/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AgendaAgendaPatch
 */
export interface AgendaAgendaPatch {
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPatch
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPatch
     */
    meetingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPatch
     */
    agendaGroup?: string;
    /**
     * 
     * @type {Array<AgendaSectionAgendaPatch>}
     * @memberof AgendaAgendaPatch
     */
    sections?: Array<AgendaSectionAgendaPatch>;
}
/**
 * 
 * @export
 * @interface AgendaAgendaPost
 */
export interface AgendaAgendaPost {
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPost
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPost
     */
    meetingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaPost
     */
    agendaGroup?: string;
}
/**
 * 
 * @export
 * @interface AgendaAgendaRead
 */
export interface AgendaAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaRead
     */
    meetingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {AgendaGroupAgendaRead}
     * @memberof AgendaAgendaRead
     */
    agendaGroup?: AgendaGroupAgendaRead;
    /**
     * 
     * @type {Array<AgendaSectionAgendaRead>}
     * @memberof AgendaAgendaRead
     */
    sections?: Array<AgendaSectionAgendaRead>;
    /**
     * 
     * @type {Array<UserAgendaRead>}
     * @memberof AgendaAgendaRead
     */
    previewToUsers?: Array<UserAgendaRead>;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaRead
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaAgendaRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgendaAgendaRead
     */
    generationDate?: string | null;
    /**
     * 
     * @type {Array<AgendaReleasesAgendaRead>}
     * @memberof AgendaAgendaRead
     */
    agendaReleases?: Array<AgendaReleasesAgendaRead>;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaAgendaRead
     */
    isPreview?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgendaAgendaWritePreview
 */
export interface AgendaAgendaWritePreview {
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaAgendaWritePreview
     */
    previewToUsers?: Array<string>;
}
/**
 * 
 * @export
 * @interface AgendaGroupAgendaGroupRead
 */
export interface AgendaGroupAgendaGroupRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaGroupRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaGroupRead
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<UserAgendaGroupRead>}
     * @memberof AgendaGroupAgendaGroupRead
     */
    secretary?: Array<UserAgendaGroupRead>;
    /**
     * 
     * @type {Array<UserAgendaGroupRead>}
     * @memberof AgendaGroupAgendaGroupRead
     */
    users?: Array<UserAgendaGroupRead>;
    /**
     * 
     * @type {AgendaTypeAgendaGroupRead}
     * @memberof AgendaGroupAgendaGroupRead
     */
    agendaType?: AgendaTypeAgendaGroupRead;
}
/**
 * 
 * @export
 * @interface AgendaGroupAgendaGroupWrite
 */
export interface AgendaGroupAgendaGroupWrite {
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaGroupWrite
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaGroupAgendaGroupWrite
     */
    secretary?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaGroupAgendaGroupWrite
     */
    users?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaGroupWrite
     */
    agendaType?: string;
}
/**
 * 
 * @export
 * @interface AgendaGroupAgendaRead
 */
export interface AgendaGroupAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupAgendaRead
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<UserAgendaRead>}
     * @memberof AgendaGroupAgendaRead
     */
    secretary?: Array<UserAgendaRead>;
    /**
     * 
     * @type {Array<UserAgendaRead>}
     * @memberof AgendaGroupAgendaRead
     */
    users?: Array<UserAgendaRead>;
    /**
     * 
     * @type {AgendaTypeAgendaRead}
     * @memberof AgendaGroupAgendaRead
     */
    agendaType?: AgendaTypeAgendaRead;
}
/**
 * 
 * @export
 * @interface AgendaGroupJsonldAgendaGroupRead
 */
export interface AgendaGroupJsonldAgendaGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<UserJsonldAgendaGroupRead>}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    secretary?: Array<UserJsonldAgendaGroupRead>;
    /**
     * 
     * @type {Array<UserJsonldAgendaGroupRead>}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    users?: Array<UserJsonldAgendaGroupRead>;
    /**
     * 
     * @type {AgendaTypeJsonldAgendaGroupRead}
     * @memberof AgendaGroupJsonldAgendaGroupRead
     */
    agendaType?: AgendaTypeJsonldAgendaGroupRead;
}
/**
 * 
 * @export
 * @interface AgendaGroupJsonldAgendaGroupWrite
 */
export interface AgendaGroupJsonldAgendaGroupWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    secretary?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    users?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaGroupWrite
     */
    agendaType?: string;
}
/**
 * 
 * @export
 * @interface AgendaGroupJsonldAgendaRead
 */
export interface AgendaGroupJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    documentFolderName?: string | null;
    /**
     * 
     * @type {Array<UserJsonldAgendaRead>}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    secretary?: Array<UserJsonldAgendaRead>;
    /**
     * 
     * @type {Array<UserJsonldAgendaRead>}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    users?: Array<UserJsonldAgendaRead>;
    /**
     * 
     * @type {AgendaTypeJsonldAgendaRead}
     * @memberof AgendaGroupJsonldAgendaRead
     */
    agendaType?: AgendaTypeJsonldAgendaRead;
}
/**
 * Note: That an agenda item can only have either a document or a media item, not both.
 * @export
 * @interface AgendaItemAgendaPatch
 */
export interface AgendaItemAgendaPatch {
    /**
     * 
     * @type {string}
     * @memberof AgendaItemAgendaPatch
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaItemAgendaPatch
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaItemAgendaPatch
     */
    held?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemAgendaPatch
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemAgendaPatch
     */
    attachment?: string | null;
    /**
     * 
     * @type {Array<AgendaItemAgendaPatch>}
     * @memberof AgendaItemAgendaPatch
     */
    agendaItems?: Array<AgendaItemAgendaPatch>;
}
/**
 * Note: That an agenda item can only have either a document or a media item, not both.
 * @export
 * @interface AgendaItemAgendaRead
 */
export interface AgendaItemAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaItemAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaItemAgendaRead
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaItemAgendaRead
     */
    held?: boolean;
    /**
     * 
     * @type {DocumentAgendaRead}
     * @memberof AgendaItemAgendaRead
     */
    document?: DocumentAgendaRead | null;
    /**
     * 
     * @type {MediaAgendaRead}
     * @memberof AgendaItemAgendaRead
     */
    attachment?: MediaAgendaRead | null;
    /**
     * 
     * @type {Array<AgendaItemAgendaRead>}
     * @memberof AgendaItemAgendaRead
     */
    agendaItems?: Array<AgendaItemAgendaRead>;
}
/**
 * Note: That an agenda item can only have either a document or a media item, not both.
 * @export
 * @interface AgendaItemJsonldAgendaItemRead
 */
export interface AgendaItemJsonldAgendaItemRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaItemJsonldAgendaItemRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaItemRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaItemRead
     */
    type?: string;
}
/**
 * Note: That an agenda item can only have either a document or a media item, not both.
 * @export
 * @interface AgendaItemJsonldAgendaItemWrite
 */
export interface AgendaItemJsonldAgendaItemWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaItemJsonldAgendaItemWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaItemWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaItemWrite
     */
    type?: string;
}
/**
 * Note: That an agenda item can only have either a document or a media item, not both.
 * @export
 * @interface AgendaItemJsonldAgendaRead
 */
export interface AgendaItemJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaItemJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaItemJsonldAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaItemJsonldAgendaRead
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaItemJsonldAgendaRead
     */
    held?: boolean;
    /**
     * 
     * @type {DocumentJsonldAgendaRead}
     * @memberof AgendaItemJsonldAgendaRead
     */
    document?: DocumentJsonldAgendaRead | null;
    /**
     * 
     * @type {MediaJsonldAgendaRead}
     * @memberof AgendaItemJsonldAgendaRead
     */
    attachment?: MediaJsonldAgendaRead | null;
    /**
     * 
     * @type {Array<AgendaItemJsonldAgendaRead>}
     * @memberof AgendaItemJsonldAgendaRead
     */
    agendaItems?: Array<AgendaItemJsonldAgendaRead>;
}
/**
 * 
 * @export
 * @interface AgendaJsonld
 */
export interface AgendaJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonld
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface AgendaJsonldAgendaPost
 */
export interface AgendaJsonldAgendaPost {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaJsonldAgendaPost
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaPost
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaPost
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaPost
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaPost
     */
    meetingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaPost
     */
    agendaGroup?: string;
}
/**
 * 
 * @export
 * @interface AgendaJsonldAgendaRead
 */
export interface AgendaJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    meetingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {AgendaGroupJsonldAgendaRead}
     * @memberof AgendaJsonldAgendaRead
     */
    agendaGroup?: AgendaGroupJsonldAgendaRead;
    /**
     * 
     * @type {Array<AgendaSectionJsonldAgendaRead>}
     * @memberof AgendaJsonldAgendaRead
     */
    sections?: Array<AgendaSectionJsonldAgendaRead>;
    /**
     * 
     * @type {Array<UserJsonldAgendaRead>}
     * @memberof AgendaJsonldAgendaRead
     */
    previewToUsers?: Array<UserJsonldAgendaRead>;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaJsonldAgendaRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaRead
     */
    generationDate?: string | null;
    /**
     * 
     * @type {Array<AgendaReleasesJsonldAgendaRead>}
     * @memberof AgendaJsonldAgendaRead
     */
    agendaReleases?: Array<AgendaReleasesJsonldAgendaRead>;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaJsonldAgendaRead
     */
    isPreview?: boolean | null;
}
/**
 * 
 * @export
 * @interface AgendaJsonldAgendaWritePreview
 */
export interface AgendaJsonldAgendaWritePreview {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaJsonldAgendaWritePreview
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaWritePreview
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaJsonldAgendaWritePreview
     */
    type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgendaJsonldAgendaWritePreview
     */
    previewToUsers?: Array<string>;
}
/**
 * 
 * @export
 * @interface AgendaReleasesAgendaRead
 */
export interface AgendaReleasesAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesAgendaRead
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesAgendaRead
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface AgendaReleasesJsonldAgendaRead
 */
export interface AgendaReleasesJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaReleasesJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesJsonldAgendaRead
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaReleasesJsonldAgendaRead
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface AgendaSectionAgendaPatch
 */
export interface AgendaSectionAgendaPatch {
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionAgendaPatch
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaSectionAgendaPatch
     */
    position: number;
    /**
     * 
     * @type {Array<AgendaItemAgendaPatch>}
     * @memberof AgendaSectionAgendaPatch
     */
    agendaItems?: Array<AgendaItemAgendaPatch>;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaSectionAgendaPatch
     */
    held?: boolean;
}
/**
 * 
 * @export
 * @interface AgendaSectionAgendaRead
 */
export interface AgendaSectionAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaSectionAgendaRead
     */
    position: number;
    /**
     * 
     * @type {Array<AgendaItemAgendaRead>}
     * @memberof AgendaSectionAgendaRead
     */
    agendaItems?: Array<AgendaItemAgendaRead>;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaSectionAgendaRead
     */
    held?: boolean;
}
/**
 * 
 * @export
 * @interface AgendaSectionJsonldAgendaRead
 */
export interface AgendaSectionJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    position: number;
    /**
     * 
     * @type {Array<AgendaItemJsonldAgendaRead>}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    agendaItems?: Array<AgendaItemJsonldAgendaRead>;
    /**
     * 
     * @type {boolean}
     * @memberof AgendaSectionJsonldAgendaRead
     */
    held?: boolean;
}
/**
 * 
 * @export
 * @interface AgendaSectionJsonldAgendaSectionRead
 */
export interface AgendaSectionJsonldAgendaSectionRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaSectionJsonldAgendaSectionRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaSectionRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaSectionRead
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface AgendaSectionJsonldAgendaSectionWrite
 */
export interface AgendaSectionJsonldAgendaSectionWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaSectionJsonldAgendaSectionWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaSectionWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaSectionJsonldAgendaSectionWrite
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface AgendaTypeAgendaGroupRead
 */
export interface AgendaTypeAgendaGroupRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaGroupRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaGroupRead
     */
    packageType?: AgendaTypeAgendaGroupReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeAgendaGroupReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeAgendaRead
 */
export interface AgendaTypeAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaRead
     */
    packageType?: AgendaTypeAgendaReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeAgendaReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeAgendaTypeRead
 */
export interface AgendaTypeAgendaTypeRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaTypeRead
     */
    title?: string;
    /**
     * 
     * @type {Array<AgendaTypeSectionAgendaTypeRead>}
     * @memberof AgendaTypeAgendaTypeRead
     */
    agendaTypeSections?: Array<AgendaTypeSectionAgendaTypeRead>;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaTypeRead
     */
    packageType?: AgendaTypeAgendaTypeReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeAgendaTypeReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeAgendaTypeWrite
 */
export interface AgendaTypeAgendaTypeWrite {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaTypeWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<AgendaTypeSectionAgendaTypeWrite>}
     * @memberof AgendaTypeAgendaTypeWrite
     */
    agendaTypeSections?: Array<AgendaTypeSectionAgendaTypeWrite>;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeAgendaTypeWrite
     */
    packageType?: AgendaTypeAgendaTypeWritePackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeAgendaTypeWritePackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeJsonldAgendaGroupRead
 */
export interface AgendaTypeJsonldAgendaGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeJsonldAgendaGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaGroupRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaGroupRead
     */
    packageType?: AgendaTypeJsonldAgendaGroupReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeJsonldAgendaGroupReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeJsonldAgendaRead
 */
export interface AgendaTypeJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaRead
     */
    packageType?: AgendaTypeJsonldAgendaReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeJsonldAgendaReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeJsonldAgendaTypeRead
 */
export interface AgendaTypeJsonldAgendaTypeRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    title?: string;
    /**
     * 
     * @type {Array<AgendaTypeSectionJsonldAgendaTypeRead>}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    agendaTypeSections?: Array<AgendaTypeSectionJsonldAgendaTypeRead>;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeRead
     */
    packageType?: AgendaTypeJsonldAgendaTypeReadPackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeJsonldAgendaTypeReadPackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeJsonldAgendaTypeWrite
 */
export interface AgendaTypeJsonldAgendaTypeWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<AgendaTypeSectionJsonldAgendaTypeWrite>}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    agendaTypeSections?: Array<AgendaTypeSectionJsonldAgendaTypeWrite>;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeJsonldAgendaTypeWrite
     */
    packageType?: AgendaTypeJsonldAgendaTypeWritePackageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgendaTypeJsonldAgendaTypeWritePackageTypeEnum {
    Agenda = 'agenda',
    DocumentBundle = 'document-bundle'
}

/**
 * 
 * @export
 * @interface AgendaTypeSectionAgendaTypeRead
 */
export interface AgendaTypeSectionAgendaTypeRead {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionAgendaTypeRead
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaTypeSectionAgendaTypeRead
     */
    position?: number;
    /**
     * 
     * @type {AgendaTypeAgendaTypeRead}
     * @memberof AgendaTypeSectionAgendaTypeRead
     */
    agendaType?: AgendaTypeAgendaTypeRead;
}
/**
 * 
 * @export
 * @interface AgendaTypeSectionAgendaTypeWrite
 */
export interface AgendaTypeSectionAgendaTypeWrite {
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionAgendaTypeWrite
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaTypeSectionAgendaTypeWrite
     */
    position?: number;
    /**
     * 
     * @type {AgendaTypeAgendaTypeWrite}
     * @memberof AgendaTypeSectionAgendaTypeWrite
     */
    agendaType?: AgendaTypeAgendaTypeWrite;
}
/**
 * 
 * @export
 * @interface AgendaTypeSectionJsonldAgendaTypeRead
 */
export interface AgendaTypeSectionJsonldAgendaTypeRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    position?: number;
    /**
     * 
     * @type {AgendaTypeJsonldAgendaTypeRead}
     * @memberof AgendaTypeSectionJsonldAgendaTypeRead
     */
    agendaType?: AgendaTypeJsonldAgendaTypeRead;
}
/**
 * 
 * @export
 * @interface AgendaTypeSectionJsonldAgendaTypeSectionRead
 */
export interface AgendaTypeSectionJsonldAgendaTypeSectionRead {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionRead
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface AgendaTypeSectionJsonldAgendaTypeSectionWrite
 */
export interface AgendaTypeSectionJsonldAgendaTypeSectionWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeSectionWrite
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface AgendaTypeSectionJsonldAgendaTypeWrite
 */
export interface AgendaTypeSectionJsonldAgendaTypeWrite {
    /**
     * 
     * @type {string | any}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    position?: number;
    /**
     * 
     * @type {AgendaTypeJsonldAgendaTypeWrite}
     * @memberof AgendaTypeSectionJsonldAgendaTypeWrite
     */
    agendaType?: AgendaTypeJsonldAgendaTypeWrite;
}
/**
 * 
 * @export
 * @interface BookmarkBookmarkRead
 */
export interface BookmarkBookmarkRead {
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkRead
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkRead
     */
    user?: string;
}
/**
 * 
 * @export
 * @interface BookmarkBookmarkWrite
 */
export interface BookmarkBookmarkWrite {
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkWrite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkBookmarkWrite
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface BookmarkJsonldBookmarkRead
 */
export interface BookmarkJsonldBookmarkRead {
    /**
     * 
     * @type {string | any}
     * @memberof BookmarkJsonldBookmarkRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkRead
     */
    user?: string;
}
/**
 * 
 * @export
 * @interface BookmarkJsonldBookmarkWrite
 */
export interface BookmarkJsonldBookmarkWrite {
    /**
     * 
     * @type {string | any}
     * @memberof BookmarkJsonldBookmarkWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkWrite
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkJsonldBookmarkWrite
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface CommentCommentRead
 */
export interface CommentCommentRead {
    /**
     * 
     * @type {string}
     * @memberof CommentCommentRead
     */
    content?: string;
    /**
     * 
     * @type {UserCommentRead}
     * @memberof CommentCommentRead
     */
    user?: UserCommentRead;
    /**
     * 
     * @type {string}
     * @memberof CommentCommentRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCommentRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentCommentRead
     */
    seen?: boolean;
    /**
     * 
     * @type {Array<CommentCommentRead>}
     * @memberof CommentCommentRead
     */
    replies?: Array<CommentCommentRead>;
    /**
     * 
     * @type {boolean}
     * @memberof CommentCommentRead
     */
    resolved?: boolean;
}
/**
 * 
 * @export
 * @interface CommentCommentReply
 */
export interface CommentCommentReply {
    /**
     * 
     * @type {string}
     * @memberof CommentCommentReply
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface CommentCommentWrite
 */
export interface CommentCommentWrite {
    /**
     * 
     * @type {string}
     * @memberof CommentCommentWrite
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCommentWrite
     */
    document?: string;
}
/**
 * 
 * @export
 * @interface CommentDocumentComments
 */
export interface CommentDocumentComments {
    /**
     * 
     * @type {string}
     * @memberof CommentDocumentComments
     */
    content?: string;
    /**
     * 
     * @type {UserDocumentComments}
     * @memberof CommentDocumentComments
     */
    user?: UserDocumentComments;
    /**
     * 
     * @type {string}
     * @memberof CommentDocumentComments
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDocumentComments
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentDocumentComments
     */
    seen?: boolean;
    /**
     * 
     * @type {Array<CommentDocumentComments>}
     * @memberof CommentDocumentComments
     */
    replies?: Array<CommentDocumentComments>;
    /**
     * 
     * @type {boolean}
     * @memberof CommentDocumentComments
     */
    resolved?: boolean;
}
/**
 * 
 * @export
 * @interface CommentJsonld
 */
export interface CommentJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof CommentJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonld
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface CommentJsonldCommentRead
 */
export interface CommentJsonldCommentRead {
    /**
     * 
     * @type {string | any}
     * @memberof CommentJsonldCommentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentRead
     */
    content?: string;
    /**
     * 
     * @type {UserJsonldCommentRead}
     * @memberof CommentJsonldCommentRead
     */
    user?: UserJsonldCommentRead;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentJsonldCommentRead
     */
    seen?: boolean;
    /**
     * 
     * @type {Array<CommentJsonldCommentRead>}
     * @memberof CommentJsonldCommentRead
     */
    replies?: Array<CommentJsonldCommentRead>;
    /**
     * 
     * @type {boolean}
     * @memberof CommentJsonldCommentRead
     */
    resolved?: boolean;
}
/**
 * 
 * @export
 * @interface CommentJsonldCommentReply
 */
export interface CommentJsonldCommentReply {
    /**
     * 
     * @type {string | any}
     * @memberof CommentJsonldCommentReply
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentReply
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentReply
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentReply
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface CommentJsonldCommentWrite
 */
export interface CommentJsonldCommentWrite {
    /**
     * 
     * @type {string | any}
     * @memberof CommentJsonldCommentWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentWrite
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldCommentWrite
     */
    document?: string;
}
/**
 * 
 * @export
 * @interface CommentJsonldDocumentComments
 */
export interface CommentJsonldDocumentComments {
    /**
     * 
     * @type {string | any}
     * @memberof CommentJsonldDocumentComments
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldDocumentComments
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldDocumentComments
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldDocumentComments
     */
    content?: string;
    /**
     * 
     * @type {UserJsonldDocumentComments}
     * @memberof CommentJsonldDocumentComments
     */
    user?: UserJsonldDocumentComments;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldDocumentComments
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentJsonldDocumentComments
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentJsonldDocumentComments
     */
    seen?: boolean;
    /**
     * 
     * @type {Array<CommentJsonldDocumentComments>}
     * @memberof CommentJsonldDocumentComments
     */
    replies?: Array<CommentJsonldDocumentComments>;
    /**
     * 
     * @type {boolean}
     * @memberof CommentJsonldDocumentComments
     */
    resolved?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentAgendaRead
 */
export interface DocumentAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof DocumentAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAgendaRead
     */
    number?: number;
    /**
     * 
     * @type {Array<DocumentAttachmentAgendaRead>}
     * @memberof DocumentAgendaRead
     */
    documentAttachments?: Array<DocumentAttachmentAgendaRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentAgendaRead
     */
    documentClass?: string;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentAgendaRead
 */
export interface DocumentAttachmentAgendaRead {
    /**
     * 
     * @type {MediaAgendaRead}
     * @memberof DocumentAttachmentAgendaRead
     */
    attachment?: MediaAgendaRead;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentAgendaRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentDocumentAttachmentRead
 */
export interface DocumentAttachmentDocumentAttachmentRead {
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentDocumentAttachmentRead
     */
    document?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentDocumentAttachmentRead
     */
    attachment?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentDocumentAttachmentRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentDocumentAttachmentWrite
 */
export interface DocumentAttachmentDocumentAttachmentWrite {
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentDocumentAttachmentWrite
     */
    document?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentDocumentAttachmentWrite
     */
    attachment?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentDocumentAttachmentWrite
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentDocumentPatch
 */
export interface DocumentAttachmentDocumentPatch {
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentDocumentPatch
     */
    attachment?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentDocumentPatch
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentDocumentRead
 */
export interface DocumentAttachmentDocumentRead {
    /**
     * 
     * @type {MediaDocumentRead}
     * @memberof DocumentAttachmentDocumentRead
     */
    attachment?: MediaDocumentRead;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentDocumentRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentJsonldAgendaRead
 */
export interface DocumentAttachmentJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentAttachmentJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {MediaJsonldAgendaRead}
     * @memberof DocumentAttachmentJsonldAgendaRead
     */
    attachment?: MediaJsonldAgendaRead;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentJsonldAgendaRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentJsonldDocumentAttachmentRead
 */
export interface DocumentAttachmentJsonldDocumentAttachmentRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    document?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    attachment?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentJsonldDocumentAttachmentWrite
 */
export interface DocumentAttachmentJsonldDocumentAttachmentWrite {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    document?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    attachment?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentJsonldDocumentAttachmentWrite
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentAttachmentJsonldDocumentRead
 */
export interface DocumentAttachmentJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentAttachmentJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAttachmentJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {MediaJsonldDocumentRead}
     * @memberof DocumentAttachmentJsonldDocumentRead
     */
    attachment?: MediaJsonldDocumentRead;
    /**
     * 
     * @type {number}
     * @memberof DocumentAttachmentJsonldDocumentRead
     */
    position?: number;
}
/**
 * 
 * @export
 * @interface DocumentDocumentComments
 */
export interface DocumentDocumentComments {
    /**
     * 
     * @type {Array<CommentDocumentComments>}
     * @memberof DocumentDocumentComments
     */
    comments?: Array<CommentDocumentComments>;
}
/**
 * 
 * @export
 * @interface DocumentDocumentPatch
 */
export interface DocumentDocumentPatch {
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentPatch
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentPatch
     */
    dueDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentPatch
     */
    templateListItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentPatch
     */
    documentManager?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDocumentPatch
     */
    jointUserGroups?: Array<string>;
    /**
     * 
     * @type {WorkflowDocumentPatch}
     * @memberof DocumentDocumentPatch
     */
    approval?: WorkflowDocumentPatch | null;
    /**
     * 
     * @type {WorkflowDocumentPatch}
     * @memberof DocumentDocumentPatch
     */
    collaboration?: WorkflowDocumentPatch | null;
    /**
     * 
     * @type {Array<DocumentSharedUserDocumentPatch>}
     * @memberof DocumentDocumentPatch
     */
    documentSharedUsers?: Array<DocumentSharedUserDocumentPatch>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentPatch
     */
    customEmailNotificationContent?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDocumentPatch
     */
    trackingLists?: Array<string>;
    /**
     * 
     * @type {Array<DocumentAttachmentDocumentPatch>}
     * @memberof DocumentDocumentPatch
     */
    documentAttachments?: Array<DocumentAttachmentDocumentPatch>;
}
/**
 * 
 * @export
 * @interface DocumentDocumentRead
 */
export interface DocumentDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    title: string;
    /**
     * 
     * @type {UserDocumentRead}
     * @memberof DocumentDocumentRead
     */
    documentOwner?: UserDocumentRead | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    dueDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentRead
     */
    templateListItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    draftUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    status?: string;
    /**
     * 
     * @type {UserDocumentRead}
     * @memberof DocumentDocumentRead
     */
    documentManager?: UserDocumentRead | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentRead
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserGroupDocumentRead}
     * @memberof DocumentDocumentRead
     */
    leadUserGroup: UserGroupDocumentRead;
    /**
     * 
     * @type {Array<UserGroupDocumentRead>}
     * @memberof DocumentDocumentRead
     */
    jointUserGroups?: Array<UserGroupDocumentRead>;
    /**
     * 
     * @type {WorkflowDocumentRead}
     * @memberof DocumentDocumentRead
     */
    approval?: WorkflowDocumentRead | null;
    /**
     * 
     * @type {WorkflowDocumentRead}
     * @memberof DocumentDocumentRead
     */
    collaboration?: WorkflowDocumentRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDocumentRead
     */
    requiresMyInput?: boolean | null;
    /**
     * 
     * @type {Array<DocumentSharedUserDocumentRead>}
     * @memberof DocumentDocumentRead
     */
    documentSharedUsers?: Array<DocumentSharedUserDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    customEmailNotificationContent?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDocumentRead
     */
    trackingLists?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    spDraftDocumentId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    spOfficialDocumentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    officialUrl?: string | null;
    /**
     * 
     * @type {Array<DocumentAttachmentDocumentRead>}
     * @memberof DocumentDocumentRead
     */
    documentAttachments?: Array<DocumentAttachmentDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    documentClass?: string;
    /**
     * 
     * @type {Array<DocumentDocumentRead>}
     * @memberof DocumentDocumentRead
     */
    agendaDecision?: Array<DocumentDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    driveItemId?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentRead
     */
    commentCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    currentSpId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentRead
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDocumentReadAgendaDecision
 */
export interface DocumentDocumentReadAgendaDecision {
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {Array<UserGroupDocumentReadAgendaDecision>}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    jointUserGroups?: Array<UserGroupDocumentReadAgendaDecision>;
    /**
     * 
     * @type {Array<DocumentSharedUserDocumentReadAgendaDecision>}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    documentSharedUsers?: Array<DocumentSharedUserDocumentReadAgendaDecision>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    documentClass?: string;
    /**
     * 
     * @type {Array<DocumentDocumentReadAgendaDecision>}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    agendaDecision?: Array<DocumentDocumentReadAgendaDecision>;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    currentSpId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentReadAgendaDecision
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDocumentReadGetShare
 */
export interface DocumentDocumentReadGetShare {
    /**
     * This property is used to indicate to the frontend in specific situations (like in the addin) that they need to direct the user to a different document, because they are viewing out of date or draft version.
     * @type {string}
     * @memberof DocumentDocumentReadGetShare
     */
    redirectUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDocumentWrite
 */
export interface DocumentDocumentWrite {
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentWrite
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentWrite
     */
    dueDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDocumentWrite
     */
    templateListItemId: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentWrite
     */
    documentManager?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentWrite
     */
    leadUserGroup: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDocumentWrite
     */
    jointUserGroups?: Array<string>;
}
/**
 * 
 * @export
 * @interface DocumentDocumentWriteAgendaDecision
 */
export interface DocumentDocumentWriteAgendaDecision {
    /**
     * 
     * @type {string}
     * @memberof DocumentDocumentWriteAgendaDecision
     */
    title: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonld
 */
export interface DocumentJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonld
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldAgendaRead
 */
export interface DocumentJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldAgendaRead
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldAgendaRead
     */
    number?: number;
    /**
     * 
     * @type {Array<DocumentAttachmentJsonldAgendaRead>}
     * @memberof DocumentJsonldAgendaRead
     */
    documentAttachments?: Array<DocumentAttachmentJsonldAgendaRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldAgendaRead
     */
    documentClass?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentComments
 */
export interface DocumentJsonldDocumentComments {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentComments
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentComments
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentComments
     */
    type?: string;
    /**
     * 
     * @type {Array<CommentJsonldDocumentComments>}
     * @memberof DocumentJsonldDocumentComments
     */
    comments?: Array<CommentJsonldDocumentComments>;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentRead
 */
export interface DocumentJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    title: string;
    /**
     * 
     * @type {UserJsonldDocumentRead}
     * @memberof DocumentJsonldDocumentRead
     */
    documentOwner?: UserJsonldDocumentRead | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    dueDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldDocumentRead
     */
    templateListItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    draftUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    status?: string;
    /**
     * 
     * @type {UserJsonldDocumentRead}
     * @memberof DocumentJsonldDocumentRead
     */
    documentManager?: UserJsonldDocumentRead | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldDocumentRead
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserGroupJsonldDocumentRead}
     * @memberof DocumentJsonldDocumentRead
     */
    leadUserGroup: UserGroupJsonldDocumentRead;
    /**
     * 
     * @type {Array<UserGroupJsonldDocumentRead>}
     * @memberof DocumentJsonldDocumentRead
     */
    jointUserGroups?: Array<UserGroupJsonldDocumentRead>;
    /**
     * 
     * @type {WorkflowJsonldDocumentRead}
     * @memberof DocumentJsonldDocumentRead
     */
    approval?: WorkflowJsonldDocumentRead | null;
    /**
     * 
     * @type {WorkflowJsonldDocumentRead}
     * @memberof DocumentJsonldDocumentRead
     */
    collaboration?: WorkflowJsonldDocumentRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentJsonldDocumentRead
     */
    requiresMyInput?: boolean | null;
    /**
     * 
     * @type {Array<DocumentSharedUserJsonldDocumentRead>}
     * @memberof DocumentJsonldDocumentRead
     */
    documentSharedUsers?: Array<DocumentSharedUserJsonldDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    customEmailNotificationContent?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentJsonldDocumentRead
     */
    trackingLists?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    spDraftDocumentId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    spOfficialDocumentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    officialUrl?: string | null;
    /**
     * 
     * @type {Array<DocumentAttachmentJsonldDocumentRead>}
     * @memberof DocumentJsonldDocumentRead
     */
    documentAttachments?: Array<DocumentAttachmentJsonldDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    documentClass?: string;
    /**
     * 
     * @type {Array<DocumentJsonldDocumentRead>}
     * @memberof DocumentJsonldDocumentRead
     */
    agendaDecision?: Array<DocumentJsonldDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    driveItemId?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldDocumentRead
     */
    commentCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    currentSpId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentRead
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentReadAgendaDecision
 */
export interface DocumentJsonldDocumentReadAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {Array<UserGroupJsonldDocumentReadAgendaDecision>}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    jointUserGroups?: Array<UserGroupJsonldDocumentReadAgendaDecision>;
    /**
     * 
     * @type {Array<DocumentSharedUserJsonldDocumentReadAgendaDecision>}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    documentSharedUsers?: Array<DocumentSharedUserJsonldDocumentReadAgendaDecision>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    documentClass?: string;
    /**
     * 
     * @type {Array<DocumentJsonldDocumentReadAgendaDecision>}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    agendaDecision?: Array<DocumentJsonldDocumentReadAgendaDecision>;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    currentSpId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadAgendaDecision
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentReadGetShare
 */
export interface DocumentJsonldDocumentReadGetShare {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentReadGetShare
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadGetShare
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadGetShare
     */
    type?: string;
    /**
     * This property is used to indicate to the frontend in specific situations (like in the addin) that they need to direct the user to a different document, because they are viewing out of date or draft version.
     * @type {string}
     * @memberof DocumentJsonldDocumentReadGetShare
     */
    redirectUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentReadWorkflows
 */
export interface DocumentJsonldDocumentReadWorkflows {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentReadWorkflows
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadWorkflows
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentReadWorkflows
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentUpdateAr
 */
export interface DocumentJsonldDocumentUpdateAr {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentUpdateAr
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateAr
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateAr
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentUpdateIa
 */
export interface DocumentJsonldDocumentUpdateIa {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentUpdateIa
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateIa
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateIa
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentUpdateIc
 */
export interface DocumentJsonldDocumentUpdateIc {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentUpdateIc
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateIc
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateIc
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentUpdateMta
 */
export interface DocumentJsonldDocumentUpdateMta {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentUpdateMta
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateMta
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentUpdateMta
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentWrite
 */
export interface DocumentJsonldDocumentWrite {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    dueDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldDocumentWrite
     */
    templateListItemId: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    documentManager?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWrite
     */
    leadUserGroup: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentJsonldDocumentWrite
     */
    jointUserGroups?: Array<string>;
}
/**
 * 
 * @export
 * @interface DocumentJsonldDocumentWriteAgendaDecision
 */
export interface DocumentJsonldDocumentWriteAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldDocumentWriteAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWriteAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWriteAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldDocumentWriteAgendaDecision
     */
    title: string;
}
/**
 * 
 * @export
 * @interface DocumentJsonldTrackingListRead
 */
export interface DocumentJsonldTrackingListRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentJsonldTrackingListRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentJsonldTrackingListRead
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentJsonldTrackingListRead
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserDocumentPatch
 */
export interface DocumentSharedUserDocumentPatch {
    /**
     * This represents the Sharepoint access level. This can ONLY be \"read\" or \"write, which matches the Sharepoint access levels.
     * @type {string}
     * @memberof DocumentSharedUserDocumentPatch
     */
    accessLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserDocumentPatch
     */
    user?: string;
    /**
     * This property will return either true or false. If the permissionId is null, then it was not successful.
     * @type {boolean}
     * @memberof DocumentSharedUserDocumentPatch
     */
    wasSuccessful?: boolean | null;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserDocumentRead
 */
export interface DocumentSharedUserDocumentRead {
    /**
     * This represents the Sharepoint access level. This can ONLY be \"read\" or \"write, which matches the Sharepoint access levels.
     * @type {string}
     * @memberof DocumentSharedUserDocumentRead
     */
    accessLevel?: string;
    /**
     * 
     * @type {UserDocumentRead}
     * @memberof DocumentSharedUserDocumentRead
     */
    user?: UserDocumentRead;
    /**
     * This property will return either true or false. If the permissionId is null, then it was not successful.
     * @type {boolean}
     * @memberof DocumentSharedUserDocumentRead
     */
    wasSuccessful?: boolean | null;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserDocumentReadAgendaDecision
 */
export interface DocumentSharedUserDocumentReadAgendaDecision {
    /**
     * 
     * @type {UserDocumentReadAgendaDecision}
     * @memberof DocumentSharedUserDocumentReadAgendaDecision
     */
    user?: UserDocumentReadAgendaDecision;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserDocumentSharedUserRead
 */
export interface DocumentSharedUserDocumentSharedUserRead {
    /**
     * This represents the Sharepoint access level. This can ONLY be \"read\" or \"write, which matches the Sharepoint access levels.
     * @type {string}
     * @memberof DocumentSharedUserDocumentSharedUserRead
     */
    accessLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserDocumentSharedUserRead
     */
    user?: string;
    /**
     * This property will return either true or false. If the permissionId is null, then it was not successful.
     * @type {boolean}
     * @memberof DocumentSharedUserDocumentSharedUserRead
     */
    wasSuccessful?: boolean | null;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserJsonldDocumentRead
 */
export interface DocumentSharedUserJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    type?: string;
    /**
     * This represents the Sharepoint access level. This can ONLY be \"read\" or \"write, which matches the Sharepoint access levels.
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    accessLevel?: string;
    /**
     * 
     * @type {UserJsonldDocumentRead}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    user?: UserJsonldDocumentRead;
    /**
     * This property will return either true or false. If the permissionId is null, then it was not successful.
     * @type {boolean}
     * @memberof DocumentSharedUserJsonldDocumentRead
     */
    wasSuccessful?: boolean | null;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserJsonldDocumentReadAgendaDecision
 */
export interface DocumentSharedUserJsonldDocumentReadAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof DocumentSharedUserJsonldDocumentReadAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentReadAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentReadAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {UserJsonldDocumentReadAgendaDecision}
     * @memberof DocumentSharedUserJsonldDocumentReadAgendaDecision
     */
    user?: UserJsonldDocumentReadAgendaDecision;
}
/**
 * 
 * @export
 * @interface DocumentSharedUserJsonldDocumentSharedUserRead
 */
export interface DocumentSharedUserJsonldDocumentSharedUserRead {
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    context?: string | any;
    /**
     * This represents the Sharepoint access level. This can ONLY be \"read\" or \"write, which matches the Sharepoint access levels.
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    accessLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    user?: string;
    /**
     * This property will return either true or false. If the permissionId is null, then it was not successful.
     * @type {boolean}
     * @memberof DocumentSharedUserJsonldDocumentSharedUserRead
     */
    wasSuccessful?: boolean | null;
}
/**
 * 
 * @export
 * @interface DocumentTrackingListRead
 */
export interface DocumentTrackingListRead {
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentTrackingListRead
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    documentTypeTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTrackingListRead
     */
    currentSpUrl?: string | null;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {Array<AgendaGroupJsonldAgendaGroupRead>}
     * @memberof InlineResponse200
     */
    hydramember: Array<AgendaGroupJsonldAgendaGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse200
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse200
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {Array<AgendaItemJsonldAgendaItemRead>}
     * @memberof InlineResponse2001
     */
    hydramember: Array<AgendaItemJsonldAgendaItemRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2001
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2001
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {Array<DocumentJsonldDocumentRead>}
     * @memberof InlineResponse20010
     */
    hydramember: Array<DocumentJsonldDocumentRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20010
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20010
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20010
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {Array<KnowledgeBaseJsonldKnowledgeBaseRead>}
     * @memberof InlineResponse20011
     */
    hydramember: Array<KnowledgeBaseJsonldKnowledgeBaseRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20011
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20011
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20011
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * 
     * @type {Array<KpiJsonldKpiRead>}
     * @memberof InlineResponse20012
     */
    hydramember: Array<KpiJsonldKpiRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20012
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20012
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20012
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {Array<LogEventJsonldLogEventRead>}
     * @memberof InlineResponse20013
     */
    hydramember: Array<LogEventJsonldLogEventRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20013
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20013
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20013
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {Array<MSDriveJsonldDriveRead>}
     * @memberof InlineResponse20014
     */
    hydramember: Array<MSDriveJsonldDriveRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20014
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20014
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20014
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {Array<MSListJsonldListRead>}
     * @memberof InlineResponse20015
     */
    hydramember: Array<MSListJsonldListRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20015
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20015
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20015
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * 
     * @type {Array<MediaJsonldMediaObjectRead>}
     * @memberof InlineResponse20016
     */
    hydramember: Array<MediaJsonldMediaObjectRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20016
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20016
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20016
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * 
     * @type {Array<NotificationJsonldNotificationRead>}
     * @memberof InlineResponse20017
     */
    hydramember: Array<NotificationJsonldNotificationRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20017
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20017
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20017
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {Array<TemplateFileJsonldTemplateFileRead>}
     * @memberof InlineResponse20018
     */
    hydramember: Array<TemplateFileJsonldTemplateFileRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20018
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20018
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20018
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {Array<TrackingListJsonldTrackingListRead>}
     * @memberof InlineResponse20019
     */
    hydramember: Array<TrackingListJsonldTrackingListRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20019
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20019
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20019
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {Array<AgendaSectionJsonldAgendaSectionRead>}
     * @memberof InlineResponse2002
     */
    hydramember: Array<AgendaSectionJsonldAgendaSectionRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2002
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2002
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {Array<UserGroupTypeJsonldUserGroupTypeRead>}
     * @memberof InlineResponse20020
     */
    hydramember: Array<UserGroupTypeJsonldUserGroupTypeRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20020
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20020
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20020
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * 
     * @type {Array<UserGroupJsonldUserGroupRead>}
     * @memberof InlineResponse20021
     */
    hydramember: Array<UserGroupJsonldUserGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20021
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20021
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20021
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * 
     * @type {Array<UserUserGroupJsonldUserUserGroupRead>}
     * @memberof InlineResponse20022
     */
    hydramember: Array<UserUserGroupJsonldUserUserGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20022
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20022
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20022
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * 
     * @type {Array<UserJsonldUserRead>}
     * @memberof InlineResponse20023
     */
    hydramember: Array<UserJsonldUserRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20023
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20023
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20023
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
    /**
     * 
     * @type {Array<WorkflowGroupJsonldWorkflowGroupRead>}
     * @memberof InlineResponse20024
     */
    hydramember: Array<WorkflowGroupJsonldWorkflowGroupRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20024
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20024
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20024
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20025
 */
export interface InlineResponse20025 {
    /**
     * 
     * @type {Array<WorkflowTemplateJsonldWorkflowTemplateRead>}
     * @memberof InlineResponse20025
     */
    hydramember: Array<WorkflowTemplateJsonldWorkflowTemplateRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20025
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20025
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20025
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {Array<WorkflowJsonldWorkflowRead>}
     * @memberof InlineResponse20026
     */
    hydramember: Array<WorkflowJsonldWorkflowRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20026
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse20026
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse20026
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {Array<AgendaTypeSectionJsonldAgendaTypeSectionRead>}
     * @memberof InlineResponse2003
     */
    hydramember: Array<AgendaTypeSectionJsonldAgendaTypeSectionRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2003
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2003
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 
     * @type {Array<AgendaTypeJsonldAgendaTypeRead>}
     * @memberof InlineResponse2004
     */
    hydramember: Array<AgendaTypeJsonldAgendaTypeRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2004
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2004
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2004
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {Array<AgendaJsonldAgendaRead>}
     * @memberof InlineResponse2005
     */
    hydramember: Array<AgendaJsonldAgendaRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2005
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2005
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2005
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {Array<BookmarkJsonldBookmarkRead>}
     * @memberof InlineResponse2006
     */
    hydramember: Array<BookmarkJsonldBookmarkRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2006
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2006
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * 
     * @type {Array<CommentJsonldCommentRead>}
     * @memberof InlineResponse2007
     */
    hydramember: Array<CommentJsonldCommentRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2007
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2007
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2007
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * 
     * @type {Array<DocumentAttachmentJsonldDocumentAttachmentRead>}
     * @memberof InlineResponse2008
     */
    hydramember: Array<DocumentAttachmentJsonldDocumentAttachmentRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2008
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2008
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2008
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {Array<DocumentSharedUserJsonldDocumentSharedUserRead>}
     * @memberof InlineResponse2009
     */
    hydramember: Array<DocumentSharedUserJsonldDocumentSharedUserRead>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2009
     */
    hydratotalItems?: number;
    /**
     * 
     * @type {InlineResponse200HydraView}
     * @memberof InlineResponse2009
     */
    hydraview?: InlineResponse200HydraView;
    /**
     * 
     * @type {InlineResponse200HydraSearch}
     * @memberof InlineResponse2009
     */
    hydrasearch?: InlineResponse200HydraSearch;
}
/**
 * 
 * @export
 * @interface InlineResponse200HydraSearch
 */
export interface InlineResponse200HydraSearch {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearch
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearch
     */
    hydratemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearch
     */
    hydravariableRepresentation?: string;
    /**
     * 
     * @type {Array<InlineResponse200HydraSearchHydraMapping>}
     * @memberof InlineResponse200HydraSearch
     */
    hydramapping?: Array<InlineResponse200HydraSearchHydraMapping>;
}
/**
 * 
 * @export
 * @interface InlineResponse200HydraSearchHydraMapping
 */
export interface InlineResponse200HydraSearchHydraMapping {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearchHydraMapping
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearchHydraMapping
     */
    variable?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraSearchHydraMapping
     */
    property?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse200HydraSearchHydraMapping
     */
    required?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse200HydraView
 */
export interface InlineResponse200HydraView {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    hydrafirst?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    hydralast?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    hydraprevious?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200HydraView
     */
    hydranext?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseJsonldKnowledgeBaseRead
 */
export interface KnowledgeBaseJsonldKnowledgeBaseRead {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    answer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    relatedResource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseJsonldKnowledgeBaseRead
     */
    relatedResourceTitle?: string | null;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseKnowledgeBaseRead
 */
export interface KnowledgeBaseKnowledgeBaseRead {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseKnowledgeBaseRead
     */
    answer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseKnowledgeBaseRead
     */
    relatedResource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseKnowledgeBaseRead
     */
    relatedResourceTitle?: string | null;
}
/**
 * 
 * @export
 * @interface KpiJsonldKpiRead
 */
export interface KpiJsonldKpiRead {
    /**
     * 
     * @type {string}
     * @memberof KpiJsonldKpiRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiJsonldKpiRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof KpiJsonldKpiRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KpiJsonldKpiRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiJsonldKpiRead
     */
    ministry?: string | null;
    /**
     * 
     * @type {Array<KpiPerformanceJsonldKpiRead>}
     * @memberof KpiJsonldKpiRead
     */
    performanceMetrics?: Array<KpiPerformanceJsonldKpiRead>;
    /**
     * 
     * @type {KpiTableJsonldKpiRead}
     * @memberof KpiJsonldKpiRead
     */
    documentStatusMetrics?: KpiTableJsonldKpiRead | null;
    /**
     * 
     * @type {string}
     * @memberof KpiJsonldKpiRead
     */
    dateCreated?: string;
}
/**
 * 
 * @export
 * @interface KpiKpiRead
 */
export interface KpiKpiRead {
    /**
     * 
     * @type {string}
     * @memberof KpiKpiRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiKpiRead
     */
    ministry?: string | null;
    /**
     * 
     * @type {Array<KpiPerformanceKpiRead>}
     * @memberof KpiKpiRead
     */
    performanceMetrics?: Array<KpiPerformanceKpiRead>;
    /**
     * 
     * @type {KpiTableKpiRead}
     * @memberof KpiKpiRead
     */
    documentStatusMetrics?: KpiTableKpiRead | null;
    /**
     * 
     * @type {string}
     * @memberof KpiKpiRead
     */
    dateCreated?: string;
}
/**
 * 
 * @export
 * @interface KpiPerformanceJsonldKpiRead
 */
export interface KpiPerformanceJsonldKpiRead {
    /**
     * 
     * @type {string | any}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceJsonldKpiRead
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface KpiPerformanceKpiRead
 */
export interface KpiPerformanceKpiRead {
    /**
     * 
     * @type {number}
     * @memberof KpiPerformanceKpiRead
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceKpiRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiPerformanceKpiRead
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface KpiTableHeaderJsonldKpiRead
 */
export interface KpiTableHeaderJsonldKpiRead {
    /**
     * 
     * @type {string | any}
     * @memberof KpiTableHeaderJsonldKpiRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderJsonldKpiRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderJsonldKpiRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderJsonldKpiRead
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderJsonldKpiRead
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface KpiTableHeaderKpiRead
 */
export interface KpiTableHeaderKpiRead {
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderKpiRead
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableHeaderKpiRead
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface KpiTableJsonldKpiRead
 */
export interface KpiTableJsonldKpiRead {
    /**
     * 
     * @type {string | any}
     * @memberof KpiTableJsonldKpiRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KpiTableJsonldKpiRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableJsonldKpiRead
     */
    type?: string;
    /**
     * 
     * @type {Array<KpiTableHeaderJsonldKpiRead>}
     * @memberof KpiTableJsonldKpiRead
     */
    headers?: Array<KpiTableHeaderJsonldKpiRead>;
    /**
     * 
     * @type {Array<KpiTableRowJsonldKpiRead>}
     * @memberof KpiTableJsonldKpiRead
     */
    tableRows?: Array<KpiTableRowJsonldKpiRead>;
}
/**
 * 
 * @export
 * @interface KpiTableKpiRead
 */
export interface KpiTableKpiRead {
    /**
     * 
     * @type {Array<KpiTableHeaderKpiRead>}
     * @memberof KpiTableKpiRead
     */
    headers?: Array<KpiTableHeaderKpiRead>;
    /**
     * 
     * @type {Array<KpiTableRowKpiRead>}
     * @memberof KpiTableKpiRead
     */
    tableRows?: Array<KpiTableRowKpiRead>;
}
/**
 * 
 * @export
 * @interface KpiTableRowJsonldKpiRead
 */
export interface KpiTableRowJsonldKpiRead {
    /**
     * 
     * @type {string | any}
     * @memberof KpiTableRowJsonldKpiRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowJsonldKpiRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowJsonldKpiRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowJsonldKpiRead
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof KpiTableRowJsonldKpiRead
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowJsonldKpiRead
     */
    oldest?: string | null;
}
/**
 * 
 * @export
 * @interface KpiTableRowKpiRead
 */
export interface KpiTableRowKpiRead {
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowKpiRead
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof KpiTableRowKpiRead
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof KpiTableRowKpiRead
     */
    oldest?: string | null;
}
/**
 * 
 * @export
 * @interface LogEventJsonldLogEventRead
 */
export interface LogEventJsonldLogEventRead {
    /**
     * 
     * @type {string | any}
     * @memberof LogEventJsonldLogEventRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    level?: LogEventJsonldLogEventReadLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    subject: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    source?: LogEventJsonldLogEventReadSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    user?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventRead
     */
    time?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LogEventJsonldLogEventReadLevelEnum {
    Emergency = 'Emergency',
    Alert = 'Alert',
    Critical = 'Critical',
    Error = 'Error',
    Warning = 'Warning',
    Notice = 'Notice',
    Informational = 'Informational',
    Debug = 'Debug'
}
/**
    * @export
    * @enum {string}
    */
export enum LogEventJsonldLogEventReadSourceEnum {
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface LogEventJsonldLogEventWrite
 */
export interface LogEventJsonldLogEventWrite {
    /**
     * 
     * @type {string | any}
     * @memberof LogEventJsonldLogEventWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventWrite
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventWrite
     */
    level?: LogEventJsonldLogEventWriteLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventJsonldLogEventWrite
     */
    subject: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum LogEventJsonldLogEventWriteLevelEnum {
    Emergency = 'Emergency',
    Alert = 'Alert',
    Critical = 'Critical',
    Error = 'Error',
    Warning = 'Warning',
    Notice = 'Notice',
    Informational = 'Informational',
    Debug = 'Debug'
}

/**
 * 
 * @export
 * @interface LogEventLogEventRead
 */
export interface LogEventLogEventRead {
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    level?: LogEventLogEventReadLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    subject: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    source?: LogEventLogEventReadSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    user?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventRead
     */
    time?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LogEventLogEventReadLevelEnum {
    Emergency = 'Emergency',
    Alert = 'Alert',
    Critical = 'Critical',
    Error = 'Error',
    Warning = 'Warning',
    Notice = 'Notice',
    Informational = 'Informational',
    Debug = 'Debug'
}
/**
    * @export
    * @enum {string}
    */
export enum LogEventLogEventReadSourceEnum {
    User = 'USER',
    System = 'SYSTEM'
}

/**
 * 
 * @export
 * @interface LogEventLogEventWrite
 */
export interface LogEventLogEventWrite {
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventWrite
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventWrite
     */
    level?: LogEventLogEventWriteLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LogEventLogEventWrite
     */
    subject: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum LogEventLogEventWriteLevelEnum {
    Emergency = 'Emergency',
    Alert = 'Alert',
    Critical = 'Critical',
    Error = 'Error',
    Warning = 'Warning',
    Notice = 'Notice',
    Informational = 'Informational',
    Debug = 'Debug'
}

/**
 * 
 * @export
 * @interface MSDriveDriveRead
 */
export interface MSDriveDriveRead {
    /**
     * 
     * @type {string}
     * @memberof MSDriveDriveRead
     */
    driveId?: string;
    /**
     * 
     * @type {string}
     * @memberof MSDriveDriveRead
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MSDriveDriveRead
     */
    webPath?: string;
}
/**
 * 
 * @export
 * @interface MSDriveJsonldDriveRead
 */
export interface MSDriveJsonldDriveRead {
    /**
     * 
     * @type {string}
     * @memberof MSDriveJsonldDriveRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MSDriveJsonldDriveRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof MSDriveJsonldDriveRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MSDriveJsonldDriveRead
     */
    driveId?: string;
    /**
     * 
     * @type {string}
     * @memberof MSDriveJsonldDriveRead
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MSDriveJsonldDriveRead
     */
    webPath?: string;
}
/**
 * Class MSList.
 * @export
 * @interface MSListJsonldListRead
 */
export interface MSListJsonldListRead {
    /**
     * 
     * @type {string}
     * @memberof MSListJsonldListRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MSListJsonldListRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof MSListJsonldListRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MSListJsonldListRead
     */
    listId?: string;
    /**
     * 
     * @type {string}
     * @memberof MSListJsonldListRead
     */
    title?: string | null;
}
/**
 * Class MSList.
 * @export
 * @interface MSListListRead
 */
export interface MSListListRead {
    /**
     * 
     * @type {string}
     * @memberof MSListListRead
     */
    listId?: string;
    /**
     * 
     * @type {string}
     * @memberof MSListListRead
     */
    title?: string | null;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaAgendaRead
 */
export interface MediaAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof MediaAgendaRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaAgendaRead
     */
    mimeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaAgendaRead
     */
    extension?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaDocumentRead
 */
export interface MediaDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof MediaDocumentRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaDocumentRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaDocumentRead
     */
    mimeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaDocumentRead
     */
    extension?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaJsonld
 */
export interface MediaJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof MediaJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonld
     */
    type?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaJsonldAgendaRead
 */
export interface MediaJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof MediaJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    mimeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldAgendaRead
     */
    extension?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaJsonldDocumentRead
 */
export interface MediaJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof MediaJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    mimeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldDocumentRead
     */
    extension?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaJsonldMediaObjectRead
 */
export interface MediaJsonldMediaObjectRead {
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldMediaObjectRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldMediaObjectRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof MediaJsonldMediaObjectRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldMediaObjectRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaJsonldMediaObjectRead
     */
    title?: string;
}
/**
 * NOTE: The OpenApi Post context is handled in the post definition bellow. The media_object_create group does NOT handle deserialization, this group is only for validation.
 * @export
 * @interface MediaMediaObjectRead
 */
export interface MediaMediaObjectRead {
    /**
     * 
     * @type {string}
     * @memberof MediaMediaObjectRead
     */
    dateUploaded?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaMediaObjectRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface NotificationJsonld
 */
export interface NotificationJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof NotificationJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonld
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface NotificationJsonldNotificationRead
 */
export interface NotificationJsonldNotificationRead {
    /**
     * 
     * @type {string | any}
     * @memberof NotificationJsonldNotificationRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    subCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationJsonldNotificationRead
     */
    content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationJsonldNotificationRead
     */
    seen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationJsonldNotificationRead
     */
    cleared?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NotificationJsonldNotificationRead
     */
    actionMetaData?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface NotificationNotificationRead
 */
export interface NotificationNotificationRead {
    /**
     * 
     * @type {string}
     * @memberof NotificationNotificationRead
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNotificationRead
     */
    subCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNotificationRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNotificationRead
     */
    content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationNotificationRead
     */
    seen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationNotificationRead
     */
    cleared?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NotificationNotificationRead
     */
    actionMetaData?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface NotificationSeenStatus
 */
export interface NotificationSeenStatus {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSeenStatus
     */
    hasUnread?: boolean;
}
/**
 * 
 * @export
 * @interface TemplateFileJsonldTemplateFileRead
 */
export interface TemplateFileJsonldTemplateFileRead {
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    driveItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    listItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileJsonldTemplateFileRead
     */
    documentClass?: string | null;
}
/**
 * 
 * @export
 * @interface TemplateFileTemplateFileRead
 */
export interface TemplateFileTemplateFileRead {
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    driveItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    listItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TemplateFileTemplateFileRead
     */
    documentClass?: string | null;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    token?: string;
}
/**
 * 
 * @export
 * @interface TrackingListJsonldTrackingListRead
 */
export interface TrackingListJsonldTrackingListRead {
    /**
     * 
     * @type {string | any}
     * @memberof TrackingListJsonldTrackingListRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListRead
     */
    title?: string;
    /**
     * 
     * @type {Array<DocumentJsonldTrackingListRead>}
     * @memberof TrackingListJsonldTrackingListRead
     */
    documents?: Array<DocumentJsonldTrackingListRead>;
}
/**
 * 
 * @export
 * @interface TrackingListJsonldTrackingListWrite
 */
export interface TrackingListJsonldTrackingListWrite {
    /**
     * 
     * @type {string | any}
     * @memberof TrackingListJsonldTrackingListWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingListJsonldTrackingListWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackingListJsonldTrackingListWrite
     */
    documents?: Array<string>;
}
/**
 * 
 * @export
 * @interface TrackingListTrackingListRead
 */
export interface TrackingListTrackingListRead {
    /**
     * 
     * @type {string}
     * @memberof TrackingListTrackingListRead
     */
    title?: string;
    /**
     * 
     * @type {Array<DocumentTrackingListRead>}
     * @memberof TrackingListTrackingListRead
     */
    documents?: Array<DocumentTrackingListRead>;
}
/**
 * 
 * @export
 * @interface TrackingListTrackingListWrite
 */
export interface TrackingListTrackingListWrite {
    /**
     * 
     * @type {string}
     * @memberof TrackingListTrackingListWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackingListTrackingListWrite
     */
    documents?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserAgendaGroupRead
 */
export interface UserAgendaGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserAgendaGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAgendaGroupRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupAgendaGroupRead>}
     * @memberof UserAgendaGroupRead
     */
    userUserGroup?: Array<UserUserGroupAgendaGroupRead>;
}
/**
 * 
 * @export
 * @interface UserAgendaRead
 */
export interface UserAgendaRead {
    /**
     * 
     * @type {string}
     * @memberof UserAgendaRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAgendaRead
     */
    surName?: string | null;
}
/**
 * 
 * @export
 * @interface UserCommentRead
 */
export interface UserCommentRead {
    /**
     * 
     * @type {string}
     * @memberof UserCommentRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCommentRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupCommentRead>}
     * @memberof UserCommentRead
     */
    userUserGroup?: Array<UserUserGroupCommentRead>;
}
/**
 * 
 * @export
 * @interface UserDocumentComments
 */
export interface UserDocumentComments {
    /**
     * 
     * @type {string}
     * @memberof UserDocumentComments
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDocumentComments
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupDocumentComments>}
     * @memberof UserDocumentComments
     */
    userUserGroup?: Array<UserUserGroupDocumentComments>;
}
/**
 * 
 * @export
 * @interface UserDocumentRead
 */
export interface UserDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof UserDocumentRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDocumentRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupDocumentRead>}
     * @memberof UserDocumentRead
     */
    userUserGroup?: Array<UserUserGroupDocumentRead>;
}
/**
 * 
 * @export
 * @interface UserDocumentReadAgendaDecision
 */
export interface UserDocumentReadAgendaDecision {
    /**
     * 
     * @type {string}
     * @memberof UserDocumentReadAgendaDecision
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDocumentReadAgendaDecision
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupDocumentReadAgendaDecision>}
     * @memberof UserDocumentReadAgendaDecision
     */
    userUserGroup?: Array<UserUserGroupDocumentReadAgendaDecision>;
}
/**
 * 
 * @export
 * @interface UserGroupAgendaGroupRead
 */
export interface UserGroupAgendaGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAgendaGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAgendaGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupAgendaGroupRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupCommentRead
 */
export interface UserGroupCommentRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupCommentRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupCommentRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupCommentRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupDocumentComments
 */
export interface UserGroupDocumentComments {
    /**
     * 
     * @type {string}
     * @memberof UserGroupDocumentComments
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDocumentComments
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDocumentComments
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupDocumentRead
 */
export interface UserGroupDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupDocumentRead
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDocumentRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupDocumentReadAgendaDecision
 */
export interface UserGroupDocumentReadAgendaDecision {
    /**
     * 
     * @type {string}
     * @memberof UserGroupDocumentReadAgendaDecision
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDocumentReadAgendaDecision
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDocumentReadAgendaDecision
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldAgendaGroupRead
 */
export interface UserGroupJsonldAgendaGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldAgendaGroupRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldCommentRead
 */
export interface UserGroupJsonldCommentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldCommentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldCommentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldCommentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldCommentRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldCommentRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldCommentRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldDocumentComments
 */
export interface UserGroupJsonldDocumentComments {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldDocumentComments
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentComments
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentComments
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentComments
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentComments
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldDocumentComments
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldDocumentRead
 */
export interface UserGroupJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentRead
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldDocumentRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldDocumentReadAgendaDecision
 */
export interface UserGroupJsonldDocumentReadAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldDocumentReadAgendaDecision
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldUserGroupRead
 */
export interface UserGroupJsonldUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldUserGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserGroupTypeJsonldUserGroupRead}
     * @memberof UserGroupJsonldUserGroupRead
     */
    userGroupType?: UserGroupTypeJsonldUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldUserGroupReadDetailUserGroupRead
 */
export interface UserGroupJsonldUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldUserGroupReadDetailUserGroupRead>}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    userUserGroup?: Array<UserUserGroupJsonldUserGroupReadDetailUserGroupRead>;
    /**
     * 
     * @type {UserGroupTypeJsonldUserGroupReadDetailUserGroupRead}
     * @memberof UserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    userGroupType?: UserGroupTypeJsonldUserGroupReadDetailUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldUserGroupWrite
 */
export interface UserGroupJsonldUserGroupWrite {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserGroupWrite
     */
    userGroupType?: string;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldUserRead
 */
export interface UserGroupJsonldUserRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldUserRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldUserRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldUserRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldWorkflowGroupRead
 */
export interface UserGroupJsonldWorkflowGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {UserGroupTypeJsonldWorkflowGroupRead}
     * @memberof UserGroupJsonldWorkflowGroupRead
     */
    userGroupType?: UserGroupTypeJsonldWorkflowGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupJsonldWorkflowTemplateRead
 */
export interface UserGroupJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupJsonldWorkflowTemplateRead
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupJsonldWorkflowTemplateRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldUserGroupRead
 */
export interface UserGroupTypeJsonldUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldUserGroupReadDetailUserGroupRead
 */
export interface UserGroupTypeJsonldUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldUserGroupReadDetailUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupReadDetailUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupReadDetailUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupReadDetailUserGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldUserGroupTypeRead
 */
export interface UserGroupTypeJsonldUserGroupTypeRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldUserGroupTypeRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldUserGroupTypeWrite
 */
export interface UserGroupTypeJsonldUserGroupTypeWrite {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldUserGroupTypeWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldUserGroupTypeWrite
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldWorkflowGroupRead
 */
export interface UserGroupTypeJsonldWorkflowGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldWorkflowGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeJsonldWorkflowTemplateRead
 */
export interface UserGroupTypeJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserGroupTypeJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeJsonldWorkflowTemplateRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeUserGroupRead
 */
export interface UserGroupTypeUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeUserGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeUserGroupReadDetailUserGroupRead
 */
export interface UserGroupTypeUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeUserGroupReadDetailUserGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeUserGroupTypeRead
 */
export interface UserGroupTypeUserGroupTypeRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeUserGroupTypeRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeUserGroupTypeWrite
 */
export interface UserGroupTypeUserGroupTypeWrite {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeUserGroupTypeWrite
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeWorkflowGroupRead
 */
export interface UserGroupTypeWorkflowGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeWorkflowGroupRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupTypeWorkflowTemplateRead
 */
export interface UserGroupTypeWorkflowTemplateRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTypeWorkflowTemplateRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserGroupUserGroupRead
 */
export interface UserGroupUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupUserGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserGroupTypeUserGroupRead}
     * @memberof UserGroupUserGroupRead
     */
    userGroupType?: UserGroupTypeUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupUserGroupReadDetailUserGroupRead
 */
export interface UserGroupUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupUserGroupReadDetailUserGroupRead>}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    userUserGroup?: Array<UserUserGroupUserGroupReadDetailUserGroupRead>;
    /**
     * 
     * @type {UserGroupTypeUserGroupReadDetailUserGroupRead}
     * @memberof UserGroupUserGroupReadDetailUserGroupRead
     */
    userGroupType?: UserGroupTypeUserGroupReadDetailUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupUserGroupWrite
 */
export interface UserGroupUserGroupWrite {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupWrite
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupWrite
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupUserGroupWrite
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserGroupWrite
     */
    userGroupType?: string;
}
/**
 * 
 * @export
 * @interface UserGroupUserRead
 */
export interface UserGroupUserRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupUserRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupWorkflowGroupRead
 */
export interface UserGroupWorkflowGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupWorkflowGroupRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupWorkflowGroupRead
     */
    acronym?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupWorkflowGroupRead
     */
    isActive?: boolean;
    /**
     * 
     * @type {UserGroupTypeWorkflowGroupRead}
     * @memberof UserGroupWorkflowGroupRead
     */
    userGroupType?: UserGroupTypeWorkflowGroupRead;
}
/**
 * 
 * @export
 * @interface UserGroupWorkflowTemplateRead
 */
export interface UserGroupWorkflowTemplateRead {
    /**
     * 
     * @type {string}
     * @memberof UserGroupWorkflowTemplateRead
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupWorkflowTemplateRead
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface UserJsonld
 */
export interface UserJsonld {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonld
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonld
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface UserJsonldAgendaGroupRead
 */
export interface UserJsonldAgendaGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldAgendaGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaGroupRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldAgendaGroupRead>}
     * @memberof UserJsonldAgendaGroupRead
     */
    userUserGroup?: Array<UserUserGroupJsonldAgendaGroupRead>;
}
/**
 * 
 * @export
 * @interface UserJsonldAgendaRead
 */
export interface UserJsonldAgendaRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldAgendaRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldAgendaRead
     */
    surName?: string | null;
}
/**
 * 
 * @export
 * @interface UserJsonldCommentRead
 */
export interface UserJsonldCommentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldCommentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldCommentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldCommentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldCommentRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldCommentRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldCommentRead>}
     * @memberof UserJsonldCommentRead
     */
    userUserGroup?: Array<UserUserGroupJsonldCommentRead>;
}
/**
 * 
 * @export
 * @interface UserJsonldDocumentComments
 */
export interface UserJsonldDocumentComments {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldDocumentComments
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentComments
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentComments
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentComments
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentComments
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldDocumentComments>}
     * @memberof UserJsonldDocumentComments
     */
    userUserGroup?: Array<UserUserGroupJsonldDocumentComments>;
}
/**
 * 
 * @export
 * @interface UserJsonldDocumentRead
 */
export interface UserJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldDocumentRead>}
     * @memberof UserJsonldDocumentRead
     */
    userUserGroup?: Array<UserUserGroupJsonldDocumentRead>;
}
/**
 * 
 * @export
 * @interface UserJsonldDocumentReadAgendaDecision
 */
export interface UserJsonldDocumentReadAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldDocumentReadAgendaDecision>}
     * @memberof UserJsonldDocumentReadAgendaDecision
     */
    userUserGroup?: Array<UserUserGroupJsonldDocumentReadAgendaDecision>;
}
/**
 * 
 * @export
 * @interface UserJsonldUserGroupReadDetailUserGroupRead
 */
export interface UserJsonldUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldUserGroupReadDetailUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserGroupReadDetailUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserGroupReadDetailUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserGroupReadDetailUserGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserGroupReadDetailUserGroupRead
     */
    surName?: string | null;
}
/**
 * 
 * @export
 * @interface UserJsonldUserInviteExternal
 */
export interface UserJsonldUserInviteExternal {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldUserInviteExternal
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserInviteExternal
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserInviteExternal
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserInviteExternal
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface UserJsonldUserRead
 */
export interface UserJsonldUserRead {
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldUserRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    email?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserJsonldUserRead
     */
    roles?: Array<string>;
    /**
     * The first time the user logs into DocShare and connect to the DocShare API.
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldUserRead>}
     * @memberof UserJsonldUserRead
     */
    userUserGroup?: Array<UserUserGroupJsonldUserRead>;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserSettingsJsonldUserRead}
     * @memberof UserJsonldUserRead
     */
    userSettings?: UserSettingsJsonldUserRead | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    upn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserJsonldUserRead
     */
    active?: boolean;
    /**
     * A visual identifier that represents this user.
     * @type {string}
     * @memberof UserJsonldUserRead
     */
    username?: string;
    /**
     * This method exposes a list of users you are able to delegate without any other info.
     * @type {{ [key: string]: string; }}
     * @memberof UserJsonldUserRead
     */
    peopleToDelegate?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UserJsonldUserSettingsRead
 */
export interface UserJsonldUserSettingsRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldUserSettingsRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserSettingsRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserSettingsRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserSettingsRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldUserSettingsRead
     */
    surName?: string | null;
    /**
     * A visual identifier that represents this user.
     * @type {string}
     * @memberof UserJsonldUserSettingsRead
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface UserJsonldWorkflowGroupRead
 */
export interface UserJsonldWorkflowGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldWorkflowGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowGroupRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldWorkflowGroupRead>}
     * @memberof UserJsonldWorkflowGroupRead
     */
    userUserGroup?: Array<UserUserGroupJsonldWorkflowGroupRead>;
}
/**
 * 
 * @export
 * @interface UserJsonldWorkflowTemplateRead
 */
export interface UserJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupJsonldWorkflowTemplateRead>}
     * @memberof UserJsonldWorkflowTemplateRead
     */
    userUserGroup?: Array<UserUserGroupJsonldWorkflowTemplateRead>;
}
/**
 * 
 * @export
 * @interface UserSettingsJsonldUserRead
 */
export interface UserSettingsJsonldUserRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserSettingsJsonldUserRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserRead
     */
    type?: string;
    /**
     * 
     * @type {UserJsonldUserRead}
     * @memberof UserSettingsJsonldUserRead
     */
    delegateUser?: UserJsonldUserRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsJsonldUserRead
     */
    isDelegateEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserRead
     */
    preferredDashboardFilter?: UserSettingsJsonldUserReadPreferredDashboardFilterEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSettingsJsonldUserReadPreferredDashboardFilterEnum {
    Current = 'current',
    Archived = 'archived',
    RequiresMyInput = 'requiresMyInput'
}

/**
 * 
 * @export
 * @interface UserSettingsJsonldUserSettingsRead
 */
export interface UserSettingsJsonldUserSettingsRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    type?: string;
    /**
     * 
     * @type {UserJsonldUserSettingsRead}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    delegateUser?: UserJsonldUserSettingsRead | null;
    /**
     * 
     * @type {UserJsonldUserSettingsRead}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    user?: UserJsonldUserSettingsRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    showAssistanceTooltips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    showSupportMessages?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    notificationPhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    phoneNotificationsEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    enabledDashboardNotifications?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    enabledEmailNotifications?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    isDelegateEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsJsonldUserSettingsRead
     */
    preferredDashboardFilter?: UserSettingsJsonldUserSettingsReadPreferredDashboardFilterEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSettingsJsonldUserSettingsReadPreferredDashboardFilterEnum {
    Current = 'current',
    Archived = 'archived',
    RequiresMyInput = 'requiresMyInput'
}

/**
 * 
 * @export
 * @interface UserSettingsUserRead
 */
export interface UserSettingsUserRead {
    /**
     * 
     * @type {UserUserRead}
     * @memberof UserSettingsUserRead
     */
    delegateUser?: UserUserRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserRead
     */
    isDelegateEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserRead
     */
    preferredDashboardFilter?: UserSettingsUserReadPreferredDashboardFilterEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSettingsUserReadPreferredDashboardFilterEnum {
    Current = 'current',
    Archived = 'archived',
    RequiresMyInput = 'requiresMyInput'
}

/**
 * 
 * @export
 * @interface UserSettingsUserSettingsRead
 */
export interface UserSettingsUserSettingsRead {
    /**
     * 
     * @type {UserUserSettingsRead}
     * @memberof UserSettingsUserSettingsRead
     */
    delegateUser?: UserUserSettingsRead | null;
    /**
     * 
     * @type {UserUserSettingsRead}
     * @memberof UserSettingsUserSettingsRead
     */
    user?: UserUserSettingsRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsRead
     */
    showAssistanceTooltips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsRead
     */
    showSupportMessages?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserSettingsRead
     */
    notificationPhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsRead
     */
    phoneNotificationsEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsUserSettingsRead
     */
    enabledDashboardNotifications?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsUserSettingsRead
     */
    enabledEmailNotifications?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsRead
     */
    isDelegateEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserSettingsRead
     */
    preferredDashboardFilter?: UserSettingsUserSettingsReadPreferredDashboardFilterEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSettingsUserSettingsReadPreferredDashboardFilterEnum {
    Current = 'current',
    Archived = 'archived',
    RequiresMyInput = 'requiresMyInput'
}

/**
 * 
 * @export
 * @interface UserSettingsUserSettingsWrite
 */
export interface UserSettingsUserSettingsWrite {
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserSettingsWrite
     */
    delegateUser?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsWrite
     */
    showAssistanceTooltips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsWrite
     */
    showSupportMessages?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserSettingsWrite
     */
    notificationPhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsWrite
     */
    phoneNotificationsEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsUserSettingsWrite
     */
    enabledDashboardNotifications?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettingsUserSettingsWrite
     */
    enabledEmailNotifications?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettingsUserSettingsWrite
     */
    isDelegateEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettingsUserSettingsWrite
     */
    preferredDashboardFilter?: UserSettingsUserSettingsWritePreferredDashboardFilterEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserSettingsUserSettingsWritePreferredDashboardFilterEnum {
    Current = 'current',
    Archived = 'archived',
    RequiresMyInput = 'requiresMyInput'
}

/**
 * 
 * @export
 * @interface UserUserGroupAgendaGroupRead
 */
export interface UserUserGroupAgendaGroupRead {
    /**
     * 
     * @type {UserGroupAgendaGroupRead}
     * @memberof UserUserGroupAgendaGroupRead
     */
    userGroup?: UserGroupAgendaGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupCommentRead
 */
export interface UserUserGroupCommentRead {
    /**
     * 
     * @type {UserGroupCommentRead}
     * @memberof UserUserGroupCommentRead
     */
    userGroup?: UserGroupCommentRead;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupCommentRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserUserGroupDocumentComments
 */
export interface UserUserGroupDocumentComments {
    /**
     * 
     * @type {UserGroupDocumentComments}
     * @memberof UserUserGroupDocumentComments
     */
    userGroup?: UserGroupDocumentComments;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupDocumentComments
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserUserGroupDocumentRead
 */
export interface UserUserGroupDocumentRead {
    /**
     * 
     * @type {UserGroupDocumentRead}
     * @memberof UserUserGroupDocumentRead
     */
    userGroup?: UserGroupDocumentRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupDocumentReadAgendaDecision
 */
export interface UserUserGroupDocumentReadAgendaDecision {
    /**
     * 
     * @type {UserGroupDocumentReadAgendaDecision}
     * @memberof UserUserGroupDocumentReadAgendaDecision
     */
    userGroup?: UserGroupDocumentReadAgendaDecision;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldAgendaGroupRead
 */
export interface UserUserGroupJsonldAgendaGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldAgendaGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldAgendaGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldAgendaGroupRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldAgendaGroupRead}
     * @memberof UserUserGroupJsonldAgendaGroupRead
     */
    userGroup?: UserGroupJsonldAgendaGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldCommentRead
 */
export interface UserUserGroupJsonldCommentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldCommentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldCommentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldCommentRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldCommentRead}
     * @memberof UserUserGroupJsonldCommentRead
     */
    userGroup?: UserGroupJsonldCommentRead;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldCommentRead
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldDocumentComments
 */
export interface UserUserGroupJsonldDocumentComments {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldDocumentComments
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentComments
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentComments
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldDocumentComments}
     * @memberof UserUserGroupJsonldDocumentComments
     */
    userGroup?: UserGroupJsonldDocumentComments;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentComments
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldDocumentRead
 */
export interface UserUserGroupJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldDocumentRead}
     * @memberof UserUserGroupJsonldDocumentRead
     */
    userGroup?: UserGroupJsonldDocumentRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldDocumentReadAgendaDecision
 */
export interface UserUserGroupJsonldDocumentReadAgendaDecision {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldDocumentReadAgendaDecision
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentReadAgendaDecision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldDocumentReadAgendaDecision
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldDocumentReadAgendaDecision}
     * @memberof UserUserGroupJsonldDocumentReadAgendaDecision
     */
    userGroup?: UserGroupJsonldDocumentReadAgendaDecision;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldUserGroupReadDetailUserGroupRead
 */
export interface UserUserGroupJsonldUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {UserJsonldUserGroupReadDetailUserGroupRead}
     * @memberof UserUserGroupJsonldUserGroupReadDetailUserGroupRead
     */
    user?: UserJsonldUserGroupReadDetailUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldUserRead
 */
export interface UserUserGroupJsonldUserRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldUserRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldUserRead}
     * @memberof UserUserGroupJsonldUserRead
     */
    userGroup?: UserGroupJsonldUserRead;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserRead
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserRead
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserRead
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserRead
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldUserUserGroupRead
 */
export interface UserUserGroupJsonldUserUserGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    userGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupRead
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldUserUserGroupWrite
 */
export interface UserUserGroupJsonldUserUserGroupWrite {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    userGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupJsonldUserUserGroupWrite
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldWorkflowGroupRead
 */
export interface UserUserGroupJsonldWorkflowGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldWorkflowGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldWorkflowGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldWorkflowGroupRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldWorkflowGroupRead}
     * @memberof UserUserGroupJsonldWorkflowGroupRead
     */
    userGroup?: UserGroupJsonldWorkflowGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupJsonldWorkflowTemplateRead
 */
export interface UserUserGroupJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof UserUserGroupJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldWorkflowTemplateRead}
     * @memberof UserUserGroupJsonldWorkflowTemplateRead
     */
    userGroup?: UserGroupJsonldWorkflowTemplateRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupReadDetailUserGroupRead
 */
export interface UserUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupReadDetailUserGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupReadDetailUserGroupRead
     */
    surName?: string | null;
}
/**
 * 
 * @export
 * @interface UserUserGroupUserGroupReadDetailUserGroupRead
 */
export interface UserUserGroupUserGroupReadDetailUserGroupRead {
    /**
     * 
     * @type {UserUserGroupReadDetailUserGroupRead}
     * @memberof UserUserGroupUserGroupReadDetailUserGroupRead
     */
    user?: UserUserGroupReadDetailUserGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupUserRead
 */
export interface UserUserGroupUserRead {
    /**
     * 
     * @type {UserGroupUserRead}
     * @memberof UserUserGroupUserRead
     */
    userGroup?: UserGroupUserRead;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserRead
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserRead
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserRead
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserRead
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupUserUserGroupPatch
 */
export interface UserUserGroupUserUserGroupPatch {
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupPatch
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupPatch
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupPatch
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupPatch
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupUserUserGroupRead
 */
export interface UserUserGroupUserUserGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupRead
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupRead
     */
    userGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupRead
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupRead
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupRead
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupRead
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupUserUserGroupWrite
 */
export interface UserUserGroupUserUserGroupWrite {
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    userGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    allDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    highRanking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserGroupUserUserGroupWrite
     */
    admin?: boolean;
}
/**
 * 
 * @export
 * @interface UserUserGroupWorkflowGroupRead
 */
export interface UserUserGroupWorkflowGroupRead {
    /**
     * 
     * @type {UserGroupWorkflowGroupRead}
     * @memberof UserUserGroupWorkflowGroupRead
     */
    userGroup?: UserGroupWorkflowGroupRead;
}
/**
 * 
 * @export
 * @interface UserUserGroupWorkflowTemplateRead
 */
export interface UserUserGroupWorkflowTemplateRead {
    /**
     * 
     * @type {UserGroupWorkflowTemplateRead}
     * @memberof UserUserGroupWorkflowTemplateRead
     */
    userGroup?: UserGroupWorkflowTemplateRead;
}
/**
 * 
 * @export
 * @interface UserUserInviteExternal
 */
export interface UserUserInviteExternal {
    /**
     * 
     * @type {string}
     * @memberof UserUserInviteExternal
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface UserUserRead
 */
export interface UserUserRead {
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    email?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUserRead
     */
    roles?: Array<string>;
    /**
     * The first time the user logs into DocShare and connect to the DocShare API.
     * @type {string}
     * @memberof UserUserRead
     */
    dateCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupUserRead>}
     * @memberof UserUserRead
     */
    userUserGroup?: Array<UserUserGroupUserRead>;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    dateUpdated?: string | null;
    /**
     * 
     * @type {UserSettingsUserRead}
     * @memberof UserUserRead
     */
    userSettings?: UserSettingsUserRead | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserRead
     */
    upn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUserRead
     */
    active?: boolean;
    /**
     * A visual identifier that represents this user.
     * @type {string}
     * @memberof UserUserRead
     */
    username?: string;
    /**
     * This method exposes a list of users you are able to delegate without any other info.
     * @type {{ [key: string]: string; }}
     * @memberof UserUserRead
     */
    peopleToDelegate?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UserUserSettingsRead
 */
export interface UserUserSettingsRead {
    /**
     * 
     * @type {string}
     * @memberof UserUserSettingsRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserSettingsRead
     */
    surName?: string | null;
    /**
     * A visual identifier that represents this user.
     * @type {string}
     * @memberof UserUserSettingsRead
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface UserUserWrite
 */
export interface UserUserWrite {
    /**
     * 
     * @type {string}
     * @memberof UserUserWrite
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserWrite
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUserWrite
     */
    surName?: string | null;
}
/**
 * 
 * @export
 * @interface UserWorkflowGroupRead
 */
export interface UserWorkflowGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserWorkflowGroupRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWorkflowGroupRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupWorkflowGroupRead>}
     * @memberof UserWorkflowGroupRead
     */
    userUserGroup?: Array<UserUserGroupWorkflowGroupRead>;
}
/**
 * 
 * @export
 * @interface UserWorkflowTemplateRead
 */
export interface UserWorkflowTemplateRead {
    /**
     * 
     * @type {string}
     * @memberof UserWorkflowTemplateRead
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWorkflowTemplateRead
     */
    surName?: string | null;
    /**
     * 
     * @type {Array<UserUserGroupWorkflowTemplateRead>}
     * @memberof UserWorkflowTemplateRead
     */
    userUserGroup?: Array<UserUserGroupWorkflowTemplateRead>;
}
/**
 * 
 * @export
 * @interface WorkflowDocumentPatch
 */
export interface WorkflowDocumentPatch {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDocumentPatch
     */
    dueDate?: string;
    /**
     * 
     * @type {Array<WorkflowStepsDocumentPatch>}
     * @memberof WorkflowDocumentPatch
     */
    workflowStepsRequired?: Array<WorkflowStepsDocumentPatch>;
    /**
     * 
     * @type {Array<WorkflowStepsDocumentPatch>}
     * @memberof WorkflowDocumentPatch
     */
    workflowStepsAdditional?: Array<WorkflowStepsDocumentPatch>;
}
/**
 * 
 * @export
 * @interface WorkflowDocumentRead
 */
export interface WorkflowDocumentRead {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDocumentRead
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDocumentRead
     */
    dateCompleted?: string | null;
    /**
     * 
     * @type {Array<WorkflowStepsDocumentRead>}
     * @memberof WorkflowDocumentRead
     */
    workflowStepsRequired?: Array<WorkflowStepsDocumentRead>;
    /**
     * 
     * @type {Array<WorkflowStepsDocumentRead>}
     * @memberof WorkflowDocumentRead
     */
    workflowStepsAdditional?: Array<WorkflowStepsDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDocumentRead
     */
    dateStarted?: string | null;
}
/**
 * 
 * @export
 * @interface WorkflowGroupJsonldWorkflowGroupRead
 */
export interface WorkflowGroupJsonldWorkflowGroupRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    title?: string;
    /**
     * 
     * @type {Array<UserJsonldWorkflowGroupRead>}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    users?: Array<UserJsonldWorkflowGroupRead>;
    /**
     * 
     * @type {UserGroupJsonldWorkflowGroupRead}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    userGroup?: UserGroupJsonldWorkflowGroupRead | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    workflowTemplateWorkflowGroups?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    workflowType?: string;
    /**
     * 
     * @type {UserGroupTypeJsonldWorkflowGroupRead}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    userGroupType?: UserGroupTypeJsonldWorkflowGroupRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupJsonldWorkflowGroupRead
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowGroupJsonldWorkflowGroupWrite
 */
export interface WorkflowGroupJsonldWorkflowGroupWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    users?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    userGroup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    workflowType?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    userGroupType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupJsonldWorkflowGroupWrite
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowGroupJsonldWorkflowTemplateRead
 */
export interface WorkflowGroupJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    title?: string;
    /**
     * 
     * @type {Array<UserJsonldWorkflowTemplateRead>}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    users?: Array<UserJsonldWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupJsonldWorkflowTemplateRead
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowGroupWorkflowGroupRead
 */
export interface WorkflowGroupWorkflowGroupRead {
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    title?: string;
    /**
     * 
     * @type {Array<UserWorkflowGroupRead>}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    users?: Array<UserWorkflowGroupRead>;
    /**
     * 
     * @type {UserGroupWorkflowGroupRead}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    userGroup?: UserGroupWorkflowGroupRead | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    workflowTemplateWorkflowGroups?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    workflowType?: string;
    /**
     * 
     * @type {UserGroupTypeWorkflowGroupRead}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    userGroupType?: UserGroupTypeWorkflowGroupRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupWorkflowGroupRead
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowGroupWorkflowGroupWrite
 */
export interface WorkflowGroupWorkflowGroupWrite {
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    users?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    userGroup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    workflowType?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    userGroupType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupWorkflowGroupWrite
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowGroupWorkflowTemplateRead
 */
export interface WorkflowGroupWorkflowTemplateRead {
    /**
     * 
     * @type {string}
     * @memberof WorkflowGroupWorkflowTemplateRead
     */
    title?: string;
    /**
     * 
     * @type {Array<UserWorkflowTemplateRead>}
     * @memberof WorkflowGroupWorkflowTemplateRead
     */
    users?: Array<UserWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowGroupWorkflowTemplateRead
     */
    critical?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowJsonldDocumentRead
 */
export interface WorkflowJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldDocumentRead
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldDocumentRead
     */
    dateCompleted?: string | null;
    /**
     * 
     * @type {Array<WorkflowStepsJsonldDocumentRead>}
     * @memberof WorkflowJsonldDocumentRead
     */
    workflowStepsRequired?: Array<WorkflowStepsJsonldDocumentRead>;
    /**
     * 
     * @type {Array<WorkflowStepsJsonldDocumentRead>}
     * @memberof WorkflowJsonldDocumentRead
     */
    workflowStepsAdditional?: Array<WorkflowStepsJsonldDocumentRead>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldDocumentRead
     */
    dateStarted?: string | null;
}
/**
 * 
 * @export
 * @interface WorkflowJsonldWorkflowRead
 */
export interface WorkflowJsonldWorkflowRead {
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldWorkflowRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowJsonldWorkflowRead
     */
    type?: string;
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowJsonldWorkflowRead
     */
    context?: string | any;
}
/**
 * 
 * @export
 * @interface WorkflowStepsDocumentPatch
 */
export interface WorkflowStepsDocumentPatch {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsDocumentPatch
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsDocumentPatch
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsDocumentPatch
     */
    position?: number | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsDocumentRead
 */
export interface WorkflowStepsDocumentRead {
    /**
     * 
     * @type {UserDocumentRead}
     * @memberof WorkflowStepsDocumentRead
     */
    user?: UserDocumentRead;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsDocumentRead
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsDocumentRead
     */
    position?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsDocumentRead
     */
    dateApproved?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsDocumentRead
     */
    hasComment?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsJsonldDocumentRead
 */
export interface WorkflowStepsJsonldDocumentRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    type?: string;
    /**
     * 
     * @type {UserJsonldDocumentRead}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    user?: UserJsonldDocumentRead;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    position?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    dateApproved?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsJsonldDocumentRead
     */
    hasComment?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsJsonldWorkflowStepsRead
 */
export interface WorkflowStepsJsonldWorkflowStepsRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    position?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    dateApproved?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsJsonldWorkflowStepsRead
     */
    hasComment?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsJsonldWorkflowStepsWrite
 */
export interface WorkflowStepsJsonldWorkflowStepsWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsJsonldWorkflowStepsWrite
     */
    position?: number | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsWorkflowStepsRead
 */
export interface WorkflowStepsWorkflowStepsRead {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsWorkflowStepsRead
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsWorkflowStepsRead
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsWorkflowStepsRead
     */
    position?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsWorkflowStepsRead
     */
    dateApproved?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsWorkflowStepsRead
     */
    hasComment?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkflowStepsWorkflowStepsWrite
 */
export interface WorkflowStepsWorkflowStepsWrite {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStepsWorkflowStepsWrite
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStepsWorkflowStepsWrite
     */
    approved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStepsWorkflowStepsWrite
     */
    position?: number | null;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateDocumentJsonldWorkflowTemplateRead
 */
export interface WorkflowTemplateDocumentJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateRead
     */
    templateSpId?: number;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateDocumentJsonldWorkflowTemplateWrite
 */
export interface WorkflowTemplateDocumentJsonldWorkflowTemplateWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateWrite
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateDocumentJsonldWorkflowTemplateWrite
     */
    templateSpId?: number;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateDocumentWorkflowTemplateRead
 */
export interface WorkflowTemplateDocumentWorkflowTemplateRead {
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateDocumentWorkflowTemplateRead
     */
    templateSpId?: number;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateDocumentWorkflowTemplateWrite
 */
export interface WorkflowTemplateDocumentWorkflowTemplateWrite {
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateDocumentWorkflowTemplateWrite
     */
    templateSpId?: number;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateJsonldWorkflowTemplateRead
 */
export interface WorkflowTemplateJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {UserGroupJsonldWorkflowTemplateRead}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    userGroup?: UserGroupJsonldWorkflowTemplateRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    workflowType?: string;
    /**
     * 
     * @type {Array<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead>}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    workflowTemplateWorkflowGroups?: Array<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead>;
    /**
     * 
     * @type {Array<WorkflowTemplateDocumentJsonldWorkflowTemplateRead>}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    workflowTemplateDocuments?: Array<WorkflowTemplateDocumentJsonldWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    isStandardList?: boolean;
    /**
     * 
     * @type {UserGroupTypeJsonldWorkflowTemplateRead}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateRead
     */
    userGroupType?: UserGroupTypeJsonldWorkflowTemplateRead | null;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateJsonldWorkflowTemplateWrite
 */
export interface WorkflowTemplateJsonldWorkflowTemplateWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    userGroup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    workflowType?: string;
    /**
     * 
     * @type {Array<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite>}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    workflowTemplateWorkflowGroups?: Array<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite>;
    /**
     * 
     * @type {Array<WorkflowTemplateDocumentJsonldWorkflowTemplateWrite>}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    workflowTemplateDocuments?: Array<WorkflowTemplateDocumentJsonldWorkflowTemplateWrite>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    isStandardList?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateJsonldWorkflowTemplateWrite
     */
    userGroupType?: string | null;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
 */
export interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    position?: number;
    /**
     * 
     * @type {WorkflowGroupJsonldWorkflowTemplateRead}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    workflowGroup?: WorkflowGroupJsonldWorkflowTemplateRead;
    /**
     * 
     * @type {Array<UserJsonldWorkflowTemplateRead>}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    workflowTemplateUserInclusion?: Array<UserJsonldWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateRead
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead
 */
export interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite
 */
export interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
 */
export interface WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite {
    /**
     * 
     * @type {string | any}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    context?: string | any;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    workflowGroup?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    workflowTemplateUserInclusion?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWrite
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupWorkflowTemplateRead
 */
export interface WorkflowTemplateWorkflowGroupWorkflowTemplateRead {
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateRead
     */
    position?: number;
    /**
     * 
     * @type {WorkflowGroupWorkflowTemplateRead}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateRead
     */
    workflowGroup?: WorkflowGroupWorkflowTemplateRead;
    /**
     * 
     * @type {Array<UserWorkflowTemplateRead>}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateRead
     */
    workflowTemplateUserInclusion?: Array<UserWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateRead
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowGroupWorkflowTemplateWrite
 */
export interface WorkflowTemplateWorkflowGroupWorkflowTemplateWrite {
    /**
     * 
     * @type {number}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateWrite
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateWrite
     */
    workflowGroup?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateWrite
     */
    workflowTemplateUserInclusion?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowGroupWorkflowTemplateWrite
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowTemplateRead
 */
export interface WorkflowTemplateWorkflowTemplateRead {
    /**
     * 
     * @type {UserGroupWorkflowTemplateRead}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    userGroup?: UserGroupWorkflowTemplateRead | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    workflowType?: string;
    /**
     * 
     * @type {Array<WorkflowTemplateWorkflowGroupWorkflowTemplateRead>}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    workflowTemplateWorkflowGroups?: Array<WorkflowTemplateWorkflowGroupWorkflowTemplateRead>;
    /**
     * 
     * @type {Array<WorkflowTemplateDocumentWorkflowTemplateRead>}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    workflowTemplateDocuments?: Array<WorkflowTemplateDocumentWorkflowTemplateRead>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    isStandardList?: boolean;
    /**
     * 
     * @type {UserGroupTypeWorkflowTemplateRead}
     * @memberof WorkflowTemplateWorkflowTemplateRead
     */
    userGroupType?: UserGroupTypeWorkflowTemplateRead | null;
}
/**
 * 
 * @export
 * @interface WorkflowTemplateWorkflowTemplateWrite
 */
export interface WorkflowTemplateWorkflowTemplateWrite {
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    userGroup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    workflowType?: string;
    /**
     * 
     * @type {Array<WorkflowTemplateWorkflowGroupWorkflowTemplateWrite>}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    workflowTemplateWorkflowGroups?: Array<WorkflowTemplateWorkflowGroupWorkflowTemplateWrite>;
    /**
     * 
     * @type {Array<WorkflowTemplateDocumentWorkflowTemplateWrite>}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    workflowTemplateDocuments?: Array<WorkflowTemplateDocumentWorkflowTemplateWrite>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    isStandardList?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowTemplateWorkflowTemplateWrite
     */
    userGroupType?: string | null;
}

/**
 * AgendaApi - axios parameter creator
 * @export
 */
export const AgendaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the Agenda resource.
         * @summary Removes the Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaItem', 'id', id)
            const localVarPath = `/api/agendas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Agenda resources.
         * @summary Retrieves the collection of Agenda resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderMeetingDate] 
         * @param {'asc' | 'desc'} [orderIsActive] 
         * @param {'asc' | 'desc'} [orderAgendaGroupAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [generationDateBefore] 
         * @param {string} [generationDateStrictlyBefore] 
         * @param {string} [generationDateAfter] 
         * @param {string} [generationDateStrictlyAfter] 
         * @param {string} [meetingDateBefore] 
         * @param {string} [meetingDateStrictlyBefore] 
         * @param {string} [meetingDateAfter] 
         * @param {string} [meetingDateStrictlyAfter] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [agendaGroupAgendaType] 
         * @param {Array<string>} [agendaGroupAgendaType2] 
         * @param {string} [agendaGroupAgendaTypePackageType] 
         * @param {Array<string>} [agendaGroupAgendaTypePackageType2] 
         * @param {Array<string>} [groups] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderMeetingDate?: 'asc' | 'desc', orderIsActive?: 'asc' | 'desc', orderAgendaGroupAgendaTypeTitle?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', generationDateBefore?: string, generationDateStrictlyBefore?: string, generationDateAfter?: string, generationDateStrictlyAfter?: string, meetingDateBefore?: string, meetingDateStrictlyBefore?: string, meetingDateAfter?: string, meetingDateStrictlyAfter?: string, status?: string, status2?: Array<string>, agendaGroupAgendaType?: string, agendaGroupAgendaType2?: Array<string>, agendaGroupAgendaTypePackageType?: string, agendaGroupAgendaTypePackageType2?: Array<string>, groups?: Array<string>, q?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agendas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['order[status]'] = orderStatus;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }

            if (orderMeetingDate !== undefined) {
                localVarQueryParameter['order[meetingDate]'] = orderMeetingDate;
            }

            if (orderIsActive !== undefined) {
                localVarQueryParameter['order[isActive]'] = orderIsActive;
            }

            if (orderAgendaGroupAgendaTypeTitle !== undefined) {
                localVarQueryParameter['order[agendaGroup.agendaType.title]'] = orderAgendaGroupAgendaTypeTitle;
            }

            if (orderDateCreated !== undefined) {
                localVarQueryParameter['order[dateCreated]'] = orderDateCreated;
            }

            if (generationDateBefore !== undefined) {
                localVarQueryParameter['generationDate[before]'] = generationDateBefore;
            }

            if (generationDateStrictlyBefore !== undefined) {
                localVarQueryParameter['generationDate[strictly_before]'] = generationDateStrictlyBefore;
            }

            if (generationDateAfter !== undefined) {
                localVarQueryParameter['generationDate[after]'] = generationDateAfter;
            }

            if (generationDateStrictlyAfter !== undefined) {
                localVarQueryParameter['generationDate[strictly_after]'] = generationDateStrictlyAfter;
            }

            if (meetingDateBefore !== undefined) {
                localVarQueryParameter['meetingDate[before]'] = meetingDateBefore;
            }

            if (meetingDateStrictlyBefore !== undefined) {
                localVarQueryParameter['meetingDate[strictly_before]'] = meetingDateStrictlyBefore;
            }

            if (meetingDateAfter !== undefined) {
                localVarQueryParameter['meetingDate[after]'] = meetingDateAfter;
            }

            if (meetingDateStrictlyAfter !== undefined) {
                localVarQueryParameter['meetingDate[strictly_after]'] = meetingDateStrictlyAfter;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (status2) {
                localVarQueryParameter['status[]'] = status2;
            }

            if (agendaGroupAgendaType !== undefined) {
                localVarQueryParameter['agendaGroup.agendaType'] = agendaGroupAgendaType;
            }

            if (agendaGroupAgendaType2) {
                localVarQueryParameter['agendaGroup.agendaType[]'] = agendaGroupAgendaType2;
            }

            if (agendaGroupAgendaTypePackageType !== undefined) {
                localVarQueryParameter['agendaGroup.agendaType.packageType'] = agendaGroupAgendaTypePackageType;
            }

            if (agendaGroupAgendaTypePackageType2) {
                localVarQueryParameter['agendaGroup.agendaType.packageType[]'] = agendaGroupAgendaTypePackageType2;
            }

            if (groups) {
                localVarQueryParameter['groups[]'] = groups;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaDownloadItemPdfAgendaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaDownloadItemPdfAgendaItem', 'id', id)
            const localVarPath = `/api/agenda/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaDownloadZipAgendaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaDownloadZipAgendaItem', 'id', id)
            const localVarPath = `/api/agenda/{id}/zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaItem', 'id', id)
            const localVarPath = `/api/agendas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaManifestAgendaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaManifestAgendaItem', 'id', id)
            const localVarPath = `/api/agenda/{id}/manifest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Agenda resource.
         * @summary Updates the Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaAgendaPatch} agendaAgendaPatch The updated Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaItem: async (id: string, agendaAgendaPatch: AgendaAgendaPatch, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaItem', 'id', id)
            // verify required parameter 'agendaAgendaPatch' is not null or undefined
            assertParamExists('patchAgendaItem', 'agendaAgendaPatch', agendaAgendaPatch)
            const localVarPath = `/api/agendas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaAgendaPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {AgendaJsonldAgendaPost} agendaJsonldAgendaPost The new Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaCollection: async (agendaJsonldAgendaPost: AgendaJsonldAgendaPost, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaJsonldAgendaPost' is not null or undefined
            assertParamExists('postAgendaCollection', 'agendaJsonldAgendaPost', agendaJsonldAgendaPost)
            const localVarPath = `/api/agendas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaJsonldAgendaPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonldAgendaWritePreview} agendaJsonldAgendaWritePreview The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPreviewAgendaItem: async (id: string, agendaJsonldAgendaWritePreview: AgendaJsonldAgendaWritePreview, forceRebuild?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postPreviewAgendaItem', 'id', id)
            // verify required parameter 'agendaJsonldAgendaWritePreview' is not null or undefined
            assertParamExists('postPreviewAgendaItem', 'agendaJsonldAgendaWritePreview', agendaJsonldAgendaWritePreview)
            const localVarPath = `/api/agenda/{id}/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (forceRebuild !== undefined) {
                localVarQueryParameter['forceRebuild'] = forceRebuild;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaJsonldAgendaWritePreview, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonld} agendaJsonld The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReleaseAgendaItem: async (id: string, agendaJsonld: AgendaJsonld, forceRebuild?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postReleaseAgendaItem', 'id', id)
            // verify required parameter 'agendaJsonld' is not null or undefined
            assertParamExists('postReleaseAgendaItem', 'agendaJsonld', agendaJsonld)
            const localVarPath = `/api/agenda/{id}/release`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (forceRebuild !== undefined) {
                localVarQueryParameter['forceRebuild'] = forceRebuild;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaApi - functional programming interface
 * @export
 */
export const AgendaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the Agenda resource.
         * @summary Removes the Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of Agenda resources.
         * @summary Retrieves the collection of Agenda resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderMeetingDate] 
         * @param {'asc' | 'desc'} [orderIsActive] 
         * @param {'asc' | 'desc'} [orderAgendaGroupAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [generationDateBefore] 
         * @param {string} [generationDateStrictlyBefore] 
         * @param {string} [generationDateAfter] 
         * @param {string} [generationDateStrictlyAfter] 
         * @param {string} [meetingDateBefore] 
         * @param {string} [meetingDateStrictlyBefore] 
         * @param {string} [meetingDateAfter] 
         * @param {string} [meetingDateStrictlyAfter] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [agendaGroupAgendaType] 
         * @param {Array<string>} [agendaGroupAgendaType2] 
         * @param {string} [agendaGroupAgendaTypePackageType] 
         * @param {Array<string>} [agendaGroupAgendaTypePackageType2] 
         * @param {Array<string>} [groups] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaCollection(page?: number, itemsPerPage?: number, pagination?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderMeetingDate?: 'asc' | 'desc', orderIsActive?: 'asc' | 'desc', orderAgendaGroupAgendaTypeTitle?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', generationDateBefore?: string, generationDateStrictlyBefore?: string, generationDateAfter?: string, generationDateStrictlyAfter?: string, meetingDateBefore?: string, meetingDateStrictlyBefore?: string, meetingDateAfter?: string, meetingDateStrictlyAfter?: string, status?: string, status2?: Array<string>, agendaGroupAgendaType?: string, agendaGroupAgendaType2?: Array<string>, agendaGroupAgendaTypePackageType?: string, agendaGroupAgendaTypePackageType2?: Array<string>, groups?: Array<string>, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaCollection(page, itemsPerPage, pagination, orderStatus, orderTitle, orderMeetingDate, orderIsActive, orderAgendaGroupAgendaTypeTitle, orderDateCreated, generationDateBefore, generationDateStrictlyBefore, generationDateAfter, generationDateStrictlyAfter, meetingDateBefore, meetingDateStrictlyBefore, meetingDateAfter, meetingDateStrictlyAfter, status, status2, agendaGroupAgendaType, agendaGroupAgendaType2, agendaGroupAgendaTypePackageType, agendaGroupAgendaTypePackageType2, groups, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaDownloadItemPdfAgendaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaDownloadItemPdfAgendaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaDownloadZipAgendaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaDownloadZipAgendaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaManifestAgendaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaManifestAgendaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the Agenda resource.
         * @summary Updates the Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaAgendaPatch} agendaAgendaPatch The updated Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaItem(id: string, agendaAgendaPatch: AgendaAgendaPatch, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaItem(id, agendaAgendaPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {AgendaJsonldAgendaPost} agendaJsonldAgendaPost The new Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaCollection(agendaJsonldAgendaPost: AgendaJsonldAgendaPost, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaCollection(agendaJsonldAgendaPost, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonldAgendaWritePreview} agendaJsonldAgendaWritePreview The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPreviewAgendaItem(id: string, agendaJsonldAgendaWritePreview: AgendaJsonldAgendaWritePreview, forceRebuild?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPreviewAgendaItem(id, agendaJsonldAgendaWritePreview, forceRebuild, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonld} agendaJsonld The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReleaseAgendaItem(id: string, agendaJsonld: AgendaJsonld, forceRebuild?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaJsonldAgendaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReleaseAgendaItem(id, agendaJsonld, forceRebuild, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaApi - factory interface
 * @export
 */
export const AgendaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaApiFp(configuration)
    return {
        /**
         * Removes the Agenda resource.
         * @summary Removes the Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Agenda resources.
         * @summary Retrieves the collection of Agenda resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderMeetingDate] 
         * @param {'asc' | 'desc'} [orderIsActive] 
         * @param {'asc' | 'desc'} [orderAgendaGroupAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [generationDateBefore] 
         * @param {string} [generationDateStrictlyBefore] 
         * @param {string} [generationDateAfter] 
         * @param {string} [generationDateStrictlyAfter] 
         * @param {string} [meetingDateBefore] 
         * @param {string} [meetingDateStrictlyBefore] 
         * @param {string} [meetingDateAfter] 
         * @param {string} [meetingDateStrictlyAfter] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [agendaGroupAgendaType] 
         * @param {Array<string>} [agendaGroupAgendaType2] 
         * @param {string} [agendaGroupAgendaTypePackageType] 
         * @param {Array<string>} [agendaGroupAgendaTypePackageType2] 
         * @param {Array<string>} [groups] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaCollection(page?: number, itemsPerPage?: number, pagination?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderMeetingDate?: 'asc' | 'desc', orderIsActive?: 'asc' | 'desc', orderAgendaGroupAgendaTypeTitle?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', generationDateBefore?: string, generationDateStrictlyBefore?: string, generationDateAfter?: string, generationDateStrictlyAfter?: string, meetingDateBefore?: string, meetingDateStrictlyBefore?: string, meetingDateAfter?: string, meetingDateStrictlyAfter?: string, status?: string, status2?: Array<string>, agendaGroupAgendaType?: string, agendaGroupAgendaType2?: Array<string>, agendaGroupAgendaTypePackageType?: string, agendaGroupAgendaTypePackageType2?: Array<string>, groups?: Array<string>, q?: string, options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.getAgendaCollection(page, itemsPerPage, pagination, orderStatus, orderTitle, orderMeetingDate, orderIsActive, orderAgendaGroupAgendaTypeTitle, orderDateCreated, generationDateBefore, generationDateStrictlyBefore, generationDateAfter, generationDateStrictlyAfter, meetingDateBefore, meetingDateStrictlyBefore, meetingDateAfter, meetingDateStrictlyAfter, status, status2, agendaGroupAgendaType, agendaGroupAgendaType2, agendaGroupAgendaTypePackageType, agendaGroupAgendaTypePackageType2, groups, q, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaDownloadItemPdfAgendaItem(id: string, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.getAgendaDownloadItemPdfAgendaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaDownloadZipAgendaItem(id: string, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.getAgendaDownloadZipAgendaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItem(id: string, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.getAgendaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Agenda resource.
         * @summary Retrieves a Agenda resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaManifestAgendaItem(id: string, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.getAgendaManifestAgendaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Agenda resource.
         * @summary Updates the Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaAgendaPatch} agendaAgendaPatch The updated Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaItem(id: string, agendaAgendaPatch: AgendaAgendaPatch, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.patchAgendaItem(id, agendaAgendaPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {AgendaJsonldAgendaPost} agendaJsonldAgendaPost The new Agenda resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaCollection(agendaJsonldAgendaPost: AgendaJsonldAgendaPost, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.postAgendaCollection(agendaJsonldAgendaPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonldAgendaWritePreview} agendaJsonldAgendaWritePreview The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPreviewAgendaItem(id: string, agendaJsonldAgendaWritePreview: AgendaJsonldAgendaWritePreview, forceRebuild?: boolean, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.postPreviewAgendaItem(id, agendaJsonldAgendaWritePreview, forceRebuild, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Agenda resource.
         * @summary Creates a Agenda resource.
         * @param {string} id Resource identifier
         * @param {AgendaJsonld} agendaJsonld The new Agenda resource
         * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReleaseAgendaItem(id: string, agendaJsonld: AgendaJsonld, forceRebuild?: boolean, options?: any): AxiosPromise<AgendaJsonldAgendaRead> {
            return localVarFp.postReleaseAgendaItem(id, agendaJsonld, forceRebuild, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaApi - object-oriented interface
 * @export
 * @class AgendaApi
 * @extends {BaseAPI}
 */
export class AgendaApi extends BaseAPI {
    /**
     * Removes the Agenda resource.
     * @summary Removes the Agenda resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public deleteAgendaItem(id: string, options?: any) {
        return AgendaApiFp(this.configuration).deleteAgendaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Agenda resources.
     * @summary Retrieves the collection of Agenda resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {'asc' | 'desc'} [orderStatus] 
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {'asc' | 'desc'} [orderMeetingDate] 
     * @param {'asc' | 'desc'} [orderIsActive] 
     * @param {'asc' | 'desc'} [orderAgendaGroupAgendaTypeTitle] 
     * @param {'asc' | 'desc'} [orderDateCreated] 
     * @param {string} [generationDateBefore] 
     * @param {string} [generationDateStrictlyBefore] 
     * @param {string} [generationDateAfter] 
     * @param {string} [generationDateStrictlyAfter] 
     * @param {string} [meetingDateBefore] 
     * @param {string} [meetingDateStrictlyBefore] 
     * @param {string} [meetingDateAfter] 
     * @param {string} [meetingDateStrictlyAfter] 
     * @param {string} [status] 
     * @param {Array<string>} [status2] 
     * @param {string} [agendaGroupAgendaType] 
     * @param {Array<string>} [agendaGroupAgendaType2] 
     * @param {string} [agendaGroupAgendaTypePackageType] 
     * @param {Array<string>} [agendaGroupAgendaTypePackageType2] 
     * @param {Array<string>} [groups] 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public getAgendaCollection(page?: number, itemsPerPage?: number, pagination?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderMeetingDate?: 'asc' | 'desc', orderIsActive?: 'asc' | 'desc', orderAgendaGroupAgendaTypeTitle?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', generationDateBefore?: string, generationDateStrictlyBefore?: string, generationDateAfter?: string, generationDateStrictlyAfter?: string, meetingDateBefore?: string, meetingDateStrictlyBefore?: string, meetingDateAfter?: string, meetingDateStrictlyAfter?: string, status?: string, status2?: Array<string>, agendaGroupAgendaType?: string, agendaGroupAgendaType2?: Array<string>, agendaGroupAgendaTypePackageType?: string, agendaGroupAgendaTypePackageType2?: Array<string>, groups?: Array<string>, q?: string, options?: any) {
        return AgendaApiFp(this.configuration).getAgendaCollection(page, itemsPerPage, pagination, orderStatus, orderTitle, orderMeetingDate, orderIsActive, orderAgendaGroupAgendaTypeTitle, orderDateCreated, generationDateBefore, generationDateStrictlyBefore, generationDateAfter, generationDateStrictlyAfter, meetingDateBefore, meetingDateStrictlyBefore, meetingDateAfter, meetingDateStrictlyAfter, status, status2, agendaGroupAgendaType, agendaGroupAgendaType2, agendaGroupAgendaTypePackageType, agendaGroupAgendaTypePackageType2, groups, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Agenda resource.
     * @summary Retrieves a Agenda resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public getAgendaDownloadItemPdfAgendaItem(id: string, options?: any) {
        return AgendaApiFp(this.configuration).getAgendaDownloadItemPdfAgendaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Agenda resource.
     * @summary Retrieves a Agenda resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public getAgendaDownloadZipAgendaItem(id: string, options?: any) {
        return AgendaApiFp(this.configuration).getAgendaDownloadZipAgendaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Agenda resource.
     * @summary Retrieves a Agenda resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public getAgendaItem(id: string, options?: any) {
        return AgendaApiFp(this.configuration).getAgendaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Agenda resource.
     * @summary Retrieves a Agenda resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public getAgendaManifestAgendaItem(id: string, options?: any) {
        return AgendaApiFp(this.configuration).getAgendaManifestAgendaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Agenda resource.
     * @summary Updates the Agenda resource.
     * @param {string} id Resource identifier
     * @param {AgendaAgendaPatch} agendaAgendaPatch The updated Agenda resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public patchAgendaItem(id: string, agendaAgendaPatch: AgendaAgendaPatch, options?: any) {
        return AgendaApiFp(this.configuration).patchAgendaItem(id, agendaAgendaPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Agenda resource.
     * @summary Creates a Agenda resource.
     * @param {AgendaJsonldAgendaPost} agendaJsonldAgendaPost The new Agenda resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public postAgendaCollection(agendaJsonldAgendaPost: AgendaJsonldAgendaPost, options?: any) {
        return AgendaApiFp(this.configuration).postAgendaCollection(agendaJsonldAgendaPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Agenda resource.
     * @summary Creates a Agenda resource.
     * @param {string} id Resource identifier
     * @param {AgendaJsonldAgendaWritePreview} agendaJsonldAgendaWritePreview The new Agenda resource
     * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public postPreviewAgendaItem(id: string, agendaJsonldAgendaWritePreview: AgendaJsonldAgendaWritePreview, forceRebuild?: boolean, options?: any) {
        return AgendaApiFp(this.configuration).postPreviewAgendaItem(id, agendaJsonldAgendaWritePreview, forceRebuild, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Agenda resource.
     * @summary Creates a Agenda resource.
     * @param {string} id Resource identifier
     * @param {AgendaJsonld} agendaJsonld The new Agenda resource
     * @param {boolean} [forceRebuild] Will force Rebuild the agenda.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaApi
     */
    public postReleaseAgendaItem(id: string, agendaJsonld: AgendaJsonld, forceRebuild?: boolean, options?: any) {
        return AgendaApiFp(this.configuration).postReleaseAgendaItem(id, agendaJsonld, forceRebuild, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgendaGroupApi - axios parameter creator
 * @export
 */
export const AgendaGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the AgendaGroup resource.
         * @summary Removes the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaGroupItem', 'id', id)
            const localVarPath = `/api/agenda_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AgendaGroup resources.
         * @summary Retrieves the collection of AgendaGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [agendaType] 
         * @param {Array<string>} [agendaType2] 
         * @param {string} [agendaTypePackageType] 
         * @param {Array<string>} [agendaTypePackageType2] 
         * @param {string} [q] 
         * @param {'asc' | 'desc'} [orderAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDocumentFolderName] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaGroupCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, agendaType?: string, agendaType2?: Array<string>, agendaTypePackageType?: string, agendaTypePackageType2?: Array<string>, q?: string, orderAgendaTypeTitle?: 'asc' | 'desc', orderDocumentFolderName?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agenda_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (agendaType !== undefined) {
                localVarQueryParameter['agendaType'] = agendaType;
            }

            if (agendaType2) {
                localVarQueryParameter['agendaType[]'] = agendaType2;
            }

            if (agendaTypePackageType !== undefined) {
                localVarQueryParameter['agendaType.packageType'] = agendaTypePackageType;
            }

            if (agendaTypePackageType2) {
                localVarQueryParameter['agendaType.packageType[]'] = agendaTypePackageType2;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (orderAgendaTypeTitle !== undefined) {
                localVarQueryParameter['order[agendaType.title]'] = orderAgendaTypeTitle;
            }

            if (orderDocumentFolderName !== undefined) {
                localVarQueryParameter['order[documentFolderName]'] = orderDocumentFolderName;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AgendaGroup resource.
         * @summary Retrieves a AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaGroupItem', 'id', id)
            const localVarPath = `/api/agenda_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AgendaGroup resource.
         * @summary Updates the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {AgendaGroupAgendaGroupWrite} agendaGroupAgendaGroupWrite The updated AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaGroupItem: async (id: string, agendaGroupAgendaGroupWrite: AgendaGroupAgendaGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaGroupItem', 'id', id)
            // verify required parameter 'agendaGroupAgendaGroupWrite' is not null or undefined
            assertParamExists('patchAgendaGroupItem', 'agendaGroupAgendaGroupWrite', agendaGroupAgendaGroupWrite)
            const localVarPath = `/api/agenda_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaGroupAgendaGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a AgendaGroup resource.
         * @summary Creates a AgendaGroup resource.
         * @param {AgendaGroupJsonldAgendaGroupWrite} agendaGroupJsonldAgendaGroupWrite The new AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaGroupCollection: async (agendaGroupJsonldAgendaGroupWrite: AgendaGroupJsonldAgendaGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaGroupJsonldAgendaGroupWrite' is not null or undefined
            assertParamExists('postAgendaGroupCollection', 'agendaGroupJsonldAgendaGroupWrite', agendaGroupJsonldAgendaGroupWrite)
            const localVarPath = `/api/agenda_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaGroupJsonldAgendaGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaGroupApi - functional programming interface
 * @export
 */
export const AgendaGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the AgendaGroup resource.
         * @summary Removes the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of AgendaGroup resources.
         * @summary Retrieves the collection of AgendaGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [agendaType] 
         * @param {Array<string>} [agendaType2] 
         * @param {string} [agendaTypePackageType] 
         * @param {Array<string>} [agendaTypePackageType2] 
         * @param {string} [q] 
         * @param {'asc' | 'desc'} [orderAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDocumentFolderName] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaGroupCollection(page?: number, itemsPerPage?: number, pagination?: boolean, agendaType?: string, agendaType2?: Array<string>, agendaTypePackageType?: string, agendaTypePackageType2?: Array<string>, q?: string, orderAgendaTypeTitle?: 'asc' | 'desc', orderDocumentFolderName?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaGroupCollection(page, itemsPerPage, pagination, agendaType, agendaType2, agendaTypePackageType, agendaTypePackageType2, q, orderAgendaTypeTitle, orderDocumentFolderName, orderTitle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a AgendaGroup resource.
         * @summary Retrieves a AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaGroupJsonldAgendaGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the AgendaGroup resource.
         * @summary Updates the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {AgendaGroupAgendaGroupWrite} agendaGroupAgendaGroupWrite The updated AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaGroupItem(id: string, agendaGroupAgendaGroupWrite: AgendaGroupAgendaGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaGroupJsonldAgendaGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaGroupItem(id, agendaGroupAgendaGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a AgendaGroup resource.
         * @summary Creates a AgendaGroup resource.
         * @param {AgendaGroupJsonldAgendaGroupWrite} agendaGroupJsonldAgendaGroupWrite The new AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite: AgendaGroupJsonldAgendaGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaGroupJsonldAgendaGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaGroupApi - factory interface
 * @export
 */
export const AgendaGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaGroupApiFp(configuration)
    return {
        /**
         * Removes the AgendaGroup resource.
         * @summary Removes the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaGroupItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AgendaGroup resources.
         * @summary Retrieves the collection of AgendaGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [agendaType] 
         * @param {Array<string>} [agendaType2] 
         * @param {string} [agendaTypePackageType] 
         * @param {Array<string>} [agendaTypePackageType2] 
         * @param {string} [q] 
         * @param {'asc' | 'desc'} [orderAgendaTypeTitle] 
         * @param {'asc' | 'desc'} [orderDocumentFolderName] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaGroupCollection(page?: number, itemsPerPage?: number, pagination?: boolean, agendaType?: string, agendaType2?: Array<string>, agendaTypePackageType?: string, agendaTypePackageType2?: Array<string>, q?: string, orderAgendaTypeTitle?: 'asc' | 'desc', orderDocumentFolderName?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.getAgendaGroupCollection(page, itemsPerPage, pagination, agendaType, agendaType2, agendaTypePackageType, agendaTypePackageType2, q, orderAgendaTypeTitle, orderDocumentFolderName, orderTitle, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AgendaGroup resource.
         * @summary Retrieves a AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaGroupItem(id: string, options?: any): AxiosPromise<AgendaGroupJsonldAgendaGroupRead> {
            return localVarFp.getAgendaGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AgendaGroup resource.
         * @summary Updates the AgendaGroup resource.
         * @param {string} id Resource identifier
         * @param {AgendaGroupAgendaGroupWrite} agendaGroupAgendaGroupWrite The updated AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaGroupItem(id: string, agendaGroupAgendaGroupWrite: AgendaGroupAgendaGroupWrite, options?: any): AxiosPromise<AgendaGroupJsonldAgendaGroupRead> {
            return localVarFp.patchAgendaGroupItem(id, agendaGroupAgendaGroupWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a AgendaGroup resource.
         * @summary Creates a AgendaGroup resource.
         * @param {AgendaGroupJsonldAgendaGroupWrite} agendaGroupJsonldAgendaGroupWrite The new AgendaGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite: AgendaGroupJsonldAgendaGroupWrite, options?: any): AxiosPromise<AgendaGroupJsonldAgendaGroupRead> {
            return localVarFp.postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaGroupApi - object-oriented interface
 * @export
 * @class AgendaGroupApi
 * @extends {BaseAPI}
 */
export class AgendaGroupApi extends BaseAPI {
    /**
     * Removes the AgendaGroup resource.
     * @summary Removes the AgendaGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaGroupApi
     */
    public deleteAgendaGroupItem(id: string, options?: any) {
        return AgendaGroupApiFp(this.configuration).deleteAgendaGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AgendaGroup resources.
     * @summary Retrieves the collection of AgendaGroup resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {string} [agendaType] 
     * @param {Array<string>} [agendaType2] 
     * @param {string} [agendaTypePackageType] 
     * @param {Array<string>} [agendaTypePackageType2] 
     * @param {string} [q] 
     * @param {'asc' | 'desc'} [orderAgendaTypeTitle] 
     * @param {'asc' | 'desc'} [orderDocumentFolderName] 
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaGroupApi
     */
    public getAgendaGroupCollection(page?: number, itemsPerPage?: number, pagination?: boolean, agendaType?: string, agendaType2?: Array<string>, agendaTypePackageType?: string, agendaTypePackageType2?: Array<string>, q?: string, orderAgendaTypeTitle?: 'asc' | 'desc', orderDocumentFolderName?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', options?: any) {
        return AgendaGroupApiFp(this.configuration).getAgendaGroupCollection(page, itemsPerPage, pagination, agendaType, agendaType2, agendaTypePackageType, agendaTypePackageType2, q, orderAgendaTypeTitle, orderDocumentFolderName, orderTitle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AgendaGroup resource.
     * @summary Retrieves a AgendaGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaGroupApi
     */
    public getAgendaGroupItem(id: string, options?: any) {
        return AgendaGroupApiFp(this.configuration).getAgendaGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AgendaGroup resource.
     * @summary Updates the AgendaGroup resource.
     * @param {string} id Resource identifier
     * @param {AgendaGroupAgendaGroupWrite} agendaGroupAgendaGroupWrite The updated AgendaGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaGroupApi
     */
    public patchAgendaGroupItem(id: string, agendaGroupAgendaGroupWrite: AgendaGroupAgendaGroupWrite, options?: any) {
        return AgendaGroupApiFp(this.configuration).patchAgendaGroupItem(id, agendaGroupAgendaGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a AgendaGroup resource.
     * @summary Creates a AgendaGroup resource.
     * @param {AgendaGroupJsonldAgendaGroupWrite} agendaGroupJsonldAgendaGroupWrite The new AgendaGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaGroupApi
     */
    public postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite: AgendaGroupJsonldAgendaGroupWrite, options?: any) {
        return AgendaGroupApiFp(this.configuration).postAgendaGroupCollection(agendaGroupJsonldAgendaGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgendaItemApi - axios parameter creator
 * @export
 */
export const AgendaItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the AgendaItem resource.
         * @summary Removes the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaItemItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaItemItem', 'id', id)
            const localVarPath = `/api/agenda_items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AgendaItem resources.
         * @summary Retrieves the collection of AgendaItem resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItemCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agenda_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AgendaItem resource.
         * @summary Retrieves a AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItemItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaItemItem', 'id', id)
            const localVarPath = `/api/agenda_items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AgendaItem resource.
         * @summary Updates the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaItemItem: async (id: string, body: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaItemItem', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchAgendaItemItem', 'body', body)
            const localVarPath = `/api/agenda_items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a AgendaItem resource.
         * @summary Creates a AgendaItem resource.
         * @param {AgendaItemJsonldAgendaItemWrite} agendaItemJsonldAgendaItemWrite The new AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaItemCollection: async (agendaItemJsonldAgendaItemWrite: AgendaItemJsonldAgendaItemWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaItemJsonldAgendaItemWrite' is not null or undefined
            assertParamExists('postAgendaItemCollection', 'agendaItemJsonldAgendaItemWrite', agendaItemJsonldAgendaItemWrite)
            const localVarPath = `/api/agenda_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaItemJsonldAgendaItemWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaItemApi - functional programming interface
 * @export
 */
export const AgendaItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaItemApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the AgendaItem resource.
         * @summary Removes the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaItemItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaItemItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of AgendaItem resources.
         * @summary Retrieves the collection of AgendaItem resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaItemCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaItemCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a AgendaItem resource.
         * @summary Retrieves a AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaItemItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaItemJsonldAgendaItemRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaItemItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the AgendaItem resource.
         * @summary Updates the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaItemItem(id: string, body: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaItemJsonldAgendaItemRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaItemItem(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a AgendaItem resource.
         * @summary Creates a AgendaItem resource.
         * @param {AgendaItemJsonldAgendaItemWrite} agendaItemJsonldAgendaItemWrite The new AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaItemCollection(agendaItemJsonldAgendaItemWrite: AgendaItemJsonldAgendaItemWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaItemJsonldAgendaItemRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaItemCollection(agendaItemJsonldAgendaItemWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaItemApi - factory interface
 * @export
 */
export const AgendaItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaItemApiFp(configuration)
    return {
        /**
         * Removes the AgendaItem resource.
         * @summary Removes the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaItemItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaItemItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AgendaItem resources.
         * @summary Retrieves the collection of AgendaItem resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItemCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.getAgendaItemCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AgendaItem resource.
         * @summary Retrieves a AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaItemItem(id: string, options?: any): AxiosPromise<AgendaItemJsonldAgendaItemRead> {
            return localVarFp.getAgendaItemItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AgendaItem resource.
         * @summary Updates the AgendaItem resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaItemItem(id: string, body: object, options?: any): AxiosPromise<AgendaItemJsonldAgendaItemRead> {
            return localVarFp.patchAgendaItemItem(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a AgendaItem resource.
         * @summary Creates a AgendaItem resource.
         * @param {AgendaItemJsonldAgendaItemWrite} agendaItemJsonldAgendaItemWrite The new AgendaItem resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaItemCollection(agendaItemJsonldAgendaItemWrite: AgendaItemJsonldAgendaItemWrite, options?: any): AxiosPromise<AgendaItemJsonldAgendaItemRead> {
            return localVarFp.postAgendaItemCollection(agendaItemJsonldAgendaItemWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaItemApi - object-oriented interface
 * @export
 * @class AgendaItemApi
 * @extends {BaseAPI}
 */
export class AgendaItemApi extends BaseAPI {
    /**
     * Removes the AgendaItem resource.
     * @summary Removes the AgendaItem resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaItemApi
     */
    public deleteAgendaItemItem(id: string, options?: any) {
        return AgendaItemApiFp(this.configuration).deleteAgendaItemItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AgendaItem resources.
     * @summary Retrieves the collection of AgendaItem resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaItemApi
     */
    public getAgendaItemCollection(page?: number, itemsPerPage?: number, options?: any) {
        return AgendaItemApiFp(this.configuration).getAgendaItemCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AgendaItem resource.
     * @summary Retrieves a AgendaItem resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaItemApi
     */
    public getAgendaItemItem(id: string, options?: any) {
        return AgendaItemApiFp(this.configuration).getAgendaItemItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AgendaItem resource.
     * @summary Updates the AgendaItem resource.
     * @param {string} id Resource identifier
     * @param {object} body The updated AgendaItem resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaItemApi
     */
    public patchAgendaItemItem(id: string, body: object, options?: any) {
        return AgendaItemApiFp(this.configuration).patchAgendaItemItem(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a AgendaItem resource.
     * @summary Creates a AgendaItem resource.
     * @param {AgendaItemJsonldAgendaItemWrite} agendaItemJsonldAgendaItemWrite The new AgendaItem resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaItemApi
     */
    public postAgendaItemCollection(agendaItemJsonldAgendaItemWrite: AgendaItemJsonldAgendaItemWrite, options?: any) {
        return AgendaItemApiFp(this.configuration).postAgendaItemCollection(agendaItemJsonldAgendaItemWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgendaSectionApi - axios parameter creator
 * @export
 */
export const AgendaSectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the AgendaSection resource.
         * @summary Removes the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaSectionItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaSectionItem', 'id', id)
            const localVarPath = `/api/agenda_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AgendaSection resources.
         * @summary Retrieves the collection of AgendaSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaSectionCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agenda_sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AgendaSection resource.
         * @summary Retrieves a AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaSectionItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaSectionItem', 'id', id)
            const localVarPath = `/api/agenda_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AgendaSection resource.
         * @summary Updates the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaSectionItem: async (id: string, body: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaSectionItem', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchAgendaSectionItem', 'body', body)
            const localVarPath = `/api/agenda_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a AgendaSection resource.
         * @summary Creates a AgendaSection resource.
         * @param {AgendaSectionJsonldAgendaSectionWrite} agendaSectionJsonldAgendaSectionWrite The new AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaSectionCollection: async (agendaSectionJsonldAgendaSectionWrite: AgendaSectionJsonldAgendaSectionWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaSectionJsonldAgendaSectionWrite' is not null or undefined
            assertParamExists('postAgendaSectionCollection', 'agendaSectionJsonldAgendaSectionWrite', agendaSectionJsonldAgendaSectionWrite)
            const localVarPath = `/api/agenda_sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaSectionJsonldAgendaSectionWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaSectionApi - functional programming interface
 * @export
 */
export const AgendaSectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaSectionApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the AgendaSection resource.
         * @summary Removes the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaSectionItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaSectionItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of AgendaSection resources.
         * @summary Retrieves the collection of AgendaSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaSectionCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaSectionCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a AgendaSection resource.
         * @summary Retrieves a AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaSectionItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaSectionJsonldAgendaSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaSectionItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the AgendaSection resource.
         * @summary Updates the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaSectionItem(id: string, body: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaSectionJsonldAgendaSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaSectionItem(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a AgendaSection resource.
         * @summary Creates a AgendaSection resource.
         * @param {AgendaSectionJsonldAgendaSectionWrite} agendaSectionJsonldAgendaSectionWrite The new AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite: AgendaSectionJsonldAgendaSectionWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaSectionJsonldAgendaSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaSectionApi - factory interface
 * @export
 */
export const AgendaSectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaSectionApiFp(configuration)
    return {
        /**
         * Removes the AgendaSection resource.
         * @summary Removes the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaSectionItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaSectionItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AgendaSection resources.
         * @summary Retrieves the collection of AgendaSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaSectionCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.getAgendaSectionCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AgendaSection resource.
         * @summary Retrieves a AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaSectionItem(id: string, options?: any): AxiosPromise<AgendaSectionJsonldAgendaSectionRead> {
            return localVarFp.getAgendaSectionItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AgendaSection resource.
         * @summary Updates the AgendaSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaSectionItem(id: string, body: object, options?: any): AxiosPromise<AgendaSectionJsonldAgendaSectionRead> {
            return localVarFp.patchAgendaSectionItem(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a AgendaSection resource.
         * @summary Creates a AgendaSection resource.
         * @param {AgendaSectionJsonldAgendaSectionWrite} agendaSectionJsonldAgendaSectionWrite The new AgendaSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite: AgendaSectionJsonldAgendaSectionWrite, options?: any): AxiosPromise<AgendaSectionJsonldAgendaSectionRead> {
            return localVarFp.postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaSectionApi - object-oriented interface
 * @export
 * @class AgendaSectionApi
 * @extends {BaseAPI}
 */
export class AgendaSectionApi extends BaseAPI {
    /**
     * Removes the AgendaSection resource.
     * @summary Removes the AgendaSection resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaSectionApi
     */
    public deleteAgendaSectionItem(id: string, options?: any) {
        return AgendaSectionApiFp(this.configuration).deleteAgendaSectionItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AgendaSection resources.
     * @summary Retrieves the collection of AgendaSection resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaSectionApi
     */
    public getAgendaSectionCollection(page?: number, itemsPerPage?: number, options?: any) {
        return AgendaSectionApiFp(this.configuration).getAgendaSectionCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AgendaSection resource.
     * @summary Retrieves a AgendaSection resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaSectionApi
     */
    public getAgendaSectionItem(id: string, options?: any) {
        return AgendaSectionApiFp(this.configuration).getAgendaSectionItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AgendaSection resource.
     * @summary Updates the AgendaSection resource.
     * @param {string} id Resource identifier
     * @param {object} body The updated AgendaSection resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaSectionApi
     */
    public patchAgendaSectionItem(id: string, body: object, options?: any) {
        return AgendaSectionApiFp(this.configuration).patchAgendaSectionItem(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a AgendaSection resource.
     * @summary Creates a AgendaSection resource.
     * @param {AgendaSectionJsonldAgendaSectionWrite} agendaSectionJsonldAgendaSectionWrite The new AgendaSection resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaSectionApi
     */
    public postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite: AgendaSectionJsonldAgendaSectionWrite, options?: any) {
        return AgendaSectionApiFp(this.configuration).postAgendaSectionCollection(agendaSectionJsonldAgendaSectionWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgendaTypeApi - axios parameter creator
 * @export
 */
export const AgendaTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the AgendaType resource.
         * @summary Removes the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaTypeItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaTypeItem', 'id', id)
            const localVarPath = `/api/agenda_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AgendaType resources.
         * @summary Retrieves the collection of AgendaType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderPackageType] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {string} [packageType] 
         * @param {Array<string>} [packageType2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeCollection: async (page?: number, itemsPerPage?: number, orderPackageType?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', q?: string, packageType?: string, packageType2?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agenda_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orderPackageType !== undefined) {
                localVarQueryParameter['order[packageType]'] = orderPackageType;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (packageType !== undefined) {
                localVarQueryParameter['packageType'] = packageType;
            }

            if (packageType2) {
                localVarQueryParameter['packageType[]'] = packageType2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AgendaType resource.
         * @summary Retrieves a AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaTypeItem', 'id', id)
            const localVarPath = `/api/agenda_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AgendaType resource.
         * @summary Updates the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {AgendaTypeAgendaTypeWrite} agendaTypeAgendaTypeWrite The updated AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaTypeItem: async (id: string, agendaTypeAgendaTypeWrite: AgendaTypeAgendaTypeWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaTypeItem', 'id', id)
            // verify required parameter 'agendaTypeAgendaTypeWrite' is not null or undefined
            assertParamExists('patchAgendaTypeItem', 'agendaTypeAgendaTypeWrite', agendaTypeAgendaTypeWrite)
            const localVarPath = `/api/agenda_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaTypeAgendaTypeWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a AgendaType resource.
         * @summary Creates a AgendaType resource.
         * @param {AgendaTypeJsonldAgendaTypeWrite} agendaTypeJsonldAgendaTypeWrite The new AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaTypeCollection: async (agendaTypeJsonldAgendaTypeWrite: AgendaTypeJsonldAgendaTypeWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaTypeJsonldAgendaTypeWrite' is not null or undefined
            assertParamExists('postAgendaTypeCollection', 'agendaTypeJsonldAgendaTypeWrite', agendaTypeJsonldAgendaTypeWrite)
            const localVarPath = `/api/agenda_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaTypeJsonldAgendaTypeWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaTypeApi - functional programming interface
 * @export
 */
export const AgendaTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the AgendaType resource.
         * @summary Removes the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaTypeItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaTypeItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of AgendaType resources.
         * @summary Retrieves the collection of AgendaType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderPackageType] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {string} [packageType] 
         * @param {Array<string>} [packageType2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaTypeCollection(page?: number, itemsPerPage?: number, orderPackageType?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', q?: string, packageType?: string, packageType2?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaTypeCollection(page, itemsPerPage, orderPackageType, orderTitle, q, packageType, packageType2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a AgendaType resource.
         * @summary Retrieves a AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaTypeItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeJsonldAgendaTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaTypeItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the AgendaType resource.
         * @summary Updates the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {AgendaTypeAgendaTypeWrite} agendaTypeAgendaTypeWrite The updated AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaTypeItem(id: string, agendaTypeAgendaTypeWrite: AgendaTypeAgendaTypeWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeJsonldAgendaTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaTypeItem(id, agendaTypeAgendaTypeWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a AgendaType resource.
         * @summary Creates a AgendaType resource.
         * @param {AgendaTypeJsonldAgendaTypeWrite} agendaTypeJsonldAgendaTypeWrite The new AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite: AgendaTypeJsonldAgendaTypeWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeJsonldAgendaTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaTypeApi - factory interface
 * @export
 */
export const AgendaTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaTypeApiFp(configuration)
    return {
        /**
         * Removes the AgendaType resource.
         * @summary Removes the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaTypeItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaTypeItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AgendaType resources.
         * @summary Retrieves the collection of AgendaType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderPackageType] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {string} [packageType] 
         * @param {Array<string>} [packageType2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeCollection(page?: number, itemsPerPage?: number, orderPackageType?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', q?: string, packageType?: string, packageType2?: Array<string>, options?: any): AxiosPromise<InlineResponse2004> {
            return localVarFp.getAgendaTypeCollection(page, itemsPerPage, orderPackageType, orderTitle, q, packageType, packageType2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AgendaType resource.
         * @summary Retrieves a AgendaType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeItem(id: string, options?: any): AxiosPromise<AgendaTypeJsonldAgendaTypeRead> {
            return localVarFp.getAgendaTypeItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AgendaType resource.
         * @summary Updates the AgendaType resource.
         * @param {string} id Resource identifier
         * @param {AgendaTypeAgendaTypeWrite} agendaTypeAgendaTypeWrite The updated AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaTypeItem(id: string, agendaTypeAgendaTypeWrite: AgendaTypeAgendaTypeWrite, options?: any): AxiosPromise<AgendaTypeJsonldAgendaTypeRead> {
            return localVarFp.patchAgendaTypeItem(id, agendaTypeAgendaTypeWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a AgendaType resource.
         * @summary Creates a AgendaType resource.
         * @param {AgendaTypeJsonldAgendaTypeWrite} agendaTypeJsonldAgendaTypeWrite The new AgendaType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite: AgendaTypeJsonldAgendaTypeWrite, options?: any): AxiosPromise<AgendaTypeJsonldAgendaTypeRead> {
            return localVarFp.postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaTypeApi - object-oriented interface
 * @export
 * @class AgendaTypeApi
 * @extends {BaseAPI}
 */
export class AgendaTypeApi extends BaseAPI {
    /**
     * Removes the AgendaType resource.
     * @summary Removes the AgendaType resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeApi
     */
    public deleteAgendaTypeItem(id: string, options?: any) {
        return AgendaTypeApiFp(this.configuration).deleteAgendaTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AgendaType resources.
     * @summary Retrieves the collection of AgendaType resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {'asc' | 'desc'} [orderPackageType] 
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {string} [q] 
     * @param {string} [packageType] 
     * @param {Array<string>} [packageType2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeApi
     */
    public getAgendaTypeCollection(page?: number, itemsPerPage?: number, orderPackageType?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', q?: string, packageType?: string, packageType2?: Array<string>, options?: any) {
        return AgendaTypeApiFp(this.configuration).getAgendaTypeCollection(page, itemsPerPage, orderPackageType, orderTitle, q, packageType, packageType2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AgendaType resource.
     * @summary Retrieves a AgendaType resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeApi
     */
    public getAgendaTypeItem(id: string, options?: any) {
        return AgendaTypeApiFp(this.configuration).getAgendaTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AgendaType resource.
     * @summary Updates the AgendaType resource.
     * @param {string} id Resource identifier
     * @param {AgendaTypeAgendaTypeWrite} agendaTypeAgendaTypeWrite The updated AgendaType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeApi
     */
    public patchAgendaTypeItem(id: string, agendaTypeAgendaTypeWrite: AgendaTypeAgendaTypeWrite, options?: any) {
        return AgendaTypeApiFp(this.configuration).patchAgendaTypeItem(id, agendaTypeAgendaTypeWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a AgendaType resource.
     * @summary Creates a AgendaType resource.
     * @param {AgendaTypeJsonldAgendaTypeWrite} agendaTypeJsonldAgendaTypeWrite The new AgendaType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeApi
     */
    public postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite: AgendaTypeJsonldAgendaTypeWrite, options?: any) {
        return AgendaTypeApiFp(this.configuration).postAgendaTypeCollection(agendaTypeJsonldAgendaTypeWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgendaTypeSectionApi - axios parameter creator
 * @export
 */
export const AgendaTypeSectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the AgendaTypeSection resource.
         * @summary Removes the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaTypeSectionItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAgendaTypeSectionItem', 'id', id)
            const localVarPath = `/api/agenda_type_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AgendaTypeSection resources.
         * @summary Retrieves the collection of AgendaTypeSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeSectionCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agenda_type_sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AgendaTypeSection resource.
         * @summary Retrieves a AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeSectionItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgendaTypeSectionItem', 'id', id)
            const localVarPath = `/api/agenda_type_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AgendaTypeSection resource.
         * @summary Updates the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaTypeSectionItem: async (id: string, body: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAgendaTypeSectionItem', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchAgendaTypeSectionItem', 'body', body)
            const localVarPath = `/api/agenda_type_sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a AgendaTypeSection resource.
         * @summary Creates a AgendaTypeSection resource.
         * @param {AgendaTypeSectionJsonldAgendaTypeSectionWrite} agendaTypeSectionJsonldAgendaTypeSectionWrite The new AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaTypeSectionCollection: async (agendaTypeSectionJsonldAgendaTypeSectionWrite: AgendaTypeSectionJsonldAgendaTypeSectionWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agendaTypeSectionJsonldAgendaTypeSectionWrite' is not null or undefined
            assertParamExists('postAgendaTypeSectionCollection', 'agendaTypeSectionJsonldAgendaTypeSectionWrite', agendaTypeSectionJsonldAgendaTypeSectionWrite)
            const localVarPath = `/api/agenda_type_sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agendaTypeSectionJsonldAgendaTypeSectionWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgendaTypeSectionApi - functional programming interface
 * @export
 */
export const AgendaTypeSectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgendaTypeSectionApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the AgendaTypeSection resource.
         * @summary Removes the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgendaTypeSectionItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgendaTypeSectionItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of AgendaTypeSection resources.
         * @summary Retrieves the collection of AgendaTypeSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaTypeSectionCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaTypeSectionCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a AgendaTypeSection resource.
         * @summary Retrieves a AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgendaTypeSectionItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgendaTypeSectionItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the AgendaTypeSection resource.
         * @summary Updates the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAgendaTypeSectionItem(id: string, body: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAgendaTypeSectionItem(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a AgendaTypeSection resource.
         * @summary Creates a AgendaTypeSection resource.
         * @param {AgendaTypeSectionJsonldAgendaTypeSectionWrite} agendaTypeSectionJsonldAgendaTypeSectionWrite The new AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite: AgendaTypeSectionJsonldAgendaTypeSectionWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgendaTypeSectionApi - factory interface
 * @export
 */
export const AgendaTypeSectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgendaTypeSectionApiFp(configuration)
    return {
        /**
         * Removes the AgendaTypeSection resource.
         * @summary Removes the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgendaTypeSectionItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAgendaTypeSectionItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AgendaTypeSection resources.
         * @summary Retrieves the collection of AgendaTypeSection resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeSectionCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.getAgendaTypeSectionCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AgendaTypeSection resource.
         * @summary Retrieves a AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgendaTypeSectionItem(id: string, options?: any): AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead> {
            return localVarFp.getAgendaTypeSectionItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AgendaTypeSection resource.
         * @summary Updates the AgendaTypeSection resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgendaTypeSectionItem(id: string, body: object, options?: any): AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead> {
            return localVarFp.patchAgendaTypeSectionItem(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a AgendaTypeSection resource.
         * @summary Creates a AgendaTypeSection resource.
         * @param {AgendaTypeSectionJsonldAgendaTypeSectionWrite} agendaTypeSectionJsonldAgendaTypeSectionWrite The new AgendaTypeSection resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite: AgendaTypeSectionJsonldAgendaTypeSectionWrite, options?: any): AxiosPromise<AgendaTypeSectionJsonldAgendaTypeSectionRead> {
            return localVarFp.postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgendaTypeSectionApi - object-oriented interface
 * @export
 * @class AgendaTypeSectionApi
 * @extends {BaseAPI}
 */
export class AgendaTypeSectionApi extends BaseAPI {
    /**
     * Removes the AgendaTypeSection resource.
     * @summary Removes the AgendaTypeSection resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeSectionApi
     */
    public deleteAgendaTypeSectionItem(id: string, options?: any) {
        return AgendaTypeSectionApiFp(this.configuration).deleteAgendaTypeSectionItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AgendaTypeSection resources.
     * @summary Retrieves the collection of AgendaTypeSection resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeSectionApi
     */
    public getAgendaTypeSectionCollection(page?: number, itemsPerPage?: number, options?: any) {
        return AgendaTypeSectionApiFp(this.configuration).getAgendaTypeSectionCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AgendaTypeSection resource.
     * @summary Retrieves a AgendaTypeSection resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeSectionApi
     */
    public getAgendaTypeSectionItem(id: string, options?: any) {
        return AgendaTypeSectionApiFp(this.configuration).getAgendaTypeSectionItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AgendaTypeSection resource.
     * @summary Updates the AgendaTypeSection resource.
     * @param {string} id Resource identifier
     * @param {object} body The updated AgendaTypeSection resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeSectionApi
     */
    public patchAgendaTypeSectionItem(id: string, body: object, options?: any) {
        return AgendaTypeSectionApiFp(this.configuration).patchAgendaTypeSectionItem(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a AgendaTypeSection resource.
     * @summary Creates a AgendaTypeSection resource.
     * @param {AgendaTypeSectionJsonldAgendaTypeSectionWrite} agendaTypeSectionJsonldAgendaTypeSectionWrite The new AgendaTypeSection resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgendaTypeSectionApi
     */
    public postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite: AgendaTypeSectionJsonldAgendaTypeSectionWrite, options?: any) {
        return AgendaTypeSectionApiFp(this.configuration).postAgendaTypeSectionCollection(agendaTypeSectionJsonldAgendaTypeSectionWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BookmarkApi - axios parameter creator
 * @export
 */
export const BookmarkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the Bookmark resource.
         * @summary Removes the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmarkItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBookmarkItem', 'id', id)
            const localVarPath = `/api/bookmarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Bookmark resources.
         * @summary Retrieves the collection of Bookmark resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Bookmark resource.
         * @summary Retrieves a Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBookmarkItem', 'id', id)
            const localVarPath = `/api/bookmarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Bookmark resource.
         * @summary Updates the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {BookmarkBookmarkWrite} bookmarkBookmarkWrite The updated Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBookmarkItem: async (id: string, bookmarkBookmarkWrite: BookmarkBookmarkWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchBookmarkItem', 'id', id)
            // verify required parameter 'bookmarkBookmarkWrite' is not null or undefined
            assertParamExists('patchBookmarkItem', 'bookmarkBookmarkWrite', bookmarkBookmarkWrite)
            const localVarPath = `/api/bookmarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookmarkBookmarkWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Bookmark resource.
         * @summary Creates a Bookmark resource.
         * @param {BookmarkJsonldBookmarkWrite} bookmarkJsonldBookmarkWrite The new Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBookmarkCollection: async (bookmarkJsonldBookmarkWrite: BookmarkJsonldBookmarkWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookmarkJsonldBookmarkWrite' is not null or undefined
            assertParamExists('postBookmarkCollection', 'bookmarkJsonldBookmarkWrite', bookmarkJsonldBookmarkWrite)
            const localVarPath = `/api/bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookmarkJsonldBookmarkWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookmarkApi - functional programming interface
 * @export
 */
export const BookmarkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookmarkApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the Bookmark resource.
         * @summary Removes the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookmarkItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookmarkItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of Bookmark resources.
         * @summary Retrieves the collection of Bookmark resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookmarkCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookmarkCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Bookmark resource.
         * @summary Retrieves a Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookmarkItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookmarkJsonldBookmarkRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookmarkItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the Bookmark resource.
         * @summary Updates the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {BookmarkBookmarkWrite} bookmarkBookmarkWrite The updated Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBookmarkItem(id: string, bookmarkBookmarkWrite: BookmarkBookmarkWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookmarkJsonldBookmarkRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBookmarkItem(id, bookmarkBookmarkWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Bookmark resource.
         * @summary Creates a Bookmark resource.
         * @param {BookmarkJsonldBookmarkWrite} bookmarkJsonldBookmarkWrite The new Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBookmarkCollection(bookmarkJsonldBookmarkWrite: BookmarkJsonldBookmarkWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookmarkJsonldBookmarkRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBookmarkCollection(bookmarkJsonldBookmarkWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookmarkApi - factory interface
 * @export
 */
export const BookmarkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookmarkApiFp(configuration)
    return {
        /**
         * Removes the Bookmark resource.
         * @summary Removes the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmarkItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBookmarkItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Bookmark resources.
         * @summary Retrieves the collection of Bookmark resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2006> {
            return localVarFp.getBookmarkCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Bookmark resource.
         * @summary Retrieves a Bookmark resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmarkItem(id: string, options?: any): AxiosPromise<BookmarkJsonldBookmarkRead> {
            return localVarFp.getBookmarkItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Bookmark resource.
         * @summary Updates the Bookmark resource.
         * @param {string} id Resource identifier
         * @param {BookmarkBookmarkWrite} bookmarkBookmarkWrite The updated Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBookmarkItem(id: string, bookmarkBookmarkWrite: BookmarkBookmarkWrite, options?: any): AxiosPromise<BookmarkJsonldBookmarkRead> {
            return localVarFp.patchBookmarkItem(id, bookmarkBookmarkWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Bookmark resource.
         * @summary Creates a Bookmark resource.
         * @param {BookmarkJsonldBookmarkWrite} bookmarkJsonldBookmarkWrite The new Bookmark resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBookmarkCollection(bookmarkJsonldBookmarkWrite: BookmarkJsonldBookmarkWrite, options?: any): AxiosPromise<BookmarkJsonldBookmarkRead> {
            return localVarFp.postBookmarkCollection(bookmarkJsonldBookmarkWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookmarkApi - object-oriented interface
 * @export
 * @class BookmarkApi
 * @extends {BaseAPI}
 */
export class BookmarkApi extends BaseAPI {
    /**
     * Removes the Bookmark resource.
     * @summary Removes the Bookmark resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    public deleteBookmarkItem(id: string, options?: any) {
        return BookmarkApiFp(this.configuration).deleteBookmarkItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Bookmark resources.
     * @summary Retrieves the collection of Bookmark resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    public getBookmarkCollection(page?: number, itemsPerPage?: number, options?: any) {
        return BookmarkApiFp(this.configuration).getBookmarkCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Bookmark resource.
     * @summary Retrieves a Bookmark resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    public getBookmarkItem(id: string, options?: any) {
        return BookmarkApiFp(this.configuration).getBookmarkItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Bookmark resource.
     * @summary Updates the Bookmark resource.
     * @param {string} id Resource identifier
     * @param {BookmarkBookmarkWrite} bookmarkBookmarkWrite The updated Bookmark resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    public patchBookmarkItem(id: string, bookmarkBookmarkWrite: BookmarkBookmarkWrite, options?: any) {
        return BookmarkApiFp(this.configuration).patchBookmarkItem(id, bookmarkBookmarkWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Bookmark resource.
     * @summary Creates a Bookmark resource.
     * @param {BookmarkJsonldBookmarkWrite} bookmarkJsonldBookmarkWrite The new Bookmark resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookmarkApi
     */
    public postBookmarkCollection(bookmarkJsonldBookmarkWrite: BookmarkJsonldBookmarkWrite, options?: any) {
        return BookmarkApiFp(this.configuration).postBookmarkCollection(bookmarkJsonldBookmarkWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommentApi - axios parameter creator
 * @export
 */
export const CommentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the Comment resource.
         * @summary Removes the Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCommentItem', 'id', id)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Comment resources.
         * @summary Retrieves the collection of Comment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [properties] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [document] 
         * @param {Array<string>} [document2] 
         * @param {boolean} [isReply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentCollection: async (page?: number, itemsPerPage?: number, properties?: Array<string>, orderDateCreated?: 'asc' | 'desc', document?: string, document2?: Array<string>, isReply?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (properties) {
                localVarQueryParameter['properties[]'] = properties;
            }

            if (orderDateCreated !== undefined) {
                localVarQueryParameter['order[dateCreated]'] = orderDateCreated;
            }

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }

            if (document2) {
                localVarQueryParameter['document[]'] = document2;
            }

            if (isReply !== undefined) {
                localVarQueryParameter['isReply'] = isReply;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Comment resource.
         * @summary Retrieves a Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommentItem', 'id', id)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Comment resource.
         * @summary Updates the Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentCommentWrite} commentCommentWrite The updated Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCommentItem: async (id: string, commentCommentWrite: CommentCommentWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchCommentItem', 'id', id)
            // verify required parameter 'commentCommentWrite' is not null or undefined
            assertParamExists('patchCommentItem', 'commentCommentWrite', commentCommentWrite)
            const localVarPath = `/api/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentCommentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {CommentJsonldCommentWrite} commentJsonldCommentWrite The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCommentCollection: async (commentJsonldCommentWrite: CommentJsonldCommentWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentJsonldCommentWrite' is not null or undefined
            assertParamExists('postCommentCollection', 'commentJsonldCommentWrite', commentJsonldCommentWrite)
            const localVarPath = `/api/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentJsonldCommentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonldCommentReply} commentJsonldCommentReply The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReplyCommentItem: async (id: string, commentJsonldCommentReply: CommentJsonldCommentReply, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postReplyCommentItem', 'id', id)
            // verify required parameter 'commentJsonldCommentReply' is not null or undefined
            assertParamExists('postReplyCommentItem', 'commentJsonldCommentReply', commentJsonldCommentReply)
            const localVarPath = `/api/comment/{id}/reply`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentJsonldCommentReply, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResolveCommentCommentItem: async (id: string, commentJsonld: CommentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postResolveCommentCommentItem', 'id', id)
            // verify required parameter 'commentJsonld' is not null or undefined
            assertParamExists('postResolveCommentCommentItem', 'commentJsonld', commentJsonld)
            const localVarPath = `/api/comment/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnresolveCommentCommentItem: async (id: string, commentJsonld: CommentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postUnresolveCommentCommentItem', 'id', id)
            // verify required parameter 'commentJsonld' is not null or undefined
            assertParamExists('postUnresolveCommentCommentItem', 'commentJsonld', commentJsonld)
            const localVarPath = `/api/comment/{id}/unresolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentApi - functional programming interface
 * @export
 */
export const CommentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the Comment resource.
         * @summary Removes the Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of Comment resources.
         * @summary Retrieves the collection of Comment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [properties] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [document] 
         * @param {Array<string>} [document2] 
         * @param {boolean} [isReply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentCollection(page?: number, itemsPerPage?: number, properties?: Array<string>, orderDateCreated?: 'asc' | 'desc', document?: string, document2?: Array<string>, isReply?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentCollection(page, itemsPerPage, properties, orderDateCreated, document, document2, isReply, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Comment resource.
         * @summary Retrieves a Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the Comment resource.
         * @summary Updates the Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentCommentWrite} commentCommentWrite The updated Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCommentItem(id: string, commentCommentWrite: CommentCommentWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCommentItem(id, commentCommentWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {CommentJsonldCommentWrite} commentJsonldCommentWrite The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCommentCollection(commentJsonldCommentWrite: CommentJsonldCommentWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCommentCollection(commentJsonldCommentWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonldCommentReply} commentJsonldCommentReply The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReplyCommentItem(id: string, commentJsonldCommentReply: CommentJsonldCommentReply, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReplyCommentItem(id, commentJsonldCommentReply, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResolveCommentCommentItem(id, commentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUnresolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentJsonldCommentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUnresolveCommentCommentItem(id, commentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommentApi - factory interface
 * @export
 */
export const CommentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentApiFp(configuration)
    return {
        /**
         * Removes the Comment resource.
         * @summary Removes the Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCommentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Comment resources.
         * @summary Retrieves the collection of Comment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [properties] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [document] 
         * @param {Array<string>} [document2] 
         * @param {boolean} [isReply] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentCollection(page?: number, itemsPerPage?: number, properties?: Array<string>, orderDateCreated?: 'asc' | 'desc', document?: string, document2?: Array<string>, isReply?: boolean, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.getCommentCollection(page, itemsPerPage, properties, orderDateCreated, document, document2, isReply, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Comment resource.
         * @summary Retrieves a Comment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentItem(id: string, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.getCommentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Comment resource.
         * @summary Updates the Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentCommentWrite} commentCommentWrite The updated Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCommentItem(id: string, commentCommentWrite: CommentCommentWrite, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.patchCommentItem(id, commentCommentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {CommentJsonldCommentWrite} commentJsonldCommentWrite The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCommentCollection(commentJsonldCommentWrite: CommentJsonldCommentWrite, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.postCommentCollection(commentJsonldCommentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonldCommentReply} commentJsonldCommentReply The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReplyCommentItem(id: string, commentJsonldCommentReply: CommentJsonldCommentReply, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.postReplyCommentItem(id, commentJsonldCommentReply, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.postResolveCommentCommentItem(id, commentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Comment resource.
         * @summary Creates a Comment resource.
         * @param {string} id Resource identifier
         * @param {CommentJsonld} commentJsonld The new Comment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUnresolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any): AxiosPromise<CommentJsonldCommentRead> {
            return localVarFp.postUnresolveCommentCommentItem(id, commentJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentApi - object-oriented interface
 * @export
 * @class CommentApi
 * @extends {BaseAPI}
 */
export class CommentApi extends BaseAPI {
    /**
     * Removes the Comment resource.
     * @summary Removes the Comment resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public deleteCommentItem(id: string, options?: any) {
        return CommentApiFp(this.configuration).deleteCommentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Comment resources.
     * @summary Retrieves the collection of Comment resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {Array<string>} [properties] 
     * @param {'asc' | 'desc'} [orderDateCreated] 
     * @param {string} [document] 
     * @param {Array<string>} [document2] 
     * @param {boolean} [isReply] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public getCommentCollection(page?: number, itemsPerPage?: number, properties?: Array<string>, orderDateCreated?: 'asc' | 'desc', document?: string, document2?: Array<string>, isReply?: boolean, options?: any) {
        return CommentApiFp(this.configuration).getCommentCollection(page, itemsPerPage, properties, orderDateCreated, document, document2, isReply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Comment resource.
     * @summary Retrieves a Comment resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public getCommentItem(id: string, options?: any) {
        return CommentApiFp(this.configuration).getCommentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Comment resource.
     * @summary Updates the Comment resource.
     * @param {string} id Resource identifier
     * @param {CommentCommentWrite} commentCommentWrite The updated Comment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public patchCommentItem(id: string, commentCommentWrite: CommentCommentWrite, options?: any) {
        return CommentApiFp(this.configuration).patchCommentItem(id, commentCommentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Comment resource.
     * @summary Creates a Comment resource.
     * @param {CommentJsonldCommentWrite} commentJsonldCommentWrite The new Comment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public postCommentCollection(commentJsonldCommentWrite: CommentJsonldCommentWrite, options?: any) {
        return CommentApiFp(this.configuration).postCommentCollection(commentJsonldCommentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Comment resource.
     * @summary Creates a Comment resource.
     * @param {string} id Resource identifier
     * @param {CommentJsonldCommentReply} commentJsonldCommentReply The new Comment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public postReplyCommentItem(id: string, commentJsonldCommentReply: CommentJsonldCommentReply, options?: any) {
        return CommentApiFp(this.configuration).postReplyCommentItem(id, commentJsonldCommentReply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Comment resource.
     * @summary Creates a Comment resource.
     * @param {string} id Resource identifier
     * @param {CommentJsonld} commentJsonld The new Comment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public postResolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any) {
        return CommentApiFp(this.configuration).postResolveCommentCommentItem(id, commentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Comment resource.
     * @summary Creates a Comment resource.
     * @param {string} id Resource identifier
     * @param {CommentJsonld} commentJsonld The new Comment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentApi
     */
    public postUnresolveCommentCommentItem(id: string, commentJsonld: CommentJsonld, options?: any) {
        return CommentApiFp(this.configuration).postUnresolveCommentCommentItem(id, commentJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the Document resource.
         * @summary Removes the Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentItem', 'id', id)
            const localVarPath = `/api/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Document resources.
         * @summary Retrieves the collection of Document resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [requiresMyInput] 
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderDocumentType] 
         * @param {'asc' | 'desc'} [orderNumber] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [documentType] 
         * @param {Array<string>} [documentType2] 
         * @param {string} [trackingLists] 
         * @param {Array<string>} [trackingLists2] 
         * @param {string} [q] 
         * @param {number} [ministry] 
         * @param {Array<string>} [groups] 
         * @param {string} [dateCreatedBefore] 
         * @param {string} [dateCreatedStrictlyBefore] 
         * @param {string} [dateCreatedAfter] 
         * @param {string} [dateCreatedStrictlyAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentCollection: async (page?: number, itemsPerPage?: number, requiresMyInput?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderDocumentType?: 'asc' | 'desc', orderNumber?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', status?: string, status2?: Array<string>, documentType?: string, documentType2?: Array<string>, trackingLists?: string, trackingLists2?: Array<string>, q?: string, ministry?: number, groups?: Array<string>, dateCreatedBefore?: string, dateCreatedStrictlyBefore?: string, dateCreatedAfter?: string, dateCreatedStrictlyAfter?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (requiresMyInput !== undefined) {
                localVarQueryParameter['RequiresMyInput'] = requiresMyInput;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['order[status]'] = orderStatus;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }

            if (orderDocumentType !== undefined) {
                localVarQueryParameter['order[documentType]'] = orderDocumentType;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order[number]'] = orderNumber;
            }

            if (orderDateCreated !== undefined) {
                localVarQueryParameter['order[dateCreated]'] = orderDateCreated;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (status2) {
                localVarQueryParameter['status[]'] = status2;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (documentType2) {
                localVarQueryParameter['documentType[]'] = documentType2;
            }

            if (trackingLists !== undefined) {
                localVarQueryParameter['trackingLists'] = trackingLists;
            }

            if (trackingLists2) {
                localVarQueryParameter['trackingLists[]'] = trackingLists2;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (ministry !== undefined) {
                localVarQueryParameter['ministry'] = ministry;
            }

            if (groups) {
                localVarQueryParameter['groups[]'] = groups;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['dateCreated[before]'] = dateCreatedBefore;
            }

            if (dateCreatedStrictlyBefore !== undefined) {
                localVarQueryParameter['dateCreated[strictly_before]'] = dateCreatedStrictlyBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['dateCreated[after]'] = dateCreatedAfter;
            }

            if (dateCreatedStrictlyAfter !== undefined) {
                localVarQueryParameter['dateCreated[strictly_after]'] = dateCreatedStrictlyAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} url Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFromShareUrlDocumentItem: async (url: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('getDocumentFromShareUrlDocumentItem', 'url', url)
            const localVarPath = `/api/documents/share/{url}`
                .replace(`{${"url"}}`, encodeURIComponent(String(url)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentItem', 'id', id)
            const localVarPath = `/api/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowForDocumentDocumentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowForDocumentDocumentItem', 'id', id)
            const localVarPath = `/api/documents/{id}/workflows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Document resource.
         * @summary Updates the Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentDocumentPatch} documentDocumentPatch The updated Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDocumentItem: async (id: string, documentDocumentPatch: DocumentDocumentPatch, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchDocumentItem', 'id', id)
            // verify required parameter 'documentDocumentPatch' is not null or undefined
            assertParamExists('patchDocumentItem', 'documentDocumentPatch', documentDocumentPatch)
            const localVarPath = `/api/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentDocumentPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentWriteAgendaDecision} documentJsonldDocumentWriteAgendaDecision The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaDecisionDocumentItem: async (id: string, documentJsonldDocumentWriteAgendaDecision: DocumentJsonldDocumentWriteAgendaDecision, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postAgendaDecisionDocumentItem', 'id', id)
            // verify required parameter 'documentJsonldDocumentWriteAgendaDecision' is not null or undefined
            assertParamExists('postAgendaDecisionDocumentItem', 'documentJsonldDocumentWriteAgendaDecision', documentJsonldDocumentWriteAgendaDecision)
            const localVarPath = `/api/documents/{id}/agenda_decision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentWriteAgendaDecision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateAr} documentJsonldDocumentUpdateAr The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postArchiveDocumentItem: async (id: string, documentJsonldDocumentUpdateAr: DocumentJsonldDocumentUpdateAr, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postArchiveDocumentItem', 'id', id)
            // verify required parameter 'documentJsonldDocumentUpdateAr' is not null or undefined
            assertParamExists('postArchiveDocumentItem', 'documentJsonldDocumentUpdateAr', documentJsonldDocumentUpdateAr)
            const localVarPath = `/api/documents/{id}/workflow/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentUpdateAr, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMinutesDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postCompleteMinutesDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postCompleteMinutesDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/minute/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentApproveDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postDocumentApproveDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postDocumentApproveDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/workflow/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {DocumentJsonldDocumentWrite} documentJsonldDocumentWrite The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentCollection: async (documentJsonldDocumentWrite: DocumentJsonldDocumentWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentJsonldDocumentWrite' is not null or undefined
            assertParamExists('postDocumentCollection', 'documentJsonldDocumentWrite', documentJsonldDocumentWrite)
            const localVarPath = `/api/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGenerateAgendaDecisionDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postGenerateAgendaDecisionDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postGenerateAgendaDecisionDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/agenda_decision/generate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIa} documentJsonldDocumentUpdateIa The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInApprovalDocumentItem: async (id: string, documentJsonldDocumentUpdateIa: DocumentJsonldDocumentUpdateIa, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postInApprovalDocumentItem', 'id', id)
            // verify required parameter 'documentJsonldDocumentUpdateIa' is not null or undefined
            assertParamExists('postInApprovalDocumentItem', 'documentJsonldDocumentUpdateIa', documentJsonldDocumentUpdateIa)
            const localVarPath = `/api/documents/{id}/workflow/in_approval`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentUpdateIa, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIc} documentJsonldDocumentUpdateIc The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInCollaborationDocumentItem: async (id: string, documentJsonldDocumentUpdateIc: DocumentJsonldDocumentUpdateIc, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postInCollaborationDocumentItem', 'id', id)
            // verify required parameter 'documentJsonldDocumentUpdateIc' is not null or undefined
            assertParamExists('postInCollaborationDocumentItem', 'documentJsonldDocumentUpdateIc', documentJsonldDocumentUpdateIc)
            const localVarPath = `/api/documents/{id}/workflow/in_collaboration`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentUpdateIc, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateMta} documentJsonldDocumentUpdateMta The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMovingToApprovalDocumentItem: async (id: string, documentJsonldDocumentUpdateMta: DocumentJsonldDocumentUpdateMta, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postMovingToApprovalDocumentItem', 'id', id)
            // verify required parameter 'documentJsonldDocumentUpdateMta' is not null or undefined
            assertParamExists('postMovingToApprovalDocumentItem', 'documentJsonldDocumentUpdateMta', documentJsonldDocumentUpdateMta)
            const localVarPath = `/api/documents/{id}/workflow/moving_to_approval`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonldDocumentUpdateMta, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMovingToCollaborationDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postMovingToCollaborationDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postMovingToCollaborationDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/workflow/moving_to_collaboration`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestAccessDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postRequestAccessDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postRequestAccessDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/request_access`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateLastSeenDocumentCommentsDocumentItem: async (id: string, documentJsonld: DocumentJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postUpdateLastSeenDocumentCommentsDocumentItem', 'id', id)
            // verify required parameter 'documentJsonld' is not null or undefined
            assertParamExists('postUpdateLastSeenDocumentCommentsDocumentItem', 'documentJsonld', documentJsonld)
            const localVarPath = `/api/documents/{id}/comments_viewed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the Document resource.
         * @summary Removes the Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of Document resources.
         * @summary Retrieves the collection of Document resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [requiresMyInput] 
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderDocumentType] 
         * @param {'asc' | 'desc'} [orderNumber] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [documentType] 
         * @param {Array<string>} [documentType2] 
         * @param {string} [trackingLists] 
         * @param {Array<string>} [trackingLists2] 
         * @param {string} [q] 
         * @param {number} [ministry] 
         * @param {Array<string>} [groups] 
         * @param {string} [dateCreatedBefore] 
         * @param {string} [dateCreatedStrictlyBefore] 
         * @param {string} [dateCreatedAfter] 
         * @param {string} [dateCreatedStrictlyAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentCollection(page?: number, itemsPerPage?: number, requiresMyInput?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderDocumentType?: 'asc' | 'desc', orderNumber?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', status?: string, status2?: Array<string>, documentType?: string, documentType2?: Array<string>, trackingLists?: string, trackingLists2?: Array<string>, q?: string, ministry?: number, groups?: Array<string>, dateCreatedBefore?: string, dateCreatedStrictlyBefore?: string, dateCreatedAfter?: string, dateCreatedStrictlyAfter?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentCollection(page, itemsPerPage, requiresMyInput, orderStatus, orderTitle, orderDocumentType, orderNumber, orderDateCreated, status, status2, documentType, documentType2, trackingLists, trackingLists2, q, ministry, groups, dateCreatedBefore, dateCreatedStrictlyBefore, dateCreatedAfter, dateCreatedStrictlyAfter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} url Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentFromShareUrlDocumentItem(url: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentReadGetShare>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentFromShareUrlDocumentItem(url, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowForDocumentDocumentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentReadWorkflows>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowForDocumentDocumentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the Document resource.
         * @summary Updates the Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentDocumentPatch} documentDocumentPatch The updated Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDocumentItem(id: string, documentDocumentPatch: DocumentDocumentPatch, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDocumentItem(id, documentDocumentPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentWriteAgendaDecision} documentJsonldDocumentWriteAgendaDecision The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgendaDecisionDocumentItem(id: string, documentJsonldDocumentWriteAgendaDecision: DocumentJsonldDocumentWriteAgendaDecision, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentReadAgendaDecision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgendaDecisionDocumentItem(id, documentJsonldDocumentWriteAgendaDecision, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateAr} documentJsonldDocumentUpdateAr The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postArchiveDocumentItem(id: string, documentJsonldDocumentUpdateAr: DocumentJsonldDocumentUpdateAr, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postArchiveDocumentItem(id, documentJsonldDocumentUpdateAr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompleteMinutesDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompleteMinutesDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentApproveDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentApproveDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {DocumentJsonldDocumentWrite} documentJsonldDocumentWrite The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentCollection(documentJsonldDocumentWrite: DocumentJsonldDocumentWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentCollection(documentJsonldDocumentWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGenerateAgendaDecisionDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentReadAgendaDecision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGenerateAgendaDecisionDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIa} documentJsonldDocumentUpdateIa The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInApprovalDocumentItem(id: string, documentJsonldDocumentUpdateIa: DocumentJsonldDocumentUpdateIa, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInApprovalDocumentItem(id, documentJsonldDocumentUpdateIa, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIc} documentJsonldDocumentUpdateIc The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInCollaborationDocumentItem(id: string, documentJsonldDocumentUpdateIc: DocumentJsonldDocumentUpdateIc, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInCollaborationDocumentItem(id, documentJsonldDocumentUpdateIc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateMta} documentJsonldDocumentUpdateMta The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMovingToApprovalDocumentItem(id: string, documentJsonldDocumentUpdateMta: DocumentJsonldDocumentUpdateMta, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMovingToApprovalDocumentItem(id, documentJsonldDocumentUpdateMta, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMovingToCollaborationDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMovingToCollaborationDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRequestAccessDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRequestAccessDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUpdateLastSeenDocumentCommentsDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentJsonldDocumentComments>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUpdateLastSeenDocumentCommentsDocumentItem(id, documentJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * Removes the Document resource.
         * @summary Removes the Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocumentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Document resources.
         * @summary Retrieves the collection of Document resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [requiresMyInput] 
         * @param {'asc' | 'desc'} [orderStatus] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderDocumentType] 
         * @param {'asc' | 'desc'} [orderNumber] 
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {string} [status] 
         * @param {Array<string>} [status2] 
         * @param {string} [documentType] 
         * @param {Array<string>} [documentType2] 
         * @param {string} [trackingLists] 
         * @param {Array<string>} [trackingLists2] 
         * @param {string} [q] 
         * @param {number} [ministry] 
         * @param {Array<string>} [groups] 
         * @param {string} [dateCreatedBefore] 
         * @param {string} [dateCreatedStrictlyBefore] 
         * @param {string} [dateCreatedAfter] 
         * @param {string} [dateCreatedStrictlyAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentCollection(page?: number, itemsPerPage?: number, requiresMyInput?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderDocumentType?: 'asc' | 'desc', orderNumber?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', status?: string, status2?: Array<string>, documentType?: string, documentType2?: Array<string>, trackingLists?: string, trackingLists2?: Array<string>, q?: string, ministry?: number, groups?: Array<string>, dateCreatedBefore?: string, dateCreatedStrictlyBefore?: string, dateCreatedAfter?: string, dateCreatedStrictlyAfter?: string, options?: any): AxiosPromise<InlineResponse20010> {
            return localVarFp.getDocumentCollection(page, itemsPerPage, requiresMyInput, orderStatus, orderTitle, orderDocumentType, orderNumber, orderDateCreated, status, status2, documentType, documentType2, trackingLists, trackingLists2, q, ministry, groups, dateCreatedBefore, dateCreatedStrictlyBefore, dateCreatedAfter, dateCreatedStrictlyAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} url Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFromShareUrlDocumentItem(url: string, options?: any): AxiosPromise<DocumentJsonldDocumentReadGetShare> {
            return localVarFp.getDocumentFromShareUrlDocumentItem(url, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentItem(id: string, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.getDocumentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Document resource.
         * @summary Retrieves a Document resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowForDocumentDocumentItem(id: string, options?: any): AxiosPromise<DocumentJsonldDocumentReadWorkflows> {
            return localVarFp.getWorkflowForDocumentDocumentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Document resource.
         * @summary Updates the Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentDocumentPatch} documentDocumentPatch The updated Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDocumentItem(id: string, documentDocumentPatch: DocumentDocumentPatch, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.patchDocumentItem(id, documentDocumentPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentWriteAgendaDecision} documentJsonldDocumentWriteAgendaDecision The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgendaDecisionDocumentItem(id: string, documentJsonldDocumentWriteAgendaDecision: DocumentJsonldDocumentWriteAgendaDecision, options?: any): AxiosPromise<DocumentJsonldDocumentReadAgendaDecision> {
            return localVarFp.postAgendaDecisionDocumentItem(id, documentJsonldDocumentWriteAgendaDecision, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateAr} documentJsonldDocumentUpdateAr The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postArchiveDocumentItem(id: string, documentJsonldDocumentUpdateAr: DocumentJsonldDocumentUpdateAr, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postArchiveDocumentItem(id, documentJsonldDocumentUpdateAr, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompleteMinutesDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postCompleteMinutesDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentApproveDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postDocumentApproveDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {DocumentJsonldDocumentWrite} documentJsonldDocumentWrite The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentCollection(documentJsonldDocumentWrite: DocumentJsonldDocumentWrite, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postDocumentCollection(documentJsonldDocumentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGenerateAgendaDecisionDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentReadAgendaDecision> {
            return localVarFp.postGenerateAgendaDecisionDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIa} documentJsonldDocumentUpdateIa The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInApprovalDocumentItem(id: string, documentJsonldDocumentUpdateIa: DocumentJsonldDocumentUpdateIa, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postInApprovalDocumentItem(id, documentJsonldDocumentUpdateIa, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateIc} documentJsonldDocumentUpdateIc The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInCollaborationDocumentItem(id: string, documentJsonldDocumentUpdateIc: DocumentJsonldDocumentUpdateIc, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postInCollaborationDocumentItem(id, documentJsonldDocumentUpdateIc, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonldDocumentUpdateMta} documentJsonldDocumentUpdateMta The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMovingToApprovalDocumentItem(id: string, documentJsonldDocumentUpdateMta: DocumentJsonldDocumentUpdateMta, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postMovingToApprovalDocumentItem(id, documentJsonldDocumentUpdateMta, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMovingToCollaborationDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postMovingToCollaborationDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestAccessDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentRead> {
            return localVarFp.postRequestAccessDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Document resource.
         * @summary Creates a Document resource.
         * @param {string} id Resource identifier
         * @param {DocumentJsonld} documentJsonld The new Document resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateLastSeenDocumentCommentsDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any): AxiosPromise<DocumentJsonldDocumentComments> {
            return localVarFp.postUpdateLastSeenDocumentCommentsDocumentItem(id, documentJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * Removes the Document resource.
     * @summary Removes the Document resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public deleteDocumentItem(id: string, options?: any) {
        return DocumentApiFp(this.configuration).deleteDocumentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Document resources.
     * @summary Retrieves the collection of Document resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {boolean} [requiresMyInput] 
     * @param {'asc' | 'desc'} [orderStatus] 
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {'asc' | 'desc'} [orderDocumentType] 
     * @param {'asc' | 'desc'} [orderNumber] 
     * @param {'asc' | 'desc'} [orderDateCreated] 
     * @param {string} [status] 
     * @param {Array<string>} [status2] 
     * @param {string} [documentType] 
     * @param {Array<string>} [documentType2] 
     * @param {string} [trackingLists] 
     * @param {Array<string>} [trackingLists2] 
     * @param {string} [q] 
     * @param {number} [ministry] 
     * @param {Array<string>} [groups] 
     * @param {string} [dateCreatedBefore] 
     * @param {string} [dateCreatedStrictlyBefore] 
     * @param {string} [dateCreatedAfter] 
     * @param {string} [dateCreatedStrictlyAfter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentCollection(page?: number, itemsPerPage?: number, requiresMyInput?: boolean, orderStatus?: 'asc' | 'desc', orderTitle?: 'asc' | 'desc', orderDocumentType?: 'asc' | 'desc', orderNumber?: 'asc' | 'desc', orderDateCreated?: 'asc' | 'desc', status?: string, status2?: Array<string>, documentType?: string, documentType2?: Array<string>, trackingLists?: string, trackingLists2?: Array<string>, q?: string, ministry?: number, groups?: Array<string>, dateCreatedBefore?: string, dateCreatedStrictlyBefore?: string, dateCreatedAfter?: string, dateCreatedStrictlyAfter?: string, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentCollection(page, itemsPerPage, requiresMyInput, orderStatus, orderTitle, orderDocumentType, orderNumber, orderDateCreated, status, status2, documentType, documentType2, trackingLists, trackingLists2, q, ministry, groups, dateCreatedBefore, dateCreatedStrictlyBefore, dateCreatedAfter, dateCreatedStrictlyAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Document resource.
     * @summary Retrieves a Document resource.
     * @param {string} url Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentFromShareUrlDocumentItem(url: string, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentFromShareUrlDocumentItem(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Document resource.
     * @summary Retrieves a Document resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentItem(id: string, options?: any) {
        return DocumentApiFp(this.configuration).getDocumentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Document resource.
     * @summary Retrieves a Document resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getWorkflowForDocumentDocumentItem(id: string, options?: any) {
        return DocumentApiFp(this.configuration).getWorkflowForDocumentDocumentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Document resource.
     * @summary Updates the Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentDocumentPatch} documentDocumentPatch The updated Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public patchDocumentItem(id: string, documentDocumentPatch: DocumentDocumentPatch, options?: any) {
        return DocumentApiFp(this.configuration).patchDocumentItem(id, documentDocumentPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonldDocumentWriteAgendaDecision} documentJsonldDocumentWriteAgendaDecision The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postAgendaDecisionDocumentItem(id: string, documentJsonldDocumentWriteAgendaDecision: DocumentJsonldDocumentWriteAgendaDecision, options?: any) {
        return DocumentApiFp(this.configuration).postAgendaDecisionDocumentItem(id, documentJsonldDocumentWriteAgendaDecision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonldDocumentUpdateAr} documentJsonldDocumentUpdateAr The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postArchiveDocumentItem(id: string, documentJsonldDocumentUpdateAr: DocumentJsonldDocumentUpdateAr, options?: any) {
        return DocumentApiFp(this.configuration).postArchiveDocumentItem(id, documentJsonldDocumentUpdateAr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postCompleteMinutesDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postCompleteMinutesDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postDocumentApproveDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postDocumentApproveDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {DocumentJsonldDocumentWrite} documentJsonldDocumentWrite The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postDocumentCollection(documentJsonldDocumentWrite: DocumentJsonldDocumentWrite, options?: any) {
        return DocumentApiFp(this.configuration).postDocumentCollection(documentJsonldDocumentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postGenerateAgendaDecisionDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postGenerateAgendaDecisionDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonldDocumentUpdateIa} documentJsonldDocumentUpdateIa The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postInApprovalDocumentItem(id: string, documentJsonldDocumentUpdateIa: DocumentJsonldDocumentUpdateIa, options?: any) {
        return DocumentApiFp(this.configuration).postInApprovalDocumentItem(id, documentJsonldDocumentUpdateIa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonldDocumentUpdateIc} documentJsonldDocumentUpdateIc The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postInCollaborationDocumentItem(id: string, documentJsonldDocumentUpdateIc: DocumentJsonldDocumentUpdateIc, options?: any) {
        return DocumentApiFp(this.configuration).postInCollaborationDocumentItem(id, documentJsonldDocumentUpdateIc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonldDocumentUpdateMta} documentJsonldDocumentUpdateMta The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postMovingToApprovalDocumentItem(id: string, documentJsonldDocumentUpdateMta: DocumentJsonldDocumentUpdateMta, options?: any) {
        return DocumentApiFp(this.configuration).postMovingToApprovalDocumentItem(id, documentJsonldDocumentUpdateMta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postMovingToCollaborationDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postMovingToCollaborationDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postRequestAccessDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postRequestAccessDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Document resource.
     * @summary Creates a Document resource.
     * @param {string} id Resource identifier
     * @param {DocumentJsonld} documentJsonld The new Document resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public postUpdateLastSeenDocumentCommentsDocumentItem(id: string, documentJsonld: DocumentJsonld, options?: any) {
        return DocumentApiFp(this.configuration).postUpdateLastSeenDocumentCommentsDocumentItem(id, documentJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentAttachmentApi - axios parameter creator
 * @export
 */
export const DocumentAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the DocumentAttachment resource.
         * @summary Removes the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentAttachmentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentAttachmentItem', 'id', id)
            const localVarPath = `/api/document_attachments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of DocumentAttachment resources.
         * @summary Retrieves the collection of DocumentAttachment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentAttachmentCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document_attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a DocumentAttachment resource.
         * @summary Retrieves a DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentAttachmentItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentAttachmentItem', 'id', id)
            const localVarPath = `/api/document_attachments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the DocumentAttachment resource.
         * @summary Updates the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {DocumentAttachmentDocumentAttachmentWrite} documentAttachmentDocumentAttachmentWrite The updated DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDocumentAttachmentItem: async (id: string, documentAttachmentDocumentAttachmentWrite: DocumentAttachmentDocumentAttachmentWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchDocumentAttachmentItem', 'id', id)
            // verify required parameter 'documentAttachmentDocumentAttachmentWrite' is not null or undefined
            assertParamExists('patchDocumentAttachmentItem', 'documentAttachmentDocumentAttachmentWrite', documentAttachmentDocumentAttachmentWrite)
            const localVarPath = `/api/document_attachments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentAttachmentDocumentAttachmentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a DocumentAttachment resource.
         * @summary Creates a DocumentAttachment resource.
         * @param {DocumentAttachmentJsonldDocumentAttachmentWrite} documentAttachmentJsonldDocumentAttachmentWrite The new DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentAttachmentCollection: async (documentAttachmentJsonldDocumentAttachmentWrite: DocumentAttachmentJsonldDocumentAttachmentWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentAttachmentJsonldDocumentAttachmentWrite' is not null or undefined
            assertParamExists('postDocumentAttachmentCollection', 'documentAttachmentJsonldDocumentAttachmentWrite', documentAttachmentJsonldDocumentAttachmentWrite)
            const localVarPath = `/api/document_attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentAttachmentJsonldDocumentAttachmentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentAttachmentApi - functional programming interface
 * @export
 */
export const DocumentAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the DocumentAttachment resource.
         * @summary Removes the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentAttachmentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentAttachmentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of DocumentAttachment resources.
         * @summary Retrieves the collection of DocumentAttachment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentAttachmentCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentAttachmentCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a DocumentAttachment resource.
         * @summary Retrieves a DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentAttachmentItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentAttachmentItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the DocumentAttachment resource.
         * @summary Updates the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {DocumentAttachmentDocumentAttachmentWrite} documentAttachmentDocumentAttachmentWrite The updated DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDocumentAttachmentItem(id: string, documentAttachmentDocumentAttachmentWrite: DocumentAttachmentDocumentAttachmentWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDocumentAttachmentItem(id, documentAttachmentDocumentAttachmentWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a DocumentAttachment resource.
         * @summary Creates a DocumentAttachment resource.
         * @param {DocumentAttachmentJsonldDocumentAttachmentWrite} documentAttachmentJsonldDocumentAttachmentWrite The new DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite: DocumentAttachmentJsonldDocumentAttachmentWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentAttachmentApi - factory interface
 * @export
 */
export const DocumentAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentAttachmentApiFp(configuration)
    return {
        /**
         * Removes the DocumentAttachment resource.
         * @summary Removes the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentAttachmentItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocumentAttachmentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of DocumentAttachment resources.
         * @summary Retrieves the collection of DocumentAttachment resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentAttachmentCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.getDocumentAttachmentCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a DocumentAttachment resource.
         * @summary Retrieves a DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentAttachmentItem(id: string, options?: any): AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead> {
            return localVarFp.getDocumentAttachmentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the DocumentAttachment resource.
         * @summary Updates the DocumentAttachment resource.
         * @param {string} id Resource identifier
         * @param {DocumentAttachmentDocumentAttachmentWrite} documentAttachmentDocumentAttachmentWrite The updated DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDocumentAttachmentItem(id: string, documentAttachmentDocumentAttachmentWrite: DocumentAttachmentDocumentAttachmentWrite, options?: any): AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead> {
            return localVarFp.patchDocumentAttachmentItem(id, documentAttachmentDocumentAttachmentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a DocumentAttachment resource.
         * @summary Creates a DocumentAttachment resource.
         * @param {DocumentAttachmentJsonldDocumentAttachmentWrite} documentAttachmentJsonldDocumentAttachmentWrite The new DocumentAttachment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite: DocumentAttachmentJsonldDocumentAttachmentWrite, options?: any): AxiosPromise<DocumentAttachmentJsonldDocumentAttachmentRead> {
            return localVarFp.postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentAttachmentApi - object-oriented interface
 * @export
 * @class DocumentAttachmentApi
 * @extends {BaseAPI}
 */
export class DocumentAttachmentApi extends BaseAPI {
    /**
     * Removes the DocumentAttachment resource.
     * @summary Removes the DocumentAttachment resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAttachmentApi
     */
    public deleteDocumentAttachmentItem(id: string, options?: any) {
        return DocumentAttachmentApiFp(this.configuration).deleteDocumentAttachmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of DocumentAttachment resources.
     * @summary Retrieves the collection of DocumentAttachment resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAttachmentApi
     */
    public getDocumentAttachmentCollection(page?: number, itemsPerPage?: number, options?: any) {
        return DocumentAttachmentApiFp(this.configuration).getDocumentAttachmentCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a DocumentAttachment resource.
     * @summary Retrieves a DocumentAttachment resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAttachmentApi
     */
    public getDocumentAttachmentItem(id: string, options?: any) {
        return DocumentAttachmentApiFp(this.configuration).getDocumentAttachmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the DocumentAttachment resource.
     * @summary Updates the DocumentAttachment resource.
     * @param {string} id Resource identifier
     * @param {DocumentAttachmentDocumentAttachmentWrite} documentAttachmentDocumentAttachmentWrite The updated DocumentAttachment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAttachmentApi
     */
    public patchDocumentAttachmentItem(id: string, documentAttachmentDocumentAttachmentWrite: DocumentAttachmentDocumentAttachmentWrite, options?: any) {
        return DocumentAttachmentApiFp(this.configuration).patchDocumentAttachmentItem(id, documentAttachmentDocumentAttachmentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a DocumentAttachment resource.
     * @summary Creates a DocumentAttachment resource.
     * @param {DocumentAttachmentJsonldDocumentAttachmentWrite} documentAttachmentJsonldDocumentAttachmentWrite The new DocumentAttachment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentAttachmentApi
     */
    public postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite: DocumentAttachmentJsonldDocumentAttachmentWrite, options?: any) {
        return DocumentAttachmentApiFp(this.configuration).postDocumentAttachmentCollection(documentAttachmentJsonldDocumentAttachmentWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentSharedUserApi - axios parameter creator
 * @export
 */
export const DocumentSharedUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of DocumentSharedUser resources.
         * @summary Retrieves the collection of DocumentSharedUser resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSharedUserCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document_shared_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a DocumentSharedUser resource.
         * @summary Retrieves a DocumentSharedUser resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSharedUserItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentSharedUserItem', 'id', id)
            const localVarPath = `/api/document_shared_users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentSharedUserApi - functional programming interface
 * @export
 */
export const DocumentSharedUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentSharedUserApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of DocumentSharedUser resources.
         * @summary Retrieves the collection of DocumentSharedUser resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentSharedUserCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentSharedUserCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a DocumentSharedUser resource.
         * @summary Retrieves a DocumentSharedUser resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentSharedUserItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentSharedUserJsonldDocumentSharedUserRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentSharedUserItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentSharedUserApi - factory interface
 * @export
 */
export const DocumentSharedUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentSharedUserApiFp(configuration)
    return {
        /**
         * Retrieves the collection of DocumentSharedUser resources.
         * @summary Retrieves the collection of DocumentSharedUser resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSharedUserCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.getDocumentSharedUserCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a DocumentSharedUser resource.
         * @summary Retrieves a DocumentSharedUser resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSharedUserItem(id: string, options?: any): AxiosPromise<DocumentSharedUserJsonldDocumentSharedUserRead> {
            return localVarFp.getDocumentSharedUserItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentSharedUserApi - object-oriented interface
 * @export
 * @class DocumentSharedUserApi
 * @extends {BaseAPI}
 */
export class DocumentSharedUserApi extends BaseAPI {
    /**
     * Retrieves the collection of DocumentSharedUser resources.
     * @summary Retrieves the collection of DocumentSharedUser resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentSharedUserApi
     */
    public getDocumentSharedUserCollection(page?: number, itemsPerPage?: number, options?: any) {
        return DocumentSharedUserApiFp(this.configuration).getDocumentSharedUserCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a DocumentSharedUser resource.
     * @summary Retrieves a DocumentSharedUser resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentSharedUserApi
     */
    public getDocumentSharedUserItem(id: string, options?: any) {
        return DocumentSharedUserApiFp(this.configuration).getDocumentSharedUserItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KnowledgeBaseApi - axios parameter creator
 * @export
 */
export const KnowledgeBaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of KnowledgeBase resources.
         * @summary Retrieves the collection of KnowledgeBase resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeBaseCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/knowledge_bases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a KnowledgeBase resource.
         * @summary Retrieves a KnowledgeBase resource.
         * @param {string} question Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeBaseItem: async (question: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'question' is not null or undefined
            assertParamExists('getKnowledgeBaseItem', 'question', question)
            const localVarPath = `/api/knowledge_bases/{question}`
                .replace(`{${"question"}}`, encodeURIComponent(String(question)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeBaseApi - functional programming interface
 * @export
 */
export const KnowledgeBaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeBaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of KnowledgeBase resources.
         * @summary Retrieves the collection of KnowledgeBase resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeBaseCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeBaseCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a KnowledgeBase resource.
         * @summary Retrieves a KnowledgeBase resource.
         * @param {string} question Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeBaseItem(question: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseJsonldKnowledgeBaseRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeBaseItem(question, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KnowledgeBaseApi - factory interface
 * @export
 */
export const KnowledgeBaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeBaseApiFp(configuration)
    return {
        /**
         * Retrieves the collection of KnowledgeBase resources.
         * @summary Retrieves the collection of KnowledgeBase resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeBaseCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.getKnowledgeBaseCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a KnowledgeBase resource.
         * @summary Retrieves a KnowledgeBase resource.
         * @param {string} question Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeBaseItem(question: string, options?: any): AxiosPromise<KnowledgeBaseJsonldKnowledgeBaseRead> {
            return localVarFp.getKnowledgeBaseItem(question, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeBaseApi - object-oriented interface
 * @export
 * @class KnowledgeBaseApi
 * @extends {BaseAPI}
 */
export class KnowledgeBaseApi extends BaseAPI {
    /**
     * Retrieves the collection of KnowledgeBase resources.
     * @summary Retrieves the collection of KnowledgeBase resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getKnowledgeBaseCollection(page?: number, itemsPerPage?: number, options?: any) {
        return KnowledgeBaseApiFp(this.configuration).getKnowledgeBaseCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a KnowledgeBase resource.
     * @summary Retrieves a KnowledgeBase resource.
     * @param {string} question Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public getKnowledgeBaseItem(question: string, options?: any) {
        return KnowledgeBaseApiFp(this.configuration).getKnowledgeBaseItem(question, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KpiApi - axios parameter creator
 * @export
 */
export const KpiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Kpi resources.
         * @summary Retrieves the collection of Kpi resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/kpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Kpi resource.
         * @summary Retrieves a Kpi resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getKpiItem', 'id', id)
            const localVarPath = `/api/kpis/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KpiApi - functional programming interface
 * @export
 */
export const KpiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KpiApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Kpi resources.
         * @summary Retrieves the collection of Kpi resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKpiCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKpiCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Kpi resource.
         * @summary Retrieves a Kpi resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKpiItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KpiJsonldKpiRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKpiItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KpiApi - factory interface
 * @export
 */
export const KpiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KpiApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Kpi resources.
         * @summary Retrieves the collection of Kpi resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse20012> {
            return localVarFp.getKpiCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Kpi resource.
         * @summary Retrieves a Kpi resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpiItem(id: string, options?: any): AxiosPromise<KpiJsonldKpiRead> {
            return localVarFp.getKpiItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KpiApi - object-oriented interface
 * @export
 * @class KpiApi
 * @extends {BaseAPI}
 */
export class KpiApi extends BaseAPI {
    /**
     * Retrieves the collection of Kpi resources.
     * @summary Retrieves the collection of Kpi resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiApi
     */
    public getKpiCollection(page?: number, itemsPerPage?: number, options?: any) {
        return KpiApiFp(this.configuration).getKpiCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Kpi resource.
     * @summary Retrieves a Kpi resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiApi
     */
    public getKpiItem(id: string, options?: any) {
        return KpiApiFp(this.configuration).getKpiItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LogEventApi - axios parameter creator
 * @export
 */
export const LogEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of LogEvent resources.
         * @summary Retrieves the collection of LogEvent resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [orSearch] 
         * @param {string} [q] 
         * @param {string} [level] 
         * @param {Array<string>} [level2] 
         * @param {string} [subject] 
         * @param {Array<string>} [subject2] 
         * @param {string} [source] 
         * @param {Array<string>} [source2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {'asc' | 'desc'} [orderEvent] 
         * @param {'asc' | 'desc'} [orderLevel] 
         * @param {'asc' | 'desc'} [orderSubject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogEventCollection: async (page?: number, itemsPerPage?: number, orSearch?: Array<string>, q?: string, level?: string, level2?: Array<string>, subject?: string, subject2?: Array<string>, source?: string, source2?: Array<string>, user?: string, user2?: Array<string>, orderEvent?: 'asc' | 'desc', orderLevel?: 'asc' | 'desc', orderSubject?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/log_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orSearch) {
                localVarQueryParameter['orSearch[]'] = orSearch;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (level2) {
                localVarQueryParameter['level[]'] = level2;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (subject2) {
                localVarQueryParameter['subject[]'] = subject2;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (source2) {
                localVarQueryParameter['source[]'] = source2;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (user2) {
                localVarQueryParameter['user[]'] = user2;
            }

            if (orderEvent !== undefined) {
                localVarQueryParameter['order[event]'] = orderEvent;
            }

            if (orderLevel !== undefined) {
                localVarQueryParameter['order[level]'] = orderLevel;
            }

            if (orderSubject !== undefined) {
                localVarQueryParameter['order[subject]'] = orderSubject;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a LogEvent resource.
         * @summary Retrieves a LogEvent resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogEventItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLogEventItem', 'id', id)
            const localVarPath = `/api/log_events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogEvent resource.
         * @summary Creates a LogEvent resource.
         * @param {LogEventJsonldLogEventWrite} logEventJsonldLogEventWrite The new LogEvent resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogEventCollection: async (logEventJsonldLogEventWrite: LogEventJsonldLogEventWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'logEventJsonldLogEventWrite' is not null or undefined
            assertParamExists('postLogEventCollection', 'logEventJsonldLogEventWrite', logEventJsonldLogEventWrite)
            const localVarPath = `/api/log_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logEventJsonldLogEventWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogEventApi - functional programming interface
 * @export
 */
export const LogEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogEventApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of LogEvent resources.
         * @summary Retrieves the collection of LogEvent resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [orSearch] 
         * @param {string} [q] 
         * @param {string} [level] 
         * @param {Array<string>} [level2] 
         * @param {string} [subject] 
         * @param {Array<string>} [subject2] 
         * @param {string} [source] 
         * @param {Array<string>} [source2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {'asc' | 'desc'} [orderEvent] 
         * @param {'asc' | 'desc'} [orderLevel] 
         * @param {'asc' | 'desc'} [orderSubject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogEventCollection(page?: number, itemsPerPage?: number, orSearch?: Array<string>, q?: string, level?: string, level2?: Array<string>, subject?: string, subject2?: Array<string>, source?: string, source2?: Array<string>, user?: string, user2?: Array<string>, orderEvent?: 'asc' | 'desc', orderLevel?: 'asc' | 'desc', orderSubject?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogEventCollection(page, itemsPerPage, orSearch, q, level, level2, subject, subject2, source, source2, user, user2, orderEvent, orderLevel, orderSubject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a LogEvent resource.
         * @summary Retrieves a LogEvent resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogEventItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogEventJsonldLogEventRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogEventItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a LogEvent resource.
         * @summary Creates a LogEvent resource.
         * @param {LogEventJsonldLogEventWrite} logEventJsonldLogEventWrite The new LogEvent resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLogEventCollection(logEventJsonldLogEventWrite: LogEventJsonldLogEventWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogEventJsonldLogEventRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLogEventCollection(logEventJsonldLogEventWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LogEventApi - factory interface
 * @export
 */
export const LogEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogEventApiFp(configuration)
    return {
        /**
         * Retrieves the collection of LogEvent resources.
         * @summary Retrieves the collection of LogEvent resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<string>} [orSearch] 
         * @param {string} [q] 
         * @param {string} [level] 
         * @param {Array<string>} [level2] 
         * @param {string} [subject] 
         * @param {Array<string>} [subject2] 
         * @param {string} [source] 
         * @param {Array<string>} [source2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {'asc' | 'desc'} [orderEvent] 
         * @param {'asc' | 'desc'} [orderLevel] 
         * @param {'asc' | 'desc'} [orderSubject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogEventCollection(page?: number, itemsPerPage?: number, orSearch?: Array<string>, q?: string, level?: string, level2?: Array<string>, subject?: string, subject2?: Array<string>, source?: string, source2?: Array<string>, user?: string, user2?: Array<string>, orderEvent?: 'asc' | 'desc', orderLevel?: 'asc' | 'desc', orderSubject?: 'asc' | 'desc', options?: any): AxiosPromise<InlineResponse20013> {
            return localVarFp.getLogEventCollection(page, itemsPerPage, orSearch, q, level, level2, subject, subject2, source, source2, user, user2, orderEvent, orderLevel, orderSubject, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a LogEvent resource.
         * @summary Retrieves a LogEvent resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogEventItem(id: string, options?: any): AxiosPromise<LogEventJsonldLogEventRead> {
            return localVarFp.getLogEventItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogEvent resource.
         * @summary Creates a LogEvent resource.
         * @param {LogEventJsonldLogEventWrite} logEventJsonldLogEventWrite The new LogEvent resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogEventCollection(logEventJsonldLogEventWrite: LogEventJsonldLogEventWrite, options?: any): AxiosPromise<LogEventJsonldLogEventRead> {
            return localVarFp.postLogEventCollection(logEventJsonldLogEventWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogEventApi - object-oriented interface
 * @export
 * @class LogEventApi
 * @extends {BaseAPI}
 */
export class LogEventApi extends BaseAPI {
    /**
     * Retrieves the collection of LogEvent resources.
     * @summary Retrieves the collection of LogEvent resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {Array<string>} [orSearch] 
     * @param {string} [q] 
     * @param {string} [level] 
     * @param {Array<string>} [level2] 
     * @param {string} [subject] 
     * @param {Array<string>} [subject2] 
     * @param {string} [source] 
     * @param {Array<string>} [source2] 
     * @param {string} [user] 
     * @param {Array<string>} [user2] 
     * @param {'asc' | 'desc'} [orderEvent] 
     * @param {'asc' | 'desc'} [orderLevel] 
     * @param {'asc' | 'desc'} [orderSubject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogEventApi
     */
    public getLogEventCollection(page?: number, itemsPerPage?: number, orSearch?: Array<string>, q?: string, level?: string, level2?: Array<string>, subject?: string, subject2?: Array<string>, source?: string, source2?: Array<string>, user?: string, user2?: Array<string>, orderEvent?: 'asc' | 'desc', orderLevel?: 'asc' | 'desc', orderSubject?: 'asc' | 'desc', options?: any) {
        return LogEventApiFp(this.configuration).getLogEventCollection(page, itemsPerPage, orSearch, q, level, level2, subject, subject2, source, source2, user, user2, orderEvent, orderLevel, orderSubject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a LogEvent resource.
     * @summary Retrieves a LogEvent resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogEventApi
     */
    public getLogEventItem(id: string, options?: any) {
        return LogEventApiFp(this.configuration).getLogEventItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogEvent resource.
     * @summary Creates a LogEvent resource.
     * @param {LogEventJsonldLogEventWrite} logEventJsonldLogEventWrite The new LogEvent resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogEventApi
     */
    public postLogEventCollection(logEventJsonldLogEventWrite: LogEventJsonldLogEventWrite, options?: any) {
        return LogEventApiFp(this.configuration).postLogEventCollection(logEventJsonldLogEventWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MSDriveApi - axios parameter creator
 * @export
 */
export const MSDriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of MSDrive resources.
         * @summary Retrieves the collection of MSDrive resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSDriveCollection: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/m_s_drives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a MSDrive resource.
         * @summary Retrieves a MSDrive resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSDriveItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMSDriveItem', 'id', id)
            const localVarPath = `/api/m_s_drives/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MSDriveApi - functional programming interface
 * @export
 */
export const MSDriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MSDriveApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of MSDrive resources.
         * @summary Retrieves the collection of MSDrive resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMSDriveCollection(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMSDriveCollection(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a MSDrive resource.
         * @summary Retrieves a MSDrive resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMSDriveItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MSDriveJsonldDriveRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMSDriveItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MSDriveApi - factory interface
 * @export
 */
export const MSDriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MSDriveApiFp(configuration)
    return {
        /**
         * Retrieves the collection of MSDrive resources.
         * @summary Retrieves the collection of MSDrive resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSDriveCollection(options?: any): AxiosPromise<InlineResponse20014> {
            return localVarFp.getMSDriveCollection(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a MSDrive resource.
         * @summary Retrieves a MSDrive resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSDriveItem(id: string, options?: any): AxiosPromise<MSDriveJsonldDriveRead> {
            return localVarFp.getMSDriveItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MSDriveApi - object-oriented interface
 * @export
 * @class MSDriveApi
 * @extends {BaseAPI}
 */
export class MSDriveApi extends BaseAPI {
    /**
     * Retrieves the collection of MSDrive resources.
     * @summary Retrieves the collection of MSDrive resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MSDriveApi
     */
    public getMSDriveCollection(options?: any) {
        return MSDriveApiFp(this.configuration).getMSDriveCollection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a MSDrive resource.
     * @summary Retrieves a MSDrive resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MSDriveApi
     */
    public getMSDriveItem(id: string, options?: any) {
        return MSDriveApiFp(this.configuration).getMSDriveItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MSListApi - axios parameter creator
 * @export
 */
export const MSListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of MSList resources.
         * @summary Retrieves the collection of MSList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSListCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/m_s_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a MSList resource.
         * @summary Retrieves a MSList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSListItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMSListItem', 'id', id)
            const localVarPath = `/api/m_s_lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MSListApi - functional programming interface
 * @export
 */
export const MSListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MSListApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of MSList resources.
         * @summary Retrieves the collection of MSList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMSListCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMSListCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a MSList resource.
         * @summary Retrieves a MSList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMSListItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MSListJsonldListRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMSListItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MSListApi - factory interface
 * @export
 */
export const MSListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MSListApiFp(configuration)
    return {
        /**
         * Retrieves the collection of MSList resources.
         * @summary Retrieves the collection of MSList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSListCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse20015> {
            return localVarFp.getMSListCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a MSList resource.
         * @summary Retrieves a MSList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMSListItem(id: string, options?: any): AxiosPromise<MSListJsonldListRead> {
            return localVarFp.getMSListItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MSListApi - object-oriented interface
 * @export
 * @class MSListApi
 * @extends {BaseAPI}
 */
export class MSListApi extends BaseAPI {
    /**
     * Retrieves the collection of MSList resources.
     * @summary Retrieves the collection of MSList resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MSListApi
     */
    public getMSListCollection(page?: number, itemsPerPage?: number, options?: any) {
        return MSListApiFp(this.configuration).getMSListCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a MSList resource.
     * @summary Retrieves a MSList resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MSListApi
     */
    public getMSListItem(id: string, options?: any) {
        return MSListApiFp(this.configuration).getMSListItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInCollaborationMediaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInCollaborationMediaItem', 'id', id)
            const localVarPath = `/api/media/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Media resources.
         * @summary Retrieves the collection of Media resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMediaItem', 'id', id)
            const localVarPath = `/api/media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Media resource.
         * @summary Creates a Media resource.
         * @param {any} [file] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMediaCollection: async (file?: any, title?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInCollaborationMediaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInCollaborationMediaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of Media resources.
         * @summary Retrieves the collection of Media resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaJsonldMediaObjectRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Media resource.
         * @summary Creates a Media resource.
         * @param {any} [file] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMediaCollection(file?: any, title?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaJsonldMediaObjectRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMediaCollection(file, title, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInCollaborationMediaItem(id: string, options?: any): AxiosPromise<MediaJsonld> {
            return localVarFp.getInCollaborationMediaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Media resources.
         * @summary Retrieves the collection of Media resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse20016> {
            return localVarFp.getMediaCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Media resource.
         * @summary Retrieves a Media resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaItem(id: string, options?: any): AxiosPromise<MediaJsonldMediaObjectRead> {
            return localVarFp.getMediaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Media resource.
         * @summary Creates a Media resource.
         * @param {any} [file] 
         * @param {string} [title] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMediaCollection(file?: any, title?: string, options?: any): AxiosPromise<MediaJsonldMediaObjectRead> {
            return localVarFp.postMediaCollection(file, title, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * Retrieves a Media resource.
     * @summary Retrieves a Media resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getInCollaborationMediaItem(id: string, options?: any) {
        return MediaApiFp(this.configuration).getInCollaborationMediaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Media resources.
     * @summary Retrieves the collection of Media resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getMediaCollection(page?: number, itemsPerPage?: number, options?: any) {
        return MediaApiFp(this.configuration).getMediaCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Media resource.
     * @summary Retrieves a Media resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getMediaItem(id: string, options?: any) {
        return MediaApiFp(this.configuration).getMediaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Media resource.
     * @summary Creates a Media resource.
     * @param {any} [file] 
     * @param {string} [title] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public postMediaCollection(file?: any, title?: string, options?: any) {
        return MediaApiFp(this.configuration).postMediaCollection(file, title, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Notification resources.
         * @summary Retrieves the collection of Notification resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCollection: async (page?: number, itemsPerPage?: number, orderDateCreated?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orderDateCreated !== undefined) {
                localVarQueryParameter['order[dateCreated]'] = orderDateCreated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Notification resource.
         * @summary Retrieves a Notification resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNotificationItem', 'id', id)
            const localVarPath = `/api/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if a user has any unread notifications.
         * @summary Checks if a user has any unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSeenStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationClearedNotificationItem: async (id: string, notificationJsonld: NotificationJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postNotificationClearedNotificationItem', 'id', id)
            // verify required parameter 'notificationJsonld' is not null or undefined
            assertParamExists('postNotificationClearedNotificationItem', 'notificationJsonld', notificationJsonld)
            const localVarPath = `/api/notifications/{id}/cleared`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationSeenNotificationItem: async (id: string, notificationJsonld: NotificationJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postNotificationSeenNotificationItem', 'id', id)
            // verify required parameter 'notificationJsonld' is not null or undefined
            assertParamExists('postNotificationSeenNotificationItem', 'notificationJsonld', notificationJsonld)
            const localVarPath = `/api/notifications/{id}/seen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationsClearedNotificationCollection: async (notificationJsonld: NotificationJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationJsonld' is not null or undefined
            assertParamExists('postNotificationsClearedNotificationCollection', 'notificationJsonld', notificationJsonld)
            const localVarPath = `/api/notifications/cleared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationsSeenNotificationCollection: async (notificationJsonld: NotificationJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationJsonld' is not null or undefined
            assertParamExists('postNotificationsSeenNotificationCollection', 'notificationJsonld', notificationJsonld)
            const localVarPath = `/api/notifications/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Notification resources.
         * @summary Retrieves the collection of Notification resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationCollection(page?: number, itemsPerPage?: number, orderDateCreated?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationCollection(page, itemsPerPage, orderDateCreated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Notification resource.
         * @summary Retrieves a Notification resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationJsonldNotificationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Checks if a user has any unread notifications.
         * @summary Checks if a user has any unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationSeenStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSeenStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationSeenStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNotificationClearedNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationJsonldNotificationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNotificationClearedNotificationItem(id, notificationJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNotificationSeenNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationJsonldNotificationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNotificationSeenNotificationItem(id, notificationJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNotificationsClearedNotificationCollection(notificationJsonld: NotificationJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationJsonldNotificationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNotificationsClearedNotificationCollection(notificationJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNotificationsSeenNotificationCollection(notificationJsonld: NotificationJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationJsonldNotificationRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNotificationsSeenNotificationCollection(notificationJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Notification resources.
         * @summary Retrieves the collection of Notification resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderDateCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCollection(page?: number, itemsPerPage?: number, orderDateCreated?: 'asc' | 'desc', options?: any): AxiosPromise<InlineResponse20017> {
            return localVarFp.getNotificationCollection(page, itemsPerPage, orderDateCreated, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Notification resource.
         * @summary Retrieves a Notification resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationItem(id: string, options?: any): AxiosPromise<NotificationJsonldNotificationRead> {
            return localVarFp.getNotificationItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if a user has any unread notifications.
         * @summary Checks if a user has any unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSeenStatus(options?: any): AxiosPromise<NotificationSeenStatus> {
            return localVarFp.getNotificationSeenStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationClearedNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any): AxiosPromise<NotificationJsonldNotificationRead> {
            return localVarFp.postNotificationClearedNotificationItem(id, notificationJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {string} id Resource identifier
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationSeenNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any): AxiosPromise<NotificationJsonldNotificationRead> {
            return localVarFp.postNotificationSeenNotificationItem(id, notificationJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationsClearedNotificationCollection(notificationJsonld: NotificationJsonld, options?: any): AxiosPromise<NotificationJsonldNotificationRead> {
            return localVarFp.postNotificationsClearedNotificationCollection(notificationJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Notification resource.
         * @summary Creates a Notification resource.
         * @param {NotificationJsonld} notificationJsonld The new Notification resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNotificationsSeenNotificationCollection(notificationJsonld: NotificationJsonld, options?: any): AxiosPromise<NotificationJsonldNotificationRead> {
            return localVarFp.postNotificationsSeenNotificationCollection(notificationJsonld, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * Retrieves the collection of Notification resources.
     * @summary Retrieves the collection of Notification resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {'asc' | 'desc'} [orderDateCreated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationCollection(page?: number, itemsPerPage?: number, orderDateCreated?: 'asc' | 'desc', options?: any) {
        return NotificationApiFp(this.configuration).getNotificationCollection(page, itemsPerPage, orderDateCreated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Notification resource.
     * @summary Retrieves a Notification resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationItem(id: string, options?: any) {
        return NotificationApiFp(this.configuration).getNotificationItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if a user has any unread notifications.
     * @summary Checks if a user has any unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationSeenStatus(options?: any) {
        return NotificationApiFp(this.configuration).getNotificationSeenStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notification resource.
     * @summary Creates a Notification resource.
     * @param {string} id Resource identifier
     * @param {NotificationJsonld} notificationJsonld The new Notification resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public postNotificationClearedNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any) {
        return NotificationApiFp(this.configuration).postNotificationClearedNotificationItem(id, notificationJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notification resource.
     * @summary Creates a Notification resource.
     * @param {string} id Resource identifier
     * @param {NotificationJsonld} notificationJsonld The new Notification resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public postNotificationSeenNotificationItem(id: string, notificationJsonld: NotificationJsonld, options?: any) {
        return NotificationApiFp(this.configuration).postNotificationSeenNotificationItem(id, notificationJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notification resource.
     * @summary Creates a Notification resource.
     * @param {NotificationJsonld} notificationJsonld The new Notification resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public postNotificationsClearedNotificationCollection(notificationJsonld: NotificationJsonld, options?: any) {
        return NotificationApiFp(this.configuration).postNotificationsClearedNotificationCollection(notificationJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Notification resource.
     * @summary Creates a Notification resource.
     * @param {NotificationJsonld} notificationJsonld The new Notification resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public postNotificationsSeenNotificationCollection(notificationJsonld: NotificationJsonld, options?: any) {
        return NotificationApiFp(this.configuration).postNotificationsSeenNotificationCollection(notificationJsonld, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplateFileApi - axios parameter creator
 * @export
 */
export const TemplateFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of TemplateFile resources.
         * @summary Retrieves the collection of TemplateFile resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFileCollection: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/template_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a TemplateFile resource.
         * @summary Retrieves a TemplateFile resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFileItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplateFileItem', 'id', id)
            const localVarPath = `/api/template_files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateFileApi - functional programming interface
 * @export
 */
export const TemplateFileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateFileApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of TemplateFile resources.
         * @summary Retrieves the collection of TemplateFile resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateFileCollection(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateFileCollection(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a TemplateFile resource.
         * @summary Retrieves a TemplateFile resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateFileItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateFileJsonldTemplateFileRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateFileItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateFileApi - factory interface
 * @export
 */
export const TemplateFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateFileApiFp(configuration)
    return {
        /**
         * Retrieves the collection of TemplateFile resources.
         * @summary Retrieves the collection of TemplateFile resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFileCollection(options?: any): AxiosPromise<InlineResponse20018> {
            return localVarFp.getTemplateFileCollection(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a TemplateFile resource.
         * @summary Retrieves a TemplateFile resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateFileItem(id: string, options?: any): AxiosPromise<TemplateFileJsonldTemplateFileRead> {
            return localVarFp.getTemplateFileItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateFileApi - object-oriented interface
 * @export
 * @class TemplateFileApi
 * @extends {BaseAPI}
 */
export class TemplateFileApi extends BaseAPI {
    /**
     * Retrieves the collection of TemplateFile resources.
     * @summary Retrieves the collection of TemplateFile resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFileApi
     */
    public getTemplateFileCollection(options?: any) {
        return TemplateFileApiFp(this.configuration).getTemplateFileCollection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a TemplateFile resource.
     * @summary Retrieves a TemplateFile resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFileApi
     */
    public getTemplateFileItem(id: string, options?: any) {
        return TemplateFileApiFp(this.configuration).getTemplateFileItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestApi - axios parameter creator
 * @export
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is for development only.
         * @summary This endpoint is for development only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCall: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 * @export
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is for development only.
         * @summary This endpoint is for development only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCall(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCall(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestApi - factory interface
 * @export
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         * This endpoint is for development only.
         * @summary This endpoint is for development only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCall(options?: any): AxiosPromise<void> {
            return localVarFp.testCall(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApi - object-oriented interface
 * @export
 * @class TestApi
 * @extends {BaseAPI}
 */
export class TestApi extends BaseAPI {
    /**
     * This endpoint is for development only.
     * @summary This endpoint is for development only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public testCall(options?: any) {
        return TestApiFp(this.configuration).testCall(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send a valid MS Office session token in the header under MSToken to authenticate with the API
         * @summary Get JWT token from a valid MS Office session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMSAuthentication: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * Send a valid MS Office session token in the header under MSToken to authenticate with the API
         * @summary Get JWT token from a valid MS Office session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMSAuthentication(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMSAuthentication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * Send a valid MS Office session token in the header under MSToken to authenticate with the API
         * @summary Get JWT token from a valid MS Office session token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMSAuthentication(options?: any): AxiosPromise<Token> {
            return localVarFp.postMSAuthentication(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * Send a valid MS Office session token in the header under MSToken to authenticate with the API
     * @summary Get JWT token from a valid MS Office session token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public postMSAuthentication(options?: any) {
        return TokenApiFp(this.configuration).postMSAuthentication(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrackingListApi - axios parameter creator
 * @export
 */
export const TrackingListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the TrackingList resource.
         * @summary Removes the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackingListItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTrackingListItem', 'id', id)
            const localVarPath = `/api/tracking_lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of TrackingList resources.
         * @summary Retrieves the collection of TrackingList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingListCollection: async (page?: number, itemsPerPage?: number, orderTitle?: 'asc' | 'desc', q?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tracking_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a TrackingList resource.
         * @summary Retrieves a TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingListItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrackingListItem', 'id', id)
            const localVarPath = `/api/tracking_lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the TrackingList resource.
         * @summary Updates the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {TrackingListTrackingListWrite} trackingListTrackingListWrite The updated TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrackingListItem: async (id: string, trackingListTrackingListWrite: TrackingListTrackingListWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTrackingListItem', 'id', id)
            // verify required parameter 'trackingListTrackingListWrite' is not null or undefined
            assertParamExists('patchTrackingListItem', 'trackingListTrackingListWrite', trackingListTrackingListWrite)
            const localVarPath = `/api/tracking_lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingListTrackingListWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a TrackingList resource.
         * @summary Creates a TrackingList resource.
         * @param {TrackingListJsonldTrackingListWrite} trackingListJsonldTrackingListWrite The new TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrackingListCollection: async (trackingListJsonldTrackingListWrite: TrackingListJsonldTrackingListWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackingListJsonldTrackingListWrite' is not null or undefined
            assertParamExists('postTrackingListCollection', 'trackingListJsonldTrackingListWrite', trackingListJsonldTrackingListWrite)
            const localVarPath = `/api/tracking_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingListJsonldTrackingListWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingListApi - functional programming interface
 * @export
 */
export const TrackingListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingListApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the TrackingList resource.
         * @summary Removes the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrackingListItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrackingListItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of TrackingList resources.
         * @summary Retrieves the collection of TrackingList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackingListCollection(page?: number, itemsPerPage?: number, orderTitle?: 'asc' | 'desc', q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackingListCollection(page, itemsPerPage, orderTitle, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a TrackingList resource.
         * @summary Retrieves a TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackingListItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingListJsonldTrackingListRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackingListItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the TrackingList resource.
         * @summary Updates the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {TrackingListTrackingListWrite} trackingListTrackingListWrite The updated TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTrackingListItem(id: string, trackingListTrackingListWrite: TrackingListTrackingListWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingListJsonldTrackingListRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTrackingListItem(id, trackingListTrackingListWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a TrackingList resource.
         * @summary Creates a TrackingList resource.
         * @param {TrackingListJsonldTrackingListWrite} trackingListJsonldTrackingListWrite The new TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTrackingListCollection(trackingListJsonldTrackingListWrite: TrackingListJsonldTrackingListWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingListJsonldTrackingListRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTrackingListCollection(trackingListJsonldTrackingListWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrackingListApi - factory interface
 * @export
 */
export const TrackingListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingListApiFp(configuration)
    return {
        /**
         * Removes the TrackingList resource.
         * @summary Removes the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackingListItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTrackingListItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of TrackingList resources.
         * @summary Retrieves the collection of TrackingList resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingListCollection(page?: number, itemsPerPage?: number, orderTitle?: 'asc' | 'desc', q?: string, options?: any): AxiosPromise<InlineResponse20019> {
            return localVarFp.getTrackingListCollection(page, itemsPerPage, orderTitle, q, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a TrackingList resource.
         * @summary Retrieves a TrackingList resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingListItem(id: string, options?: any): AxiosPromise<TrackingListJsonldTrackingListRead> {
            return localVarFp.getTrackingListItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the TrackingList resource.
         * @summary Updates the TrackingList resource.
         * @param {string} id Resource identifier
         * @param {TrackingListTrackingListWrite} trackingListTrackingListWrite The updated TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrackingListItem(id: string, trackingListTrackingListWrite: TrackingListTrackingListWrite, options?: any): AxiosPromise<TrackingListJsonldTrackingListRead> {
            return localVarFp.patchTrackingListItem(id, trackingListTrackingListWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a TrackingList resource.
         * @summary Creates a TrackingList resource.
         * @param {TrackingListJsonldTrackingListWrite} trackingListJsonldTrackingListWrite The new TrackingList resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrackingListCollection(trackingListJsonldTrackingListWrite: TrackingListJsonldTrackingListWrite, options?: any): AxiosPromise<TrackingListJsonldTrackingListRead> {
            return localVarFp.postTrackingListCollection(trackingListJsonldTrackingListWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackingListApi - object-oriented interface
 * @export
 * @class TrackingListApi
 * @extends {BaseAPI}
 */
export class TrackingListApi extends BaseAPI {
    /**
     * Removes the TrackingList resource.
     * @summary Removes the TrackingList resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingListApi
     */
    public deleteTrackingListItem(id: string, options?: any) {
        return TrackingListApiFp(this.configuration).deleteTrackingListItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of TrackingList resources.
     * @summary Retrieves the collection of TrackingList resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingListApi
     */
    public getTrackingListCollection(page?: number, itemsPerPage?: number, orderTitle?: 'asc' | 'desc', q?: string, options?: any) {
        return TrackingListApiFp(this.configuration).getTrackingListCollection(page, itemsPerPage, orderTitle, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a TrackingList resource.
     * @summary Retrieves a TrackingList resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingListApi
     */
    public getTrackingListItem(id: string, options?: any) {
        return TrackingListApiFp(this.configuration).getTrackingListItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the TrackingList resource.
     * @summary Updates the TrackingList resource.
     * @param {string} id Resource identifier
     * @param {TrackingListTrackingListWrite} trackingListTrackingListWrite The updated TrackingList resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingListApi
     */
    public patchTrackingListItem(id: string, trackingListTrackingListWrite: TrackingListTrackingListWrite, options?: any) {
        return TrackingListApiFp(this.configuration).patchTrackingListItem(id, trackingListTrackingListWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a TrackingList resource.
     * @summary Creates a TrackingList resource.
     * @param {TrackingListJsonldTrackingListWrite} trackingListJsonldTrackingListWrite The new TrackingList resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingListApi
     */
    public postTrackingListCollection(trackingListJsonldTrackingListWrite: TrackingListJsonldTrackingListWrite, options?: any) {
        return TrackingListApiFp(this.configuration).postTrackingListCollection(trackingListJsonldTrackingListWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [userUserGroupUserGroup] 
         * @param {Array<string>} [userUserGroupUserGroup2] 
         * @param {boolean} [active] 
         * @param {string} [c] 
         * @param {'asc' | 'desc'} [orderGivenName] 
         * @param {'asc' | 'desc'} [orderSurName] 
         * @param {'asc' | 'desc'} [orderEmail] 
         * @param {'asc' | 'desc'} [orderActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCollection: async (page?: number, itemsPerPage?: number, pagination?: boolean, userUserGroupUserGroup?: string, userUserGroupUserGroup2?: Array<string>, active?: boolean, c?: string, orderGivenName?: 'asc' | 'desc', orderSurName?: 'asc' | 'desc', orderEmail?: 'asc' | 'desc', orderActive?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (userUserGroupUserGroup !== undefined) {
                localVarQueryParameter['UserUserGroup.userGroup'] = userUserGroupUserGroup;
            }

            if (userUserGroupUserGroup2) {
                localVarQueryParameter['UserUserGroup.userGroup[]'] = userUserGroupUserGroup2;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (c !== undefined) {
                localVarQueryParameter['c'] = c;
            }

            if (orderGivenName !== undefined) {
                localVarQueryParameter['order[givenName]'] = orderGivenName;
            }

            if (orderSurName !== undefined) {
                localVarQueryParameter['order[surName]'] = orderSurName;
            }

            if (orderEmail !== undefined) {
                localVarQueryParameter['order[email]'] = orderEmail;
            }

            if (orderActive !== undefined) {
                localVarQueryParameter['order[active]'] = orderActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserItem', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {string} id Resource identifier
         * @param {UserUserWrite} userUserWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserItem: async (id: string, userUserWrite: UserUserWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserItem', 'id', id)
            // verify required parameter 'userUserWrite' is not null or undefined
            assertParamExists('patchUserItem', 'userUserWrite', userUserWrite)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUserWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postActivateUserUserItem: async (id: string, userJsonld: UserJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postActivateUserUserItem', 'id', id)
            // verify required parameter 'userJsonld' is not null or undefined
            assertParamExists('postActivateUserUserItem', 'userJsonld', userJsonld)
            const localVarPath = `/api/users/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDeactivateUserUserItem: async (id: string, userJsonld: UserJsonld, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postDeactivateUserUserItem', 'id', id)
            // verify required parameter 'userJsonld' is not null or undefined
            assertParamExists('postDeactivateUserUserItem', 'userJsonld', userJsonld)
            const localVarPath = `/api/users/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserJsonldUserInviteExternal} userJsonldUserInviteExternal The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInviteUserUserCollection: async (userJsonldUserInviteExternal: UserJsonldUserInviteExternal, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userJsonldUserInviteExternal' is not null or undefined
            assertParamExists('postInviteUserUserCollection', 'userJsonldUserInviteExternal', userJsonldUserInviteExternal)
            const localVarPath = `/api/users/invite/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userJsonldUserInviteExternal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [userUserGroupUserGroup] 
         * @param {Array<string>} [userUserGroupUserGroup2] 
         * @param {boolean} [active] 
         * @param {string} [c] 
         * @param {'asc' | 'desc'} [orderGivenName] 
         * @param {'asc' | 'desc'} [orderSurName] 
         * @param {'asc' | 'desc'} [orderEmail] 
         * @param {'asc' | 'desc'} [orderActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCollection(page?: number, itemsPerPage?: number, pagination?: boolean, userUserGroupUserGroup?: string, userUserGroupUserGroup2?: Array<string>, active?: boolean, c?: string, orderGivenName?: 'asc' | 'desc', orderSurName?: 'asc' | 'desc', orderEmail?: 'asc' | 'desc', orderActive?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20023>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCollection(page, itemsPerPage, pagination, userUserGroupUserGroup, userUserGroupUserGroup2, active, c, orderGivenName, orderSurName, orderEmail, orderActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonldUserRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {string} id Resource identifier
         * @param {UserUserWrite} userUserWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserItem(id: string, userUserWrite: UserUserWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonldUserRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserItem(id, userUserWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postActivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postActivateUserUserItem(id, userJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDeactivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonldDocumentRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDeactivateUserUserItem(id, userJsonld, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserJsonldUserInviteExternal} userJsonldUserInviteExternal The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInviteUserUserCollection(userJsonldUserInviteExternal: UserJsonldUserInviteExternal, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInviteUserUserCollection(userJsonldUserInviteExternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [userUserGroupUserGroup] 
         * @param {Array<string>} [userUserGroupUserGroup2] 
         * @param {boolean} [active] 
         * @param {string} [c] 
         * @param {'asc' | 'desc'} [orderGivenName] 
         * @param {'asc' | 'desc'} [orderSurName] 
         * @param {'asc' | 'desc'} [orderEmail] 
         * @param {'asc' | 'desc'} [orderActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCollection(page?: number, itemsPerPage?: number, pagination?: boolean, userUserGroupUserGroup?: string, userUserGroupUserGroup2?: Array<string>, active?: boolean, c?: string, orderGivenName?: 'asc' | 'desc', orderSurName?: 'asc' | 'desc', orderEmail?: 'asc' | 'desc', orderActive?: 'asc' | 'desc', options?: any): AxiosPromise<InlineResponse20023> {
            return localVarFp.getUserCollection(page, itemsPerPage, pagination, userUserGroupUserGroup, userUserGroupUserGroup2, active, c, orderGivenName, orderSurName, orderEmail, orderActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserItem(id: string, options?: any): AxiosPromise<UserJsonldUserRead> {
            return localVarFp.getUserItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the User resource.
         * @summary Updates the User resource.
         * @param {string} id Resource identifier
         * @param {UserUserWrite} userUserWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserItem(id: string, userUserWrite: UserUserWrite, options?: any): AxiosPromise<UserJsonldUserRead> {
            return localVarFp.patchUserItem(id, userUserWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postActivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any): AxiosPromise<UserJsonldDocumentRead> {
            return localVarFp.postActivateUserUserItem(id, userJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {string} id Resource identifier
         * @param {UserJsonld} userJsonld The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDeactivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any): AxiosPromise<UserJsonldDocumentRead> {
            return localVarFp.postDeactivateUserUserItem(id, userJsonld, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserJsonldUserInviteExternal} userJsonldUserInviteExternal The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInviteUserUserCollection(userJsonldUserInviteExternal: UserJsonldUserInviteExternal, options?: any): AxiosPromise<UserJsonld> {
            return localVarFp.postInviteUserUserCollection(userJsonldUserInviteExternal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Retrieves the collection of User resources.
     * @summary Retrieves the collection of User resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {string} [userUserGroupUserGroup] 
     * @param {Array<string>} [userUserGroupUserGroup2] 
     * @param {boolean} [active] 
     * @param {string} [c] 
     * @param {'asc' | 'desc'} [orderGivenName] 
     * @param {'asc' | 'desc'} [orderSurName] 
     * @param {'asc' | 'desc'} [orderEmail] 
     * @param {'asc' | 'desc'} [orderActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserCollection(page?: number, itemsPerPage?: number, pagination?: boolean, userUserGroupUserGroup?: string, userUserGroupUserGroup2?: Array<string>, active?: boolean, c?: string, orderGivenName?: 'asc' | 'desc', orderSurName?: 'asc' | 'desc', orderEmail?: 'asc' | 'desc', orderActive?: 'asc' | 'desc', options?: any) {
        return UserApiFp(this.configuration).getUserCollection(page, itemsPerPage, pagination, userUserGroupUserGroup, userUserGroupUserGroup2, active, c, orderGivenName, orderSurName, orderEmail, orderActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a User resource.
     * @summary Retrieves a User resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserItem(id: string, options?: any) {
        return UserApiFp(this.configuration).getUserItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the User resource.
     * @summary Updates the User resource.
     * @param {string} id Resource identifier
     * @param {UserUserWrite} userUserWrite The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public patchUserItem(id: string, userUserWrite: UserUserWrite, options?: any) {
        return UserApiFp(this.configuration).patchUserItem(id, userUserWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {string} id Resource identifier
     * @param {UserJsonld} userJsonld The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postActivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any) {
        return UserApiFp(this.configuration).postActivateUserUserItem(id, userJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {string} id Resource identifier
     * @param {UserJsonld} userJsonld The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postDeactivateUserUserItem(id: string, userJsonld: UserJsonld, options?: any) {
        return UserApiFp(this.configuration).postDeactivateUserUserItem(id, userJsonld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserJsonldUserInviteExternal} userJsonldUserInviteExternal The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postInviteUserUserCollection(userJsonldUserInviteExternal: UserJsonldUserInviteExternal, options?: any) {
        return UserApiFp(this.configuration).postInviteUserUserCollection(userJsonldUserInviteExternal, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupApi - axios parameter creator
 * @export
 */
export const UserGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of UserGroup resources.
         * @summary Retrieves the collection of UserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupCollection: async (page?: number, itemsPerPage?: number, q?: string, isActive?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a UserGroup resource.
         * @summary Retrieves a UserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserGroupItem', 'id', id)
            const localVarPath = `/api/user_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the UserGroup resource.
         * @summary Updates the UserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserGroupUserGroupWrite} userGroupUserGroupWrite The updated UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserGroupItem: async (id: string, userGroupUserGroupWrite: UserGroupUserGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserGroupItem', 'id', id)
            // verify required parameter 'userGroupUserGroupWrite' is not null or undefined
            assertParamExists('patchUserGroupItem', 'userGroupUserGroupWrite', userGroupUserGroupWrite)
            const localVarPath = `/api/user_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupUserGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a UserGroup resource.
         * @summary Creates a UserGroup resource.
         * @param {UserGroupJsonldUserGroupWrite} userGroupJsonldUserGroupWrite The new UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserGroupCollection: async (userGroupJsonldUserGroupWrite: UserGroupJsonldUserGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userGroupJsonldUserGroupWrite' is not null or undefined
            assertParamExists('postUserGroupCollection', 'userGroupJsonldUserGroupWrite', userGroupJsonldUserGroupWrite)
            const localVarPath = `/api/user_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupJsonldUserGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupApi - functional programming interface
 * @export
 */
export const UserGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of UserGroup resources.
         * @summary Retrieves the collection of UserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupCollection(page?: number, itemsPerPage?: number, q?: string, isActive?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupCollection(page, itemsPerPage, q, isActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a UserGroup resource.
         * @summary Retrieves a UserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupJsonldUserGroupReadDetailUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the UserGroup resource.
         * @summary Updates the UserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserGroupUserGroupWrite} userGroupUserGroupWrite The updated UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserGroupItem(id: string, userGroupUserGroupWrite: UserGroupUserGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupJsonldUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserGroupItem(id, userGroupUserGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a UserGroup resource.
         * @summary Creates a UserGroup resource.
         * @param {UserGroupJsonldUserGroupWrite} userGroupJsonldUserGroupWrite The new UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserGroupCollection(userGroupJsonldUserGroupWrite: UserGroupJsonldUserGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupJsonldUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserGroupCollection(userGroupJsonldUserGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupApi - factory interface
 * @export
 */
export const UserGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupApiFp(configuration)
    return {
        /**
         * Retrieves the collection of UserGroup resources.
         * @summary Retrieves the collection of UserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupCollection(page?: number, itemsPerPage?: number, q?: string, isActive?: boolean, options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.getUserGroupCollection(page, itemsPerPage, q, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a UserGroup resource.
         * @summary Retrieves a UserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupItem(id: string, options?: any): AxiosPromise<UserGroupJsonldUserGroupReadDetailUserGroupRead> {
            return localVarFp.getUserGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the UserGroup resource.
         * @summary Updates the UserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserGroupUserGroupWrite} userGroupUserGroupWrite The updated UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserGroupItem(id: string, userGroupUserGroupWrite: UserGroupUserGroupWrite, options?: any): AxiosPromise<UserGroupJsonldUserGroupRead> {
            return localVarFp.patchUserGroupItem(id, userGroupUserGroupWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a UserGroup resource.
         * @summary Creates a UserGroup resource.
         * @param {UserGroupJsonldUserGroupWrite} userGroupJsonldUserGroupWrite The new UserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserGroupCollection(userGroupJsonldUserGroupWrite: UserGroupJsonldUserGroupWrite, options?: any): AxiosPromise<UserGroupJsonldUserGroupRead> {
            return localVarFp.postUserGroupCollection(userGroupJsonldUserGroupWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupApi - object-oriented interface
 * @export
 * @class UserGroupApi
 * @extends {BaseAPI}
 */
export class UserGroupApi extends BaseAPI {
    /**
     * Retrieves the collection of UserGroup resources.
     * @summary Retrieves the collection of UserGroup resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [q] 
     * @param {boolean} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApi
     */
    public getUserGroupCollection(page?: number, itemsPerPage?: number, q?: string, isActive?: boolean, options?: any) {
        return UserGroupApiFp(this.configuration).getUserGroupCollection(page, itemsPerPage, q, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a UserGroup resource.
     * @summary Retrieves a UserGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApi
     */
    public getUserGroupItem(id: string, options?: any) {
        return UserGroupApiFp(this.configuration).getUserGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the UserGroup resource.
     * @summary Updates the UserGroup resource.
     * @param {string} id Resource identifier
     * @param {UserGroupUserGroupWrite} userGroupUserGroupWrite The updated UserGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApi
     */
    public patchUserGroupItem(id: string, userGroupUserGroupWrite: UserGroupUserGroupWrite, options?: any) {
        return UserGroupApiFp(this.configuration).patchUserGroupItem(id, userGroupUserGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a UserGroup resource.
     * @summary Creates a UserGroup resource.
     * @param {UserGroupJsonldUserGroupWrite} userGroupJsonldUserGroupWrite The new UserGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApi
     */
    public postUserGroupCollection(userGroupJsonldUserGroupWrite: UserGroupJsonldUserGroupWrite, options?: any) {
        return UserGroupApiFp(this.configuration).postUserGroupCollection(userGroupJsonldUserGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupTypeApi - axios parameter creator
 * @export
 */
export const UserGroupTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the UserGroupType resource.
         * @summary Removes the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGroupTypeItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserGroupTypeItem', 'id', id)
            const localVarPath = `/api/user_group_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of UserGroupType resources.
         * @summary Retrieves the collection of UserGroupType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupTypeCollection: async (page?: number, itemsPerPage?: number, q?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_group_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a UserGroupType resource.
         * @summary Retrieves a UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupTypeItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserGroupTypeItem', 'id', id)
            const localVarPath = `/api/user_group_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the UserGroupType resource.
         * @summary Updates the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {UserGroupTypeUserGroupTypeWrite} userGroupTypeUserGroupTypeWrite The updated UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserGroupTypeItem: async (id: string, userGroupTypeUserGroupTypeWrite: UserGroupTypeUserGroupTypeWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserGroupTypeItem', 'id', id)
            // verify required parameter 'userGroupTypeUserGroupTypeWrite' is not null or undefined
            assertParamExists('patchUserGroupTypeItem', 'userGroupTypeUserGroupTypeWrite', userGroupTypeUserGroupTypeWrite)
            const localVarPath = `/api/user_group_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupTypeUserGroupTypeWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a UserGroupType resource.
         * @summary Creates a UserGroupType resource.
         * @param {UserGroupTypeJsonldUserGroupTypeWrite} userGroupTypeJsonldUserGroupTypeWrite The new UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserGroupTypeCollection: async (userGroupTypeJsonldUserGroupTypeWrite: UserGroupTypeJsonldUserGroupTypeWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userGroupTypeJsonldUserGroupTypeWrite' is not null or undefined
            assertParamExists('postUserGroupTypeCollection', 'userGroupTypeJsonldUserGroupTypeWrite', userGroupTypeJsonldUserGroupTypeWrite)
            const localVarPath = `/api/user_group_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupTypeJsonldUserGroupTypeWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupTypeApi - functional programming interface
 * @export
 */
export const UserGroupTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the UserGroupType resource.
         * @summary Removes the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserGroupTypeItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserGroupTypeItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of UserGroupType resources.
         * @summary Retrieves the collection of UserGroupType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupTypeCollection(page?: number, itemsPerPage?: number, q?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupTypeCollection(page, itemsPerPage, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a UserGroupType resource.
         * @summary Retrieves a UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroupTypeItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroupTypeItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the UserGroupType resource.
         * @summary Updates the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {UserGroupTypeUserGroupTypeWrite} userGroupTypeUserGroupTypeWrite The updated UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserGroupTypeItem(id: string, userGroupTypeUserGroupTypeWrite: UserGroupTypeUserGroupTypeWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserGroupTypeItem(id, userGroupTypeUserGroupTypeWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a UserGroupType resource.
         * @summary Creates a UserGroupType resource.
         * @param {UserGroupTypeJsonldUserGroupTypeWrite} userGroupTypeJsonldUserGroupTypeWrite The new UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite: UserGroupTypeJsonldUserGroupTypeWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupTypeApi - factory interface
 * @export
 */
export const UserGroupTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupTypeApiFp(configuration)
    return {
        /**
         * Removes the UserGroupType resource.
         * @summary Removes the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGroupTypeItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserGroupTypeItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of UserGroupType resources.
         * @summary Retrieves the collection of UserGroupType resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupTypeCollection(page?: number, itemsPerPage?: number, q?: string, options?: any): AxiosPromise<InlineResponse20020> {
            return localVarFp.getUserGroupTypeCollection(page, itemsPerPage, q, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a UserGroupType resource.
         * @summary Retrieves a UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupTypeItem(id: string, options?: any): AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead> {
            return localVarFp.getUserGroupTypeItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the UserGroupType resource.
         * @summary Updates the UserGroupType resource.
         * @param {string} id Resource identifier
         * @param {UserGroupTypeUserGroupTypeWrite} userGroupTypeUserGroupTypeWrite The updated UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserGroupTypeItem(id: string, userGroupTypeUserGroupTypeWrite: UserGroupTypeUserGroupTypeWrite, options?: any): AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead> {
            return localVarFp.patchUserGroupTypeItem(id, userGroupTypeUserGroupTypeWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a UserGroupType resource.
         * @summary Creates a UserGroupType resource.
         * @param {UserGroupTypeJsonldUserGroupTypeWrite} userGroupTypeJsonldUserGroupTypeWrite The new UserGroupType resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite: UserGroupTypeJsonldUserGroupTypeWrite, options?: any): AxiosPromise<UserGroupTypeJsonldUserGroupTypeRead> {
            return localVarFp.postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupTypeApi - object-oriented interface
 * @export
 * @class UserGroupTypeApi
 * @extends {BaseAPI}
 */
export class UserGroupTypeApi extends BaseAPI {
    /**
     * Removes the UserGroupType resource.
     * @summary Removes the UserGroupType resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupTypeApi
     */
    public deleteUserGroupTypeItem(id: string, options?: any) {
        return UserGroupTypeApiFp(this.configuration).deleteUserGroupTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of UserGroupType resources.
     * @summary Retrieves the collection of UserGroupType resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupTypeApi
     */
    public getUserGroupTypeCollection(page?: number, itemsPerPage?: number, q?: string, options?: any) {
        return UserGroupTypeApiFp(this.configuration).getUserGroupTypeCollection(page, itemsPerPage, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a UserGroupType resource.
     * @summary Retrieves a UserGroupType resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupTypeApi
     */
    public getUserGroupTypeItem(id: string, options?: any) {
        return UserGroupTypeApiFp(this.configuration).getUserGroupTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the UserGroupType resource.
     * @summary Updates the UserGroupType resource.
     * @param {string} id Resource identifier
     * @param {UserGroupTypeUserGroupTypeWrite} userGroupTypeUserGroupTypeWrite The updated UserGroupType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupTypeApi
     */
    public patchUserGroupTypeItem(id: string, userGroupTypeUserGroupTypeWrite: UserGroupTypeUserGroupTypeWrite, options?: any) {
        return UserGroupTypeApiFp(this.configuration).patchUserGroupTypeItem(id, userGroupTypeUserGroupTypeWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a UserGroupType resource.
     * @summary Creates a UserGroupType resource.
     * @param {UserGroupTypeJsonldUserGroupTypeWrite} userGroupTypeJsonldUserGroupTypeWrite The new UserGroupType resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupTypeApi
     */
    public postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite: UserGroupTypeJsonldUserGroupTypeWrite, options?: any) {
        return UserGroupTypeApiFp(this.configuration).postUserGroupTypeCollection(userGroupTypeJsonldUserGroupTypeWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserSettingsApi - axios parameter creator
 * @export
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a UserSettings resource.
         * @summary Retrieves a UserSettings resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettingsItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserSettingsItem', 'id', id)
            const localVarPath = `/api/user_settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the UserSettings resource.
         * @summary Updates the UserSettings resource.
         * @param {string} id Resource identifier
         * @param {UserSettingsUserSettingsWrite} userSettingsUserSettingsWrite The updated UserSettings resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserSettingsItem: async (id: string, userSettingsUserSettingsWrite: UserSettingsUserSettingsWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserSettingsItem', 'id', id)
            // verify required parameter 'userSettingsUserSettingsWrite' is not null or undefined
            assertParamExists('patchUserSettingsItem', 'userSettingsUserSettingsWrite', userSettingsUserSettingsWrite)
            const localVarPath = `/api/user_settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSettingsUserSettingsWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsApi - functional programming interface
 * @export
 */
export const UserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a UserSettings resource.
         * @summary Retrieves a UserSettings resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSettingsItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsJsonldUserSettingsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettingsItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the UserSettings resource.
         * @summary Updates the UserSettings resource.
         * @param {string} id Resource identifier
         * @param {UserSettingsUserSettingsWrite} userSettingsUserSettingsWrite The updated UserSettings resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserSettingsItem(id: string, userSettingsUserSettingsWrite: UserSettingsUserSettingsWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsJsonldUserSettingsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserSettingsItem(id, userSettingsUserSettingsWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserSettingsApi - factory interface
 * @export
 */
export const UserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsApiFp(configuration)
    return {
        /**
         * Retrieves a UserSettings resource.
         * @summary Retrieves a UserSettings resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettingsItem(id: string, options?: any): AxiosPromise<UserSettingsJsonldUserSettingsRead> {
            return localVarFp.getUserSettingsItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the UserSettings resource.
         * @summary Updates the UserSettings resource.
         * @param {string} id Resource identifier
         * @param {UserSettingsUserSettingsWrite} userSettingsUserSettingsWrite The updated UserSettings resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserSettingsItem(id: string, userSettingsUserSettingsWrite: UserSettingsUserSettingsWrite, options?: any): AxiosPromise<UserSettingsJsonldUserSettingsRead> {
            return localVarFp.patchUserSettingsItem(id, userSettingsUserSettingsWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsApi - object-oriented interface
 * @export
 * @class UserSettingsApi
 * @extends {BaseAPI}
 */
export class UserSettingsApi extends BaseAPI {
    /**
     * Retrieves a UserSettings resource.
     * @summary Retrieves a UserSettings resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public getUserSettingsItem(id: string, options?: any) {
        return UserSettingsApiFp(this.configuration).getUserSettingsItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the UserSettings resource.
     * @summary Updates the UserSettings resource.
     * @param {string} id Resource identifier
     * @param {UserSettingsUserSettingsWrite} userSettingsUserSettingsWrite The updated UserSettings resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsApi
     */
    public patchUserSettingsItem(id: string, userSettingsUserSettingsWrite: UserSettingsUserSettingsWrite, options?: any) {
        return UserSettingsApiFp(this.configuration).patchUserSettingsItem(id, userSettingsUserSettingsWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserUserGroupApi - axios parameter creator
 * @export
 */
export const UserUserGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the UserUserGroup resource.
         * @summary Removes the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUserGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserUserGroupItem', 'id', id)
            const localVarPath = `/api/user_user_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of UserUserGroup resources.
         * @summary Retrieves the collection of UserUserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGroupCollection: async (page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_user_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (userGroup !== undefined) {
                localVarQueryParameter['userGroup'] = userGroup;
            }

            if (userGroup2) {
                localVarQueryParameter['userGroup[]'] = userGroup2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a UserUserGroup resource.
         * @summary Retrieves a UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserUserGroupItem', 'id', id)
            const localVarPath = `/api/user_user_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the UserUserGroup resource.
         * @summary Updates the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserUserGroupUserUserGroupPatch} userUserGroupUserUserGroupPatch The updated UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserUserGroupItem: async (id: string, userUserGroupUserUserGroupPatch: UserUserGroupUserUserGroupPatch, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserUserGroupItem', 'id', id)
            // verify required parameter 'userUserGroupUserUserGroupPatch' is not null or undefined
            assertParamExists('patchUserUserGroupItem', 'userUserGroupUserUserGroupPatch', userUserGroupUserUserGroupPatch)
            const localVarPath = `/api/user_user_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUserGroupUserUserGroupPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a UserUserGroup resource.
         * @summary Creates a UserUserGroup resource.
         * @param {UserUserGroupJsonldUserUserGroupWrite} userUserGroupJsonldUserUserGroupWrite The new UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUserGroupCollection: async (userUserGroupJsonldUserUserGroupWrite: UserUserGroupJsonldUserUserGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUserGroupJsonldUserUserGroupWrite' is not null or undefined
            assertParamExists('postUserUserGroupCollection', 'userUserGroupJsonldUserUserGroupWrite', userUserGroupJsonldUserUserGroupWrite)
            const localVarPath = `/api/user_user_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUserGroupJsonldUserUserGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserUserGroupApi - functional programming interface
 * @export
 */
export const UserUserGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserUserGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the UserUserGroup resource.
         * @summary Removes the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserUserGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserUserGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of UserUserGroup resources.
         * @summary Retrieves the collection of UserUserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserUserGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserUserGroupCollection(page, itemsPerPage, userGroup, userGroup2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a UserUserGroup resource.
         * @summary Retrieves a UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserUserGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserGroupJsonldUserUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserUserGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the UserUserGroup resource.
         * @summary Updates the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserUserGroupUserUserGroupPatch} userUserGroupUserUserGroupPatch The updated UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserUserGroupItem(id: string, userUserGroupUserUserGroupPatch: UserUserGroupUserUserGroupPatch, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserGroupJsonldUserUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserUserGroupItem(id, userUserGroupUserUserGroupPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a UserUserGroup resource.
         * @summary Creates a UserUserGroup resource.
         * @param {UserUserGroupJsonldUserUserGroupWrite} userUserGroupJsonldUserUserGroupWrite The new UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite: UserUserGroupJsonldUserUserGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserGroupJsonldUserUserGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserUserGroupApi - factory interface
 * @export
 */
export const UserUserGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserUserGroupApiFp(configuration)
    return {
        /**
         * Removes the UserUserGroup resource.
         * @summary Removes the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUserGroupItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserUserGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of UserUserGroup resources.
         * @summary Retrieves the collection of UserUserGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, options?: any): AxiosPromise<InlineResponse20022> {
            return localVarFp.getUserUserGroupCollection(page, itemsPerPage, userGroup, userGroup2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a UserUserGroup resource.
         * @summary Retrieves a UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserGroupItem(id: string, options?: any): AxiosPromise<UserUserGroupJsonldUserUserGroupRead> {
            return localVarFp.getUserUserGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the UserUserGroup resource.
         * @summary Updates the UserUserGroup resource.
         * @param {string} id Resource identifier
         * @param {UserUserGroupUserUserGroupPatch} userUserGroupUserUserGroupPatch The updated UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserUserGroupItem(id: string, userUserGroupUserUserGroupPatch: UserUserGroupUserUserGroupPatch, options?: any): AxiosPromise<UserUserGroupJsonldUserUserGroupRead> {
            return localVarFp.patchUserUserGroupItem(id, userUserGroupUserUserGroupPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a UserUserGroup resource.
         * @summary Creates a UserUserGroup resource.
         * @param {UserUserGroupJsonldUserUserGroupWrite} userUserGroupJsonldUserUserGroupWrite The new UserUserGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite: UserUserGroupJsonldUserUserGroupWrite, options?: any): AxiosPromise<UserUserGroupJsonldUserUserGroupRead> {
            return localVarFp.postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserUserGroupApi - object-oriented interface
 * @export
 * @class UserUserGroupApi
 * @extends {BaseAPI}
 */
export class UserUserGroupApi extends BaseAPI {
    /**
     * Removes the UserUserGroup resource.
     * @summary Removes the UserUserGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUserGroupApi
     */
    public deleteUserUserGroupItem(id: string, options?: any) {
        return UserUserGroupApiFp(this.configuration).deleteUserUserGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of UserUserGroup resources.
     * @summary Retrieves the collection of UserUserGroup resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [userGroup] 
     * @param {Array<string>} [userGroup2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUserGroupApi
     */
    public getUserUserGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, options?: any) {
        return UserUserGroupApiFp(this.configuration).getUserUserGroupCollection(page, itemsPerPage, userGroup, userGroup2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a UserUserGroup resource.
     * @summary Retrieves a UserUserGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUserGroupApi
     */
    public getUserUserGroupItem(id: string, options?: any) {
        return UserUserGroupApiFp(this.configuration).getUserUserGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the UserUserGroup resource.
     * @summary Updates the UserUserGroup resource.
     * @param {string} id Resource identifier
     * @param {UserUserGroupUserUserGroupPatch} userUserGroupUserUserGroupPatch The updated UserUserGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUserGroupApi
     */
    public patchUserUserGroupItem(id: string, userUserGroupUserUserGroupPatch: UserUserGroupUserUserGroupPatch, options?: any) {
        return UserUserGroupApiFp(this.configuration).patchUserUserGroupItem(id, userUserGroupUserUserGroupPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a UserUserGroup resource.
     * @summary Creates a UserUserGroup resource.
     * @param {UserUserGroupJsonldUserUserGroupWrite} userUserGroupJsonldUserUserGroupWrite The new UserUserGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUserGroupApi
     */
    public postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite: UserUserGroupJsonldUserUserGroupWrite, options?: any) {
        return UserUserGroupApiFp(this.configuration).postUserUserGroupCollection(userUserGroupJsonldUserUserGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowApi - axios parameter creator
 * @export
 */
export const WorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Workflow resources.
         * @summary Retrieves the collection of Workflow resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowCollection: async (page?: number, itemsPerPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workflows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Workflow resource.
         * @summary Retrieves a Workflow resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowItem', 'id', id)
            const localVarPath = `/api/workflows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowApi - functional programming interface
 * @export
 */
export const WorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Workflow resources.
         * @summary Retrieves the collection of Workflow resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowCollection(page?: number, itemsPerPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowCollection(page, itemsPerPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a Workflow resource.
         * @summary Retrieves a Workflow resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowJsonldWorkflowRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowApi - factory interface
 * @export
 */
export const WorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Workflow resources.
         * @summary Retrieves the collection of Workflow resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowCollection(page?: number, itemsPerPage?: number, options?: any): AxiosPromise<InlineResponse20026> {
            return localVarFp.getWorkflowCollection(page, itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Workflow resource.
         * @summary Retrieves a Workflow resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowItem(id: string, options?: any): AxiosPromise<WorkflowJsonldWorkflowRead> {
            return localVarFp.getWorkflowItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowApi - object-oriented interface
 * @export
 * @class WorkflowApi
 * @extends {BaseAPI}
 */
export class WorkflowApi extends BaseAPI {
    /**
     * Retrieves the collection of Workflow resources.
     * @summary Retrieves the collection of Workflow resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    public getWorkflowCollection(page?: number, itemsPerPage?: number, options?: any) {
        return WorkflowApiFp(this.configuration).getWorkflowCollection(page, itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Workflow resource.
     * @summary Retrieves a Workflow resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    public getWorkflowItem(id: string, options?: any) {
        return WorkflowApiFp(this.configuration).getWorkflowItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowGroupApi - axios parameter creator
 * @export
 */
export const WorkflowGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the WorkflowGroup resource.
         * @summary Removes the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkflowGroupItem', 'id', id)
            const localVarPath = `/api/workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of WorkflowGroup resources.
         * @summary Retrieves the collection of WorkflowGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {string} [title] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {boolean} [critical] 
         * @param {boolean} [isStandardList] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderCritical] 
         * @param {'asc' | 'desc'} [orderIsStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowGroupCollection: async (page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, userGroupType?: string, userGroupType2?: Array<string>, title?: string, workflowType?: string, workflowType2?: Array<string>, critical?: boolean, isStandardList?: boolean, orderTitle?: 'asc' | 'desc', orderCritical?: 'asc' | 'desc', orderIsStandardList?: 'asc' | 'desc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workflow_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (userGroup !== undefined) {
                localVarQueryParameter['userGroup'] = userGroup;
            }

            if (userGroup2) {
                localVarQueryParameter['userGroup[]'] = userGroup2;
            }

            if (userGroupType !== undefined) {
                localVarQueryParameter['userGroupType'] = userGroupType;
            }

            if (userGroupType2) {
                localVarQueryParameter['userGroupType[]'] = userGroupType2;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (workflowType !== undefined) {
                localVarQueryParameter['workflowType'] = workflowType;
            }

            if (workflowType2) {
                localVarQueryParameter['workflowType[]'] = workflowType2;
            }

            if (critical !== undefined) {
                localVarQueryParameter['critical'] = critical;
            }

            if (isStandardList !== undefined) {
                localVarQueryParameter['isStandardList'] = isStandardList;
            }

            if (orderTitle !== undefined) {
                localVarQueryParameter['order[title]'] = orderTitle;
            }

            if (orderCritical !== undefined) {
                localVarQueryParameter['order[critical]'] = orderCritical;
            }

            if (orderIsStandardList !== undefined) {
                localVarQueryParameter['order[isStandardList]'] = orderIsStandardList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a WorkflowGroup resource.
         * @summary Retrieves a WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowGroupItem', 'id', id)
            const localVarPath = `/api/workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the WorkflowGroup resource.
         * @summary Updates the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {WorkflowGroupWorkflowGroupWrite} workflowGroupWorkflowGroupWrite The updated WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowGroupItem: async (id: string, workflowGroupWorkflowGroupWrite: WorkflowGroupWorkflowGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchWorkflowGroupItem', 'id', id)
            // verify required parameter 'workflowGroupWorkflowGroupWrite' is not null or undefined
            assertParamExists('patchWorkflowGroupItem', 'workflowGroupWorkflowGroupWrite', workflowGroupWorkflowGroupWrite)
            const localVarPath = `/api/workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowGroupWorkflowGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a WorkflowGroup resource.
         * @summary Creates a WorkflowGroup resource.
         * @param {WorkflowGroupJsonldWorkflowGroupWrite} workflowGroupJsonldWorkflowGroupWrite The new WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowGroupCollection: async (workflowGroupJsonldWorkflowGroupWrite: WorkflowGroupJsonldWorkflowGroupWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowGroupJsonldWorkflowGroupWrite' is not null or undefined
            assertParamExists('postWorkflowGroupCollection', 'workflowGroupJsonldWorkflowGroupWrite', workflowGroupJsonldWorkflowGroupWrite)
            const localVarPath = `/api/workflow_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowGroupJsonldWorkflowGroupWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowGroupApi - functional programming interface
 * @export
 */
export const WorkflowGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the WorkflowGroup resource.
         * @summary Removes the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkflowGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkflowGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of WorkflowGroup resources.
         * @summary Retrieves the collection of WorkflowGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {string} [title] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {boolean} [critical] 
         * @param {boolean} [isStandardList] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderCritical] 
         * @param {'asc' | 'desc'} [orderIsStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, userGroupType?: string, userGroupType2?: Array<string>, title?: string, workflowType?: string, workflowType2?: Array<string>, critical?: boolean, isStandardList?: boolean, orderTitle?: 'asc' | 'desc', orderCritical?: 'asc' | 'desc', orderIsStandardList?: 'asc' | 'desc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20024>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowGroupCollection(page, itemsPerPage, userGroup, userGroup2, userGroupType, userGroupType2, title, workflowType, workflowType2, critical, isStandardList, orderTitle, orderCritical, orderIsStandardList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a WorkflowGroup resource.
         * @summary Retrieves a WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the WorkflowGroup resource.
         * @summary Updates the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {WorkflowGroupWorkflowGroupWrite} workflowGroupWorkflowGroupWrite The updated WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWorkflowGroupItem(id: string, workflowGroupWorkflowGroupWrite: WorkflowGroupWorkflowGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWorkflowGroupItem(id, workflowGroupWorkflowGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a WorkflowGroup resource.
         * @summary Creates a WorkflowGroup resource.
         * @param {WorkflowGroupJsonldWorkflowGroupWrite} workflowGroupJsonldWorkflowGroupWrite The new WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite: WorkflowGroupJsonldWorkflowGroupWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowGroupApi - factory interface
 * @export
 */
export const WorkflowGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowGroupApiFp(configuration)
    return {
        /**
         * Removes the WorkflowGroup resource.
         * @summary Removes the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowGroupItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkflowGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of WorkflowGroup resources.
         * @summary Retrieves the collection of WorkflowGroup resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {string} [title] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {boolean} [critical] 
         * @param {boolean} [isStandardList] 
         * @param {'asc' | 'desc'} [orderTitle] 
         * @param {'asc' | 'desc'} [orderCritical] 
         * @param {'asc' | 'desc'} [orderIsStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, userGroupType?: string, userGroupType2?: Array<string>, title?: string, workflowType?: string, workflowType2?: Array<string>, critical?: boolean, isStandardList?: boolean, orderTitle?: 'asc' | 'desc', orderCritical?: 'asc' | 'desc', orderIsStandardList?: 'asc' | 'desc', options?: any): AxiosPromise<InlineResponse20024> {
            return localVarFp.getWorkflowGroupCollection(page, itemsPerPage, userGroup, userGroup2, userGroupType, userGroupType2, title, workflowType, workflowType2, critical, isStandardList, orderTitle, orderCritical, orderIsStandardList, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a WorkflowGroup resource.
         * @summary Retrieves a WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowGroupItem(id: string, options?: any): AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead> {
            return localVarFp.getWorkflowGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the WorkflowGroup resource.
         * @summary Updates the WorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {WorkflowGroupWorkflowGroupWrite} workflowGroupWorkflowGroupWrite The updated WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowGroupItem(id: string, workflowGroupWorkflowGroupWrite: WorkflowGroupWorkflowGroupWrite, options?: any): AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead> {
            return localVarFp.patchWorkflowGroupItem(id, workflowGroupWorkflowGroupWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a WorkflowGroup resource.
         * @summary Creates a WorkflowGroup resource.
         * @param {WorkflowGroupJsonldWorkflowGroupWrite} workflowGroupJsonldWorkflowGroupWrite The new WorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite: WorkflowGroupJsonldWorkflowGroupWrite, options?: any): AxiosPromise<WorkflowGroupJsonldWorkflowGroupRead> {
            return localVarFp.postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowGroupApi - object-oriented interface
 * @export
 * @class WorkflowGroupApi
 * @extends {BaseAPI}
 */
export class WorkflowGroupApi extends BaseAPI {
    /**
     * Removes the WorkflowGroup resource.
     * @summary Removes the WorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowGroupApi
     */
    public deleteWorkflowGroupItem(id: string, options?: any) {
        return WorkflowGroupApiFp(this.configuration).deleteWorkflowGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of WorkflowGroup resources.
     * @summary Retrieves the collection of WorkflowGroup resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [userGroup] 
     * @param {Array<string>} [userGroup2] 
     * @param {string} [userGroupType] 
     * @param {Array<string>} [userGroupType2] 
     * @param {string} [title] 
     * @param {string} [workflowType] 
     * @param {Array<string>} [workflowType2] 
     * @param {boolean} [critical] 
     * @param {boolean} [isStandardList] 
     * @param {'asc' | 'desc'} [orderTitle] 
     * @param {'asc' | 'desc'} [orderCritical] 
     * @param {'asc' | 'desc'} [orderIsStandardList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowGroupApi
     */
    public getWorkflowGroupCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, userGroupType?: string, userGroupType2?: Array<string>, title?: string, workflowType?: string, workflowType2?: Array<string>, critical?: boolean, isStandardList?: boolean, orderTitle?: 'asc' | 'desc', orderCritical?: 'asc' | 'desc', orderIsStandardList?: 'asc' | 'desc', options?: any) {
        return WorkflowGroupApiFp(this.configuration).getWorkflowGroupCollection(page, itemsPerPage, userGroup, userGroup2, userGroupType, userGroupType2, title, workflowType, workflowType2, critical, isStandardList, orderTitle, orderCritical, orderIsStandardList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a WorkflowGroup resource.
     * @summary Retrieves a WorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowGroupApi
     */
    public getWorkflowGroupItem(id: string, options?: any) {
        return WorkflowGroupApiFp(this.configuration).getWorkflowGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the WorkflowGroup resource.
     * @summary Updates the WorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {WorkflowGroupWorkflowGroupWrite} workflowGroupWorkflowGroupWrite The updated WorkflowGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowGroupApi
     */
    public patchWorkflowGroupItem(id: string, workflowGroupWorkflowGroupWrite: WorkflowGroupWorkflowGroupWrite, options?: any) {
        return WorkflowGroupApiFp(this.configuration).patchWorkflowGroupItem(id, workflowGroupWorkflowGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a WorkflowGroup resource.
     * @summary Creates a WorkflowGroup resource.
     * @param {WorkflowGroupJsonldWorkflowGroupWrite} workflowGroupJsonldWorkflowGroupWrite The new WorkflowGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowGroupApi
     */
    public postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite: WorkflowGroupJsonldWorkflowGroupWrite, options?: any) {
        return WorkflowGroupApiFp(this.configuration).postWorkflowGroupCollection(workflowGroupJsonldWorkflowGroupWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowStepsApi - axios parameter creator
 * @export
 */
export const WorkflowStepsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the WorkflowSteps resource.
         * @summary Removes the WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowStepsItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkflowStepsItem', 'id', id)
            const localVarPath = `/api/workflow_steps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a WorkflowSteps resource.
         * @summary Retrieves a WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowStepsItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowStepsItem', 'id', id)
            const localVarPath = `/api/workflow_steps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a WorkflowSteps resource.
         * @summary Creates a WorkflowSteps resource.
         * @param {WorkflowStepsJsonldWorkflowStepsWrite} workflowStepsJsonldWorkflowStepsWrite The new WorkflowSteps resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowStepsCollection: async (workflowStepsJsonldWorkflowStepsWrite: WorkflowStepsJsonldWorkflowStepsWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowStepsJsonldWorkflowStepsWrite' is not null or undefined
            assertParamExists('postWorkflowStepsCollection', 'workflowStepsJsonldWorkflowStepsWrite', workflowStepsJsonldWorkflowStepsWrite)
            const localVarPath = `/api/workflow_steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowStepsJsonldWorkflowStepsWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowStepsApi - functional programming interface
 * @export
 */
export const WorkflowStepsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowStepsApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the WorkflowSteps resource.
         * @summary Removes the WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkflowStepsItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkflowStepsItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a WorkflowSteps resource.
         * @summary Retrieves a WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowStepsItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowStepsJsonldWorkflowStepsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowStepsItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a WorkflowSteps resource.
         * @summary Creates a WorkflowSteps resource.
         * @param {WorkflowStepsJsonldWorkflowStepsWrite} workflowStepsJsonldWorkflowStepsWrite The new WorkflowSteps resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite: WorkflowStepsJsonldWorkflowStepsWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowStepsJsonldWorkflowStepsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowStepsApi - factory interface
 * @export
 */
export const WorkflowStepsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowStepsApiFp(configuration)
    return {
        /**
         * Removes the WorkflowSteps resource.
         * @summary Removes the WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowStepsItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkflowStepsItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a WorkflowSteps resource.
         * @summary Retrieves a WorkflowSteps resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowStepsItem(id: string, options?: any): AxiosPromise<WorkflowStepsJsonldWorkflowStepsRead> {
            return localVarFp.getWorkflowStepsItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a WorkflowSteps resource.
         * @summary Creates a WorkflowSteps resource.
         * @param {WorkflowStepsJsonldWorkflowStepsWrite} workflowStepsJsonldWorkflowStepsWrite The new WorkflowSteps resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite: WorkflowStepsJsonldWorkflowStepsWrite, options?: any): AxiosPromise<WorkflowStepsJsonldWorkflowStepsRead> {
            return localVarFp.postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowStepsApi - object-oriented interface
 * @export
 * @class WorkflowStepsApi
 * @extends {BaseAPI}
 */
export class WorkflowStepsApi extends BaseAPI {
    /**
     * Removes the WorkflowSteps resource.
     * @summary Removes the WorkflowSteps resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowStepsApi
     */
    public deleteWorkflowStepsItem(id: string, options?: any) {
        return WorkflowStepsApiFp(this.configuration).deleteWorkflowStepsItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a WorkflowSteps resource.
     * @summary Retrieves a WorkflowSteps resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowStepsApi
     */
    public getWorkflowStepsItem(id: string, options?: any) {
        return WorkflowStepsApiFp(this.configuration).getWorkflowStepsItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a WorkflowSteps resource.
     * @summary Creates a WorkflowSteps resource.
     * @param {WorkflowStepsJsonldWorkflowStepsWrite} workflowStepsJsonldWorkflowStepsWrite The new WorkflowSteps resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowStepsApi
     */
    public postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite: WorkflowStepsJsonldWorkflowStepsWrite, options?: any) {
        return WorkflowStepsApiFp(this.configuration).postWorkflowStepsCollection(workflowStepsJsonldWorkflowStepsWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowTemplateApi - axios parameter creator
 * @export
 */
export const WorkflowTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the WorkflowTemplate resource.
         * @summary Removes the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowTemplateItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkflowTemplateItem', 'id', id)
            const localVarPath = `/api/workflow_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of WorkflowTemplate resources.
         * @summary Retrieves the collection of WorkflowTemplate resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {number} [workflowTemplateDocumentsTemplateSpId] 
         * @param {Array<number>} [workflowTemplateDocumentsTemplateSpId2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [isStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateCollection: async (page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, workflowType?: string, workflowType2?: Array<string>, workflowTemplateDocumentsTemplateSpId?: number, workflowTemplateDocumentsTemplateSpId2?: Array<number>, userGroupType?: string, userGroupType2?: Array<string>, isDefault?: boolean, isStandardList?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workflow_templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (userGroup !== undefined) {
                localVarQueryParameter['userGroup'] = userGroup;
            }

            if (userGroup2) {
                localVarQueryParameter['userGroup[]'] = userGroup2;
            }

            if (workflowType !== undefined) {
                localVarQueryParameter['workflowType'] = workflowType;
            }

            if (workflowType2) {
                localVarQueryParameter['workflowType[]'] = workflowType2;
            }

            if (workflowTemplateDocumentsTemplateSpId !== undefined) {
                localVarQueryParameter['workflowTemplateDocuments.templateSpId'] = workflowTemplateDocumentsTemplateSpId;
            }

            if (workflowTemplateDocumentsTemplateSpId2) {
                localVarQueryParameter['workflowTemplateDocuments.templateSpId[]'] = workflowTemplateDocumentsTemplateSpId2;
            }

            if (userGroupType !== undefined) {
                localVarQueryParameter['userGroupType'] = userGroupType;
            }

            if (userGroupType2) {
                localVarQueryParameter['userGroupType[]'] = userGroupType2;
            }

            if (isDefault !== undefined) {
                localVarQueryParameter['isDefault'] = isDefault;
            }

            if (isStandardList !== undefined) {
                localVarQueryParameter['isStandardList'] = isStandardList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a WorkflowTemplate resource.
         * @summary Retrieves a WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowTemplateItem', 'id', id)
            const localVarPath = `/api/workflow_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the WorkflowTemplate resource.
         * @summary Updates the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {WorkflowTemplateWorkflowTemplateWrite} workflowTemplateWorkflowTemplateWrite The updated WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowTemplateItem: async (id: string, workflowTemplateWorkflowTemplateWrite: WorkflowTemplateWorkflowTemplateWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchWorkflowTemplateItem', 'id', id)
            // verify required parameter 'workflowTemplateWorkflowTemplateWrite' is not null or undefined
            assertParamExists('patchWorkflowTemplateItem', 'workflowTemplateWorkflowTemplateWrite', workflowTemplateWorkflowTemplateWrite)
            const localVarPath = `/api/workflow_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowTemplateWorkflowTemplateWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a WorkflowTemplate resource.
         * @summary Creates a WorkflowTemplate resource.
         * @param {WorkflowTemplateJsonldWorkflowTemplateWrite} workflowTemplateJsonldWorkflowTemplateWrite The new WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowTemplateCollection: async (workflowTemplateJsonldWorkflowTemplateWrite: WorkflowTemplateJsonldWorkflowTemplateWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowTemplateJsonldWorkflowTemplateWrite' is not null or undefined
            assertParamExists('postWorkflowTemplateCollection', 'workflowTemplateJsonldWorkflowTemplateWrite', workflowTemplateJsonldWorkflowTemplateWrite)
            const localVarPath = `/api/workflow_templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowTemplateJsonldWorkflowTemplateWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowTemplateApi - functional programming interface
 * @export
 */
export const WorkflowTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the WorkflowTemplate resource.
         * @summary Removes the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkflowTemplateItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkflowTemplateItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the collection of WorkflowTemplate resources.
         * @summary Retrieves the collection of WorkflowTemplate resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {number} [workflowTemplateDocumentsTemplateSpId] 
         * @param {Array<number>} [workflowTemplateDocumentsTemplateSpId2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [isStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTemplateCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, workflowType?: string, workflowType2?: Array<string>, workflowTemplateDocumentsTemplateSpId?: number, workflowTemplateDocumentsTemplateSpId2?: Array<number>, userGroupType?: string, userGroupType2?: Array<string>, isDefault?: boolean, isStandardList?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTemplateCollection(page, itemsPerPage, userGroup, userGroup2, workflowType, workflowType2, workflowTemplateDocumentsTemplateSpId, workflowTemplateDocumentsTemplateSpId2, userGroupType, userGroupType2, isDefault, isStandardList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a WorkflowTemplate resource.
         * @summary Retrieves a WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTemplateItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTemplateItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the WorkflowTemplate resource.
         * @summary Updates the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {WorkflowTemplateWorkflowTemplateWrite} workflowTemplateWorkflowTemplateWrite The updated WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWorkflowTemplateItem(id: string, workflowTemplateWorkflowTemplateWrite: WorkflowTemplateWorkflowTemplateWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWorkflowTemplateItem(id, workflowTemplateWorkflowTemplateWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a WorkflowTemplate resource.
         * @summary Creates a WorkflowTemplate resource.
         * @param {WorkflowTemplateJsonldWorkflowTemplateWrite} workflowTemplateJsonldWorkflowTemplateWrite The new WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite: WorkflowTemplateJsonldWorkflowTemplateWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowTemplateApi - factory interface
 * @export
 */
export const WorkflowTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowTemplateApiFp(configuration)
    return {
        /**
         * Removes the WorkflowTemplate resource.
         * @summary Removes the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowTemplateItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkflowTemplateItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of WorkflowTemplate resources.
         * @summary Retrieves the collection of WorkflowTemplate resources.
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {string} [userGroup] 
         * @param {Array<string>} [userGroup2] 
         * @param {string} [workflowType] 
         * @param {Array<string>} [workflowType2] 
         * @param {number} [workflowTemplateDocumentsTemplateSpId] 
         * @param {Array<number>} [workflowTemplateDocumentsTemplateSpId2] 
         * @param {string} [userGroupType] 
         * @param {Array<string>} [userGroupType2] 
         * @param {boolean} [isDefault] 
         * @param {boolean} [isStandardList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, workflowType?: string, workflowType2?: Array<string>, workflowTemplateDocumentsTemplateSpId?: number, workflowTemplateDocumentsTemplateSpId2?: Array<number>, userGroupType?: string, userGroupType2?: Array<string>, isDefault?: boolean, isStandardList?: boolean, options?: any): AxiosPromise<InlineResponse20025> {
            return localVarFp.getWorkflowTemplateCollection(page, itemsPerPage, userGroup, userGroup2, workflowType, workflowType2, workflowTemplateDocumentsTemplateSpId, workflowTemplateDocumentsTemplateSpId2, userGroupType, userGroupType2, isDefault, isStandardList, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a WorkflowTemplate resource.
         * @summary Retrieves a WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateItem(id: string, options?: any): AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead> {
            return localVarFp.getWorkflowTemplateItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the WorkflowTemplate resource.
         * @summary Updates the WorkflowTemplate resource.
         * @param {string} id Resource identifier
         * @param {WorkflowTemplateWorkflowTemplateWrite} workflowTemplateWorkflowTemplateWrite The updated WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowTemplateItem(id: string, workflowTemplateWorkflowTemplateWrite: WorkflowTemplateWorkflowTemplateWrite, options?: any): AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead> {
            return localVarFp.patchWorkflowTemplateItem(id, workflowTemplateWorkflowTemplateWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a WorkflowTemplate resource.
         * @summary Creates a WorkflowTemplate resource.
         * @param {WorkflowTemplateJsonldWorkflowTemplateWrite} workflowTemplateJsonldWorkflowTemplateWrite The new WorkflowTemplate resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite: WorkflowTemplateJsonldWorkflowTemplateWrite, options?: any): AxiosPromise<WorkflowTemplateJsonldWorkflowTemplateRead> {
            return localVarFp.postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowTemplateApi - object-oriented interface
 * @export
 * @class WorkflowTemplateApi
 * @extends {BaseAPI}
 */
export class WorkflowTemplateApi extends BaseAPI {
    /**
     * Removes the WorkflowTemplate resource.
     * @summary Removes the WorkflowTemplate resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateApi
     */
    public deleteWorkflowTemplateItem(id: string, options?: any) {
        return WorkflowTemplateApiFp(this.configuration).deleteWorkflowTemplateItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of WorkflowTemplate resources.
     * @summary Retrieves the collection of WorkflowTemplate resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [userGroup] 
     * @param {Array<string>} [userGroup2] 
     * @param {string} [workflowType] 
     * @param {Array<string>} [workflowType2] 
     * @param {number} [workflowTemplateDocumentsTemplateSpId] 
     * @param {Array<number>} [workflowTemplateDocumentsTemplateSpId2] 
     * @param {string} [userGroupType] 
     * @param {Array<string>} [userGroupType2] 
     * @param {boolean} [isDefault] 
     * @param {boolean} [isStandardList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateApi
     */
    public getWorkflowTemplateCollection(page?: number, itemsPerPage?: number, userGroup?: string, userGroup2?: Array<string>, workflowType?: string, workflowType2?: Array<string>, workflowTemplateDocumentsTemplateSpId?: number, workflowTemplateDocumentsTemplateSpId2?: Array<number>, userGroupType?: string, userGroupType2?: Array<string>, isDefault?: boolean, isStandardList?: boolean, options?: any) {
        return WorkflowTemplateApiFp(this.configuration).getWorkflowTemplateCollection(page, itemsPerPage, userGroup, userGroup2, workflowType, workflowType2, workflowTemplateDocumentsTemplateSpId, workflowTemplateDocumentsTemplateSpId2, userGroupType, userGroupType2, isDefault, isStandardList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a WorkflowTemplate resource.
     * @summary Retrieves a WorkflowTemplate resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateApi
     */
    public getWorkflowTemplateItem(id: string, options?: any) {
        return WorkflowTemplateApiFp(this.configuration).getWorkflowTemplateItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the WorkflowTemplate resource.
     * @summary Updates the WorkflowTemplate resource.
     * @param {string} id Resource identifier
     * @param {WorkflowTemplateWorkflowTemplateWrite} workflowTemplateWorkflowTemplateWrite The updated WorkflowTemplate resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateApi
     */
    public patchWorkflowTemplateItem(id: string, workflowTemplateWorkflowTemplateWrite: WorkflowTemplateWorkflowTemplateWrite, options?: any) {
        return WorkflowTemplateApiFp(this.configuration).patchWorkflowTemplateItem(id, workflowTemplateWorkflowTemplateWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a WorkflowTemplate resource.
     * @summary Creates a WorkflowTemplate resource.
     * @param {WorkflowTemplateJsonldWorkflowTemplateWrite} workflowTemplateJsonldWorkflowTemplateWrite The new WorkflowTemplate resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateApi
     */
    public postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite: WorkflowTemplateJsonldWorkflowTemplateWrite, options?: any) {
        return WorkflowTemplateApiFp(this.configuration).postWorkflowTemplateCollection(workflowTemplateJsonldWorkflowTemplateWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowTemplateWorkflowGroupApi - axios parameter creator
 * @export
 */
export const WorkflowTemplateWorkflowGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the WorkflowTemplateWorkflowGroup resource.
         * @summary Removes the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowTemplateWorkflowGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWorkflowTemplateWorkflowGroupItem', 'id', id)
            const localVarPath = `/api/workflow_template_workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @summary Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateWorkflowGroupItem: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowTemplateWorkflowGroupItem', 'id', id)
            const localVarPath = `/api/workflow_template_workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the WorkflowTemplateWorkflowGroup resource.
         * @summary Updates the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowTemplateWorkflowGroupItem: async (id: string, body: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchWorkflowTemplateWorkflowGroupItem', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchWorkflowTemplateWorkflowGroupItem', 'body', body)
            const localVarPath = `/api/workflow_template_workflow_groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a WorkflowTemplateWorkflowGroup resource.
         * @summary Creates a WorkflowTemplateWorkflowGroup resource.
         * @param {WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite} workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite The new WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowTemplateWorkflowGroupCollection: async (workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite: WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite' is not null or undefined
            assertParamExists('postWorkflowTemplateWorkflowGroupCollection', 'workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite', workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite)
            const localVarPath = `/api/workflow_template_workflow_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Api_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication Impersonate required
            await setApiKeyToObject(localVarHeaderParameter, "HTTP-X-SWITCH-USER", configuration)

            // authentication MS_Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "MS-Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowTemplateWorkflowGroupApi - functional programming interface
 * @export
 */
export const WorkflowTemplateWorkflowGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowTemplateWorkflowGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the WorkflowTemplateWorkflowGroup resource.
         * @summary Removes the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkflowTemplateWorkflowGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkflowTemplateWorkflowGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @summary Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTemplateWorkflowGroupItem(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTemplateWorkflowGroupItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the WorkflowTemplateWorkflowGroup resource.
         * @summary Updates the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWorkflowTemplateWorkflowGroupItem(id: string, body: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWorkflowTemplateWorkflowGroupItem(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a WorkflowTemplateWorkflowGroup resource.
         * @summary Creates a WorkflowTemplateWorkflowGroup resource.
         * @param {WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite} workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite The new WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite: WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowTemplateWorkflowGroupApi - factory interface
 * @export
 */
export const WorkflowTemplateWorkflowGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowTemplateWorkflowGroupApiFp(configuration)
    return {
        /**
         * Removes the WorkflowTemplateWorkflowGroup resource.
         * @summary Removes the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkflowTemplateWorkflowGroupItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkflowTemplateWorkflowGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @summary Retrieves a WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTemplateWorkflowGroupItem(id: string, options?: any): AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead> {
            return localVarFp.getWorkflowTemplateWorkflowGroupItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the WorkflowTemplateWorkflowGroup resource.
         * @summary Updates the WorkflowTemplateWorkflowGroup resource.
         * @param {string} id Resource identifier
         * @param {object} body The updated WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkflowTemplateWorkflowGroupItem(id: string, body: object, options?: any): AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead> {
            return localVarFp.patchWorkflowTemplateWorkflowGroupItem(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a WorkflowTemplateWorkflowGroup resource.
         * @summary Creates a WorkflowTemplateWorkflowGroup resource.
         * @param {WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite} workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite The new WorkflowTemplateWorkflowGroup resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite: WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options?: any): AxiosPromise<WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsRead> {
            return localVarFp.postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowTemplateWorkflowGroupApi - object-oriented interface
 * @export
 * @class WorkflowTemplateWorkflowGroupApi
 * @extends {BaseAPI}
 */
export class WorkflowTemplateWorkflowGroupApi extends BaseAPI {
    /**
     * Removes the WorkflowTemplateWorkflowGroup resource.
     * @summary Removes the WorkflowTemplateWorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateWorkflowGroupApi
     */
    public deleteWorkflowTemplateWorkflowGroupItem(id: string, options?: any) {
        return WorkflowTemplateWorkflowGroupApiFp(this.configuration).deleteWorkflowTemplateWorkflowGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a WorkflowTemplateWorkflowGroup resource.
     * @summary Retrieves a WorkflowTemplateWorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateWorkflowGroupApi
     */
    public getWorkflowTemplateWorkflowGroupItem(id: string, options?: any) {
        return WorkflowTemplateWorkflowGroupApiFp(this.configuration).getWorkflowTemplateWorkflowGroupItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the WorkflowTemplateWorkflowGroup resource.
     * @summary Updates the WorkflowTemplateWorkflowGroup resource.
     * @param {string} id Resource identifier
     * @param {object} body The updated WorkflowTemplateWorkflowGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateWorkflowGroupApi
     */
    public patchWorkflowTemplateWorkflowGroupItem(id: string, body: object, options?: any) {
        return WorkflowTemplateWorkflowGroupApiFp(this.configuration).patchWorkflowTemplateWorkflowGroupItem(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a WorkflowTemplateWorkflowGroup resource.
     * @summary Creates a WorkflowTemplateWorkflowGroup resource.
     * @param {WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite} workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite The new WorkflowTemplateWorkflowGroup resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTemplateWorkflowGroupApi
     */
    public postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite: WorkflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options?: any) {
        return WorkflowTemplateWorkflowGroupApiFp(this.configuration).postWorkflowTemplateWorkflowGroupCollection(workflowTemplateWorkflowGroupJsonldWorkflowTemplateWorkflowGroupsWrite, options).then((request) => request(this.axios, this.basePath));
    }
}


